import { jsx as e, jsxs as C, Fragment as p1 } from "react/jsx-runtime";
import b from "classnames";
import { useState as j, useRef as k, useEffect as X, useCallback as R, useImperativeHandle as X1, useId as C1, useMemo as t1, Children as M2, useSyncExternalStore as S1, useContext as x2, createContext as b2 } from "react";
import { OverlayScrollbarsComponent as H2 } from "overlayscrollbars-react";
const L2 = "Avatar-module__root__J-n1J", Z2 = {
  root: L2
};
function g1({ className: t, ...n }) {
  return /* @__PURE__ */ e("div", { ...n, className: b(Z2.root, t) });
}
function O(t, n, o) {
  return Math.min(o, Math.max(n, t));
}
function T1(t) {
  return O(t, 0, 1);
}
const V1 = (t) => Math.sin(t * Math.PI / 2), j8 = (t) => t <= 0.05 ? t / 0.05 : t >= 0.95 ? 1 - V1((t - 0.95) / 0.05) : 1, B8 = (t) => {
  if (t < 0.5) {
    const n = t / 0.5;
    return 1 - (1 - n) * (1 - n);
  }
  return 1;
}, F8 = (t) => {
  if (t <= 0.5)
    return 0;
  const n = (t - 0.5) / 0.5;
  return -0.015 * Math.abs(Math.sin(n * 3 * Math.PI));
}, V2 = (t) => t < 0.1 ? t / 0.1 : 1 - (Math.max(0, t - 0.7) / 0.3) ** 1.5;
function i1(t, n) {
  return Math.random() * (n - t) + t;
}
const y2 = "BubbleField-module__root__2n-hw", S2 = "BubbleField-module__bubbles__Q4ub7", N2 = "BubbleField-module__bubble__ppda-", y1 = {
  root: y2,
  bubbles: S2,
  bubble: N2
};
function W8({
  bubbleControllerRef: t,
  className: n,
  maxBubbles: o = 200,
  ...r
}) {
  const [l, i] = j([]), u = k(l), a = k(/* @__PURE__ */ new Map()), d = k(null), c = k(null), s = k(0);
  X(() => {
    const { current: m } = c;
    if (!m)
      return;
    function v() {
      s.current = m?.getBoundingClientRect().height || 0;
    }
    v();
    let p = null;
    return typeof ResizeObserver < "u" ? (p = new ResizeObserver(v), p.observe(m), () => {
      p?.disconnect();
    }) : (window.addEventListener("resize", v), () => {
      window.removeEventListener("resize", v);
    });
  }, []), X(() => {
    u.current = l;
  }, [l]);
  const h = R(() => {
    u.current = [], i([]), a.current.clear();
  }, []), f = R(() => {
    if (d.current != null)
      return;
    function m(v) {
      const p = u.current;
      if (p.length === 0) {
        d.current = null;
        return;
      }
      let Z = !1;
      const _ = s.current;
      for (const x of p) {
        const y = a.current.get(x.id);
        if (!y) continue;
        const N = (v - x.startedAt) / x.duration;
        if (N >= 1) {
          Z = !0;
          continue;
        }
        const P = T1(N), T = (1 - x.yPositionEase(P)) * _, z = x.wobbleAmplitude * Math.sin(
          z1 * x.wobbleFrequency * P + x.wogglePhase
        ), B = x.opacityEase(P);
        y.style.setProperty("--Bubble_OffsetX", `${z}px`), y.style.setProperty("--Bubble_OffsetY", `${T}px`);
        const L = -x.offsetYEase(P) * 100;
        y.style.setProperty("--Bubble_LocalOffsetY", `${L}%`), y.style.opacity = `${B}`;
      }
      if (Z) {
        const x = p.filter(
          (y) => v - y.startedAt < y.duration
        );
        u.current = x, i(x);
      }
      d.current = requestAnimationFrame(m);
    }
    d.current = requestAnimationFrame(m);
  }, []), M = R(
    (m = {}) => {
      const v = {
        id: ++k2,
        startedAt: performance.now(),
        duration: m?.duration ?? i1(3e3, 5e3),
        xPosition: T1(m?.xPosition ?? i1(0.05, 0.95)),
        wobbleAmplitude: m?.wobbleAmplitude ?? i1(6, 16),
        wobbleFrequency: m?.wobbleFrequency ?? i1(0.8, 1.6),
        wogglePhase: m?.wogglePhase ?? i1(0, z1),
        content: m?.content ?? /* @__PURE__ */ e(I2, {}),
        opacityEase: m?.opacityEase ?? V2,
        yPositionEase: m?.yPositionEase ?? V1,
        offsetYEase: m?.offsetYEase ?? V1
      };
      u.current = [...u.current, v], i((p) => {
        const Z = [...p, v];
        return Z.length > o && Z.shift(), Z;
      }), f();
    },
    [f, o]
  );
  return X1(t, () => ({ release: M, clear: h }), [
    M,
    h
  ]), X(
    () => () => {
      d.current != null && cancelAnimationFrame(d.current);
    },
    []
  ), /* @__PURE__ */ e("div", { ...r, className: b(y1.root, n), ref: c, children: /* @__PURE__ */ e("div", { className: y1.bubbles, children: l.map((m) => /* @__PURE__ */ e(
    R2,
    {
      bubble: m,
      elements: a.current
    },
    m.id
  )) }) });
}
let k2 = 0;
function R2({ bubble: t, elements: n }) {
  const { id: o } = t, r = R(
    (l) => {
      l ? n.set(o, l) : n.delete(o);
    },
    [o, n]
  );
  return /* @__PURE__ */ e(
    "div",
    {
      className: y1.bubble,
      ref: r,
      style: {
        left: `${t.xPosition * 100}%`
      },
      children: t.content
    },
    t.id
  );
}
function I2() {
  return /* @__PURE__ */ e(
    "svg",
    {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      "aria-hidden": !0,
      "aria-label": "Heart",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          fill: "currentColor",
          d: "M12 21s-7.3-4.35-9.42-8.14C1.16 10.47 2.4 6.9 5.76 6.2c1.86-.38 3.5.41 4.24 1.9.74-1.49 2.38-2.28 4.24-1.9 3.36.7 4.6 4.27 3.18 6.66C19.3 16.65 12 21 12 21z"
        }
      )
    }
  );
}
const z1 = Math.PI * 2, _2 = "Button-module__root__x3BBt", P2 = "Button-module__active__nJsGe", T2 = "Button-module__primary__ypFor", z2 = "Button-module__secondary__74qS3", E2 = "Button-module__destructive__9-DNW", D2 = "Button-module__pill__NKcBA", O2 = "Button-module__glass__jHz9h", d1 = {
  root: _2,
  active: P2,
  primary: T2,
  secondary: z2,
  destructive: E2,
  pill: D2,
  glass: O2
};
function W({
  tag: t = "button",
  kind: n,
  active: o = !1,
  ...r
}) {
  const l = b(
    d1.root,
    r.className,
    typeof n == "string" ? d1[n] : n ? n.map((u) => d1[u]) : void 0,
    o && d1.active
  );
  if (t === "button") {
    const { type: u = "button", ...a } = r;
    return /* @__PURE__ */ e("button", { ...a, className: l, type: u });
  }
  const { ...i } = r;
  return /* @__PURE__ */ e("a", { ...i, className: l });
}
function v1({
  hashable: t,
  size: n = 40,
  gridSize: o = 5,
  width: r,
  height: l,
  ...i
}) {
  const u = R(
    (a) => {
      if (!a)
        return null;
      const d = a.getContext("2d");
      if (!d)
        return;
      const c = j2(t), s = B2(c);
      d.clearRect(0, 0, n, n), d.fillStyle = s.bg, d.fillRect(0, 0, n, n);
      const h = n / o;
      d.fillStyle = s.fg;
      for (let f = 0; f < o; f++)
        for (let M = 0; M < o; M++) {
          const m = f * o + M;
          c >> m % 32 & 1 && d.fillRect(
            M * h,
            f * h,
            h,
            h
          );
        }
    },
    [t, n, o]
  );
  return /* @__PURE__ */ e("canvas", { ...i, ref: u, width: n, height: n });
}
function j2(t) {
  let n = 0;
  for (let o = 0; o < t.length; o++) {
    const r = t.charCodeAt(o);
    n = (n << 5) - n + r, n = n & n;
  }
  return Math.abs(n);
}
function B2(t) {
  const n = t % 360, o = 50 + t % 30, r = 40 + t % 20;
  return {
    bg: `hsl(${n}, ${o}%, ${r}%)`,
    fg: `hsl(${n}, ${o}%, ${r + 30}%)`
  };
}
const F2 = "ChatMessageDisplay-module__root__5kyhx", W2 = "ChatMessageDisplay-module__content__u-2mr", E1 = {
  root: F2,
  content: W2
};
function U8(t) {
  const { authorNickname: n, content: o, className: r, avatar: l } = t, i = l ?? /* @__PURE__ */ e(v1, { hashable: n });
  return /* @__PURE__ */ C("div", { className: b(r, E1.root), children: [
    /* @__PURE__ */ e(g1, { children: i }),
    /* @__PURE__ */ C("div", { className: E1.content, children: [
      /* @__PURE__ */ C("strong", { children: [
        n,
        ":"
      ] }),
      " ",
      o
    ] })
  ] });
}
const U2 = "OverlayChatTextField-module__root__R2Vt8", J2 = "OverlayChatTextField-module__input__wi0Xn", D1 = {
  root: U2,
  input: J2
};
function J8({
  innerRef: t,
  buttons: n,
  className: o,
  value: r = "",
  onValueChange: l,
  placeholder: i,
  onKeyDown: u
}) {
  const [a, d] = j(r);
  X(() => {
    d(r);
  }, [r]);
  const c = k(null), s = R(
    (h) => {
      c.current = h, t && (typeof t == "function" ? t(h) : t.current = h);
    },
    [t]
  );
  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: The following click on a div forwards focus to the input field. We don't want to make it focusable.
    // biome-ignore lint/a11y/useKeyWithClickEvents: The following click on a div forwards focus to the input field. We don't want to make it focusable.
    /* @__PURE__ */ C(
      "div",
      {
        onClick: (h) => {
          if (!c.current || h.target === c.current)
            return;
          const f = h.target.closest("button");
          f && h.currentTarget.contains(f) || c.current.focus();
        },
        className: b(D1.root, o),
        children: [
          /* @__PURE__ */ e(
            "input",
            {
              "data-1p-ignore": !0,
              ref: s,
              className: D1.input,
              value: a,
              onChange: (h) => {
                d(h.target.value), l?.(h.target.value);
              },
              placeholder: i,
              onKeyDown: u
            }
          ),
          n
        ]
      }
    )
  );
}
var x1 = { exports: {} }, O1;
function Y2() {
  return O1 || (O1 = 1, (function(t) {
    var n = Object.prototype.hasOwnProperty, o = "~";
    function r() {
    }
    Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (o = !1));
    function l(d, c, s) {
      this.fn = d, this.context = c, this.once = s || !1;
    }
    function i(d, c, s, h, f) {
      if (typeof s != "function")
        throw new TypeError("The listener must be a function");
      var M = new l(s, h || d, f), m = o ? o + c : c;
      return d._events[m] ? d._events[m].fn ? d._events[m] = [d._events[m], M] : d._events[m].push(M) : (d._events[m] = M, d._eventsCount++), d;
    }
    function u(d, c) {
      --d._eventsCount === 0 ? d._events = new r() : delete d._events[c];
    }
    function a() {
      this._events = new r(), this._eventsCount = 0;
    }
    a.prototype.eventNames = function() {
      var c = [], s, h;
      if (this._eventsCount === 0) return c;
      for (h in s = this._events)
        n.call(s, h) && c.push(o ? h.slice(1) : h);
      return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(s)) : c;
    }, a.prototype.listeners = function(c) {
      var s = o ? o + c : c, h = this._events[s];
      if (!h) return [];
      if (h.fn) return [h.fn];
      for (var f = 0, M = h.length, m = new Array(M); f < M; f++)
        m[f] = h[f].fn;
      return m;
    }, a.prototype.listenerCount = function(c) {
      var s = o ? o + c : c, h = this._events[s];
      return h ? h.fn ? 1 : h.length : 0;
    }, a.prototype.emit = function(c, s, h, f, M, m) {
      var v = o ? o + c : c;
      if (!this._events[v]) return !1;
      var p = this._events[v], Z = arguments.length, _, x;
      if (p.fn) {
        switch (p.once && this.removeListener(c, p.fn, void 0, !0), Z) {
          case 1:
            return p.fn.call(p.context), !0;
          case 2:
            return p.fn.call(p.context, s), !0;
          case 3:
            return p.fn.call(p.context, s, h), !0;
          case 4:
            return p.fn.call(p.context, s, h, f), !0;
          case 5:
            return p.fn.call(p.context, s, h, f, M), !0;
          case 6:
            return p.fn.call(p.context, s, h, f, M, m), !0;
        }
        for (x = 1, _ = new Array(Z - 1); x < Z; x++)
          _[x - 1] = arguments[x];
        p.fn.apply(p.context, _);
      } else {
        var y = p.length, N;
        for (x = 0; x < y; x++)
          switch (p[x].once && this.removeListener(c, p[x].fn, void 0, !0), Z) {
            case 1:
              p[x].fn.call(p[x].context);
              break;
            case 2:
              p[x].fn.call(p[x].context, s);
              break;
            case 3:
              p[x].fn.call(p[x].context, s, h);
              break;
            case 4:
              p[x].fn.call(p[x].context, s, h, f);
              break;
            default:
              if (!_) for (N = 1, _ = new Array(Z - 1); N < Z; N++)
                _[N - 1] = arguments[N];
              p[x].fn.apply(p[x].context, _);
          }
      }
      return !0;
    }, a.prototype.on = function(c, s, h) {
      return i(this, c, s, h, !1);
    }, a.prototype.once = function(c, s, h) {
      return i(this, c, s, h, !0);
    }, a.prototype.removeListener = function(c, s, h, f) {
      var M = o ? o + c : c;
      if (!this._events[M]) return this;
      if (!s)
        return u(this, M), this;
      var m = this._events[M];
      if (m.fn)
        m.fn === s && (!f || m.once) && (!h || m.context === h) && u(this, M);
      else {
        for (var v = 0, p = [], Z = m.length; v < Z; v++)
          (m[v].fn !== s || f && !m[v].once || h && m[v].context !== h) && p.push(m[v]);
        p.length ? this._events[M] = p.length === 1 ? p[0] : p : u(this, M);
      }
      return this;
    }, a.prototype.removeAllListeners = function(c) {
      var s;
      return c ? (s = o ? o + c : c, this._events[s] && u(this, s)) : (this._events = new r(), this._eventsCount = 0), this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = o, a.EventEmitter = a, t.exports = a;
  })(x1)), x1.exports;
}
Y2();
const G2 = 2, q1 = {
  zeroDecimals: [
    "BIF",
    "CLP",
    "DJF",
    "GNF",
    "JPY",
    "KMF",
    "KRW",
    "MGA",
    "PYG",
    "RWF",
    "UGX",
    "VND",
    "VUV",
    "XAF",
    "XOF",
    "XPF"
  ],
  minimumPriceUnitAmounts: {
    AED: 500,
    AUD: 200,
    BGN: 200,
    BRL: 500,
    CAD: 200,
    CHF: 100,
    CZK: 2e3,
    DKK: 500,
    EUR: 100,
    GBP: 100,
    GIP: 100,
    HKD: 1e3,
    HUF: 4e4,
    JPY: 200,
    MXN: 2e3,
    MYR: 500,
    NOK: 1e3,
    NZD: 200,
    PLN: 500,
    RON: 500,
    SEK: 1e3,
    SGD: 100,
    THB: 4e3,
    USD: 100
  }
}, N1 = (t) => q1.zeroDecimals.includes(t.toUpperCase()) ? 0 : G2, K2 = (t) => {
  const r = q1.minimumPriceUnitAmounts[t.toUpperCase()];
  if (r === void 0)
    throw new Error(`Currency ${t} not supported`);
  return {
    defaultUnitAmount: r * 5,
    minUnitAmount: r,
    maxUnitAmount: r * 50
  };
}, k1 = (t, n) => {
  const o = 10 ** N1(n);
  return t / o;
}, r1 = (t, n, o) => new Intl.NumberFormat(void 0, {
  style: "currency",
  currency: n,
  ...o
}).format(k1(t, n)), u1 = (t, n) => {
  const o = N1(n);
  return k1(t, n).toFixed(o);
}, A2 = "data:image/png;base64,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", Q2 = "SuperBalloon-module__root__vRuA4", X2 = "SuperBalloon-module__img__SQBF7", j1 = {
  root: Q2,
  img: X2
};
function $1({
  className: t,
  label: n,
  boost: o = 0
}) {
  const r = Math.max(0, Math.min(1, o));
  return /* @__PURE__ */ C("div", { className: b(j1.root, t), children: [
    /* @__PURE__ */ e(
      "img",
      {
        className: j1.img,
        alt: "Super Balloon",
        src: A2,
        width: "72",
        height: "80",
        style: {
          "--SuperBalloon_Scale": `${0.75 + 0.5 * r}`
        }
      }
    ),
    n
  ] });
}
const q2 = "PaidChatMessageDisplay-module__root__JP1zI", $2 = "PaidChatMessageDisplay-module__avatar__x02-h", e5 = "PaidChatMessageDisplay-module__details__cL3mI", t5 = "PaidChatMessageDisplay-module__inner__b8iPq", n5 = "PaidChatMessageDisplay-module__metadata__ZkV8b", o5 = "PaidChatMessageDisplay-module__authorNickname__V2w69", r5 = "PaidChatMessageDisplay-module__amount__S9zJH", i5 = "PaidChatMessageDisplay-module__content__n9KXG", a5 = "PaidChatMessageDisplay-module__artworkContainer__CRyyo", G = {
  root: q2,
  avatar: $2,
  details: e5,
  inner: t5,
  metadata: n5,
  authorNickname: o5,
  amount: r5,
  content: i5,
  artworkContainer: a5
};
function Y8(t) {
  const {
    avatar: n,
    amount: o,
    authorNickname: r,
    className: l,
    content: i,
    currency: u,
    maxAmount: a
  } = t, d = n ?? /* @__PURE__ */ e(v1, { hashable: r }), c = Math.max(0, Math.min(a, o));
  return /* @__PURE__ */ C("div", { className: b(G.root, l), children: [
    /* @__PURE__ */ C("div", { className: G.details, children: [
      /* @__PURE__ */ C("div", { className: G.inner, children: [
        /* @__PURE__ */ e(g1, { className: G.avatar, children: d }),
        /* @__PURE__ */ C("div", { className: G.metadata, children: [
          /* @__PURE__ */ e("div", { className: G.authorNickname, children: r }),
          /* @__PURE__ */ e("div", { className: G.amount, children: r1(c, u) })
        ] })
      ] }),
      /* @__PURE__ */ e("div", { className: G.content, children: i })
    ] }),
    /* @__PURE__ */ e("div", { className: G.artworkContainer, children: /* @__PURE__ */ e($1, { boost: c / a }) })
  ] });
}
const l5 = "PopupContentContainer-module__root__Q-BqD", c5 = {
  root: l5
}, e2 = (t) => /* @__PURE__ */ e("div", { ...t, className: b(c5.root, t.className) }), s5 = "RowsContainer-module__root__EkLFd", C5 = {
  root: s5
}, B1 = (t) => /* @__PURE__ */ e("div", { ...t, className: b(C5.root, t.className) }), d5 = "DeviceSelector-module__root__Jv-Ky", u5 = "DeviceSelector-module__switch-container__y0mYN", h5 = "DeviceSelector-module__title__2xOhf", m5 = "DeviceSelector-module__list-title__V-fVB", p5 = "DeviceSelector-module__separator__WkDOi", g5 = "DeviceSelector-module__devices-list__-PIJM", v5 = "DeviceSelector-module__device__3Xxpr", w5 = "DeviceSelector-module__device-name__PkcP8", f5 = "DeviceSelector-module__icon__oM0qL", M5 = "DeviceSelector-module__error-heading__psHqD", x5 = "DeviceSelector-module__error-message__uaWLh", b5 = "DeviceSelector-module__continue-button__8hrQG", E = {
  root: d5,
  switchContainer: u5,
  title: h5,
  listTitle: m5,
  separator: p5,
  devicesList: g5,
  device: v5,
  deviceName: w5,
  icon: f5,
  errorHeading: M5,
  errorMessage: x5,
  continueButton: b5
}, H5 = "Icon-module__iconWrap__-QMsL", L5 = "Icon-module__x1__M1b-q", Z5 = "Icon-module__x1_25__0uLp0", V5 = "Icon-module__x1_25__0uLp0", y5 = "Icon-module__x1_5__zOvi0", S5 = "Icon-module__x1_5__zOvi0", N5 = "Icon-module__x2__-9N3P", k5 = "Icon-module__x3__hIac9", F1 = {
  iconWrap: H5,
  x1: L5,
  x1_25: Z5,
  x125: V5,
  x1_5: y5,
  x15: S5,
  x2: N5,
  x3: k5
};
function R5({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "12",
      height: "19",
      viewBox: "0 0 12 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "$",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M6 16.2812C5.26562 16.2812 4.53646 16.1719 3.8125 15.9531C3.08854 15.7396 2.46094 15.3854 1.92969 14.8906C1.65885 14.6354 1.41927 14.3203 1.21094 13.9453C1.00781 13.5703 0.90625 13.2005 0.90625 12.8359C0.90625 12.5859 0.989583 12.3828 1.15625 12.2266C1.32292 12.0703 1.54167 11.9922 1.8125 11.9922C2.25 11.9922 2.55729 12.2214 2.73438 12.6797C2.86458 13.1432 3.08594 13.5234 3.39844 13.8203C3.71615 14.112 4.09896 14.3307 4.54688 14.4766C4.99479 14.6172 5.48698 14.6875 6.02344 14.6875C6.4401 14.6875 6.83854 14.6484 7.21875 14.5703C7.60417 14.487 7.94792 14.3594 8.25 14.1875C8.55208 14.0156 8.78906 13.7917 8.96094 13.5156C9.13802 13.2396 9.22656 12.901 9.22656 12.5C9.22656 12.0417 9.11198 11.6719 8.88281 11.3906C8.65365 11.1042 8.33594 10.875 7.92969 10.7031C7.52865 10.5312 7.06771 10.388 6.54688 10.2734L5.03906 9.92969C4.35156 9.76823 3.70833 9.54167 3.10938 9.25C2.51042 8.95833 2.02865 8.57031 1.66406 8.08594C1.29948 7.59635 1.11719 6.98177 1.11719 6.24219C1.11719 5.61198 1.25 5.05729 1.51562 4.57812C1.78125 4.09896 2.14323 3.69792 2.60156 3.375C3.0599 3.04688 3.58073 2.80208 4.16406 2.64062C4.7474 2.47917 5.35677 2.39844 5.99219 2.39844C6.6849 2.39844 7.35156 2.5026 7.99219 2.71094C8.63802 2.91927 9.20312 3.23958 9.6875 3.67188C10.0156 3.94792 10.2917 4.28125 10.5156 4.67188C10.7396 5.0625 10.8516 5.44271 10.8516 5.8125C10.8516 6.0625 10.7682 6.26042 10.6016 6.40625C10.4349 6.54688 10.2292 6.61719 9.98438 6.61719C9.74479 6.61719 9.54688 6.55469 9.39062 6.42969C9.23958 6.30469 9.11719 6.13802 9.02344 5.92969C8.91406 5.61198 8.76562 5.33333 8.57812 5.09375C8.39062 4.85417 8.16667 4.65365 7.90625 4.49219C7.64583 4.33073 7.35677 4.20833 7.03906 4.125C6.72135 4.04167 6.375 4 6 4C5.61979 4 5.25 4.04427 4.89062 4.13281C4.53646 4.22135 4.21875 4.35417 3.9375 4.53125C3.65625 4.70312 3.43229 4.91927 3.26562 5.17969C3.09896 5.4401 3.01562 5.73958 3.01562 6.07812C3.01562 6.48958 3.125 6.83333 3.34375 7.10938C3.56771 7.38542 3.86979 7.61198 4.25 7.78906C4.63542 7.96094 5.07031 8.10417 5.55469 8.21875L7.05469 8.57812C7.60677 8.70833 8.1276 8.86719 8.61719 9.05469C9.10677 9.23698 9.53906 9.47135 9.91406 9.75781C10.2943 10.0391 10.5885 10.3906 10.7969 10.8125C11.0104 11.2292 11.1172 11.7344 11.1172 12.3281C11.1172 12.9844 10.9818 13.5599 10.7109 14.0547C10.4401 14.5443 10.0651 14.9557 9.58594 15.2891C9.11198 15.6224 8.56771 15.8698 7.95312 16.0312C7.33854 16.1979 6.6875 16.2812 6 16.2812ZM5.99219 18.1484C5.85677 18.1484 5.73958 18.099 5.64062 18C5.54688 17.9062 5.5 17.7917 5.5 17.6562V1.0625C5.5 0.932292 5.54688 0.817708 5.64062 0.71875C5.73958 0.619792 5.85677 0.570312 5.99219 0.570312C6.1276 0.570312 6.24219 0.619792 6.33594 0.71875C6.4349 0.817708 6.48438 0.932292 6.48438 1.0625V17.6562C6.48438 17.7917 6.4349 17.9062 6.33594 18C6.24219 18.099 6.1276 18.1484 5.99219 18.1484Z",
          fill: t
        }
      )
    }
  ) });
}
function I5({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "18",
      height: "5",
      fill: "none",
      "aria-label": "…",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          fill: t,
          d: "M2.435 4.43c-.334 0-.636-.08-.906-.238a1.843 1.843 0 0 1-.641-.65 1.722 1.722 0 0 1-.238-.888 1.773 1.773 0 0 1 .879-1.538C1.8.952 2.101.87 2.435.87c.322 0 .618.082.887.246.27.158.484.372.642.642.158.27.237.568.237.896 0 .323-.079.618-.237.888-.158.27-.372.486-.642.65-.27.159-.565.238-.887.238ZM9 4.43c-.328 0-.627-.08-.896-.238a1.919 1.919 0 0 1-.65-.65 1.722 1.722 0 0 1-.238-.888 1.738 1.738 0 0 1 .888-1.538A1.69 1.69 0 0 1 9 .87c.328 0 .624.082.888.246.27.158.483.372.641.642.164.27.246.568.246.896 0 .323-.082.618-.246.888-.158.27-.372.486-.641.65-.264.159-.56.238-.888.238Zm6.565 0a1.739 1.739 0 0 1-1.538-.888 1.722 1.722 0 0 1-.237-.888c0-.328.08-.627.237-.896.159-.27.372-.484.642-.642.27-.164.568-.246.896-.246.329 0 .627.082.897.246.27.158.483.372.642.642.164.27.246.568.246.896 0 .323-.082.618-.247.888a1.738 1.738 0 0 1-1.538.888Z"
        }
      )
    }
  ) });
}
function _5({
  fill: t = "currentColor",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "4",
      height: "15",
      viewBox: "0 0 4 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "…",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M3.16406 13.2578C3.16406 13.5547 3.09375 13.8229 2.95312 14.0625C2.80729 14.3021 2.61458 14.4922 2.375 14.6328C2.13542 14.7734 1.8724 14.8438 1.58594 14.8438C1.29427 14.8438 1.02865 14.7734 0.789062 14.6328C0.549479 14.4922 0.359375 14.3021 0.21875 14.0625C0.0729167 13.8229 0 13.5547 0 13.2578C0 12.9714 0.0729167 12.7083 0.21875 12.4688C0.359375 12.2292 0.549479 12.0391 0.789062 11.8984C1.02865 11.7578 1.29427 11.6875 1.58594 11.6875C1.8724 11.6875 2.13542 11.7578 2.375 11.8984C2.61458 12.0391 2.80729 12.2292 2.95312 12.4688C3.09375 12.7083 3.16406 12.9714 3.16406 13.2578ZM3.16406 7.42188C3.16406 7.71354 3.09375 7.97917 2.95312 8.21875C2.80729 8.45833 2.61458 8.65104 2.375 8.79688C2.13542 8.9375 1.8724 9.00781 1.58594 9.00781C1.29427 9.00781 1.02865 8.9375 0.789062 8.79688C0.549479 8.65104 0.359375 8.45833 0.21875 8.21875C0.0729167 7.97917 0 7.71354 0 7.42188C0 7.13021 0.0729167 6.86719 0.21875 6.63281C0.359375 6.39323 0.549479 6.20312 0.789062 6.0625C1.02865 5.91667 1.29427 5.84375 1.58594 5.84375C1.8724 5.84375 2.13542 5.91667 2.375 6.0625C2.61458 6.20312 2.80729 6.39323 2.95312 6.63281C3.09375 6.86719 3.16406 7.13021 3.16406 7.42188ZM3.16406 1.58594C3.16406 1.8776 3.09375 2.14323 2.95313 2.38281C2.80729 2.6224 2.61458 2.8125 2.375 2.95312C2.13542 3.09375 1.8724 3.16406 1.58594 3.16406C1.29427 3.16406 1.02865 3.09375 0.789063 2.95312C0.549479 2.8125 0.359375 2.6224 0.21875 2.38281C0.0729167 2.14323 0 1.8776 0 1.58594C0 1.29427 0.0729167 1.02865 0.21875 0.789062C0.359375 0.549479 0.549479 0.359375 0.789063 0.21875C1.02865 0.0729167 1.29427 0 1.58594 0C1.8724 0 2.13542 0.0729167 2.375 0.21875C2.61458 0.359375 2.80729 0.549479 2.95313 0.789062C3.09375 1.02865 3.16406 1.29427 3.16406 1.58594Z",
          fill: t
        }
      )
    }
  ) });
}
function P5({
  fill: t = "currentColor",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "18",
      height: "17",
      viewBox: "0 0 18 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Emojis",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M8.99219 16.4297C7.8776 16.4297 6.83333 16.2188 5.85938 15.7969C4.88542 15.3802 4.02865 14.8021 3.28906 14.0625C2.54948 13.3281 1.96875 12.474 1.54688 11.5C1.13021 10.5208 0.921875 9.47396 0.921875 8.35938C0.921875 7.24479 1.13021 6.20052 1.54688 5.22656C1.96875 4.2474 2.54948 3.38802 3.28906 2.64844C4.02865 1.90885 4.88542 1.33073 5.85938 0.914062C6.83333 0.497396 7.8776 0.289062 8.99219 0.289062C10.1068 0.289062 11.151 0.497396 12.125 0.914062C13.1042 1.33073 13.9635 1.90885 14.7031 2.64844C15.4427 3.38802 16.0208 4.2474 16.4375 5.22656C16.8594 6.20052 17.0703 7.24479 17.0703 8.35938C17.0703 9.47396 16.8594 10.5208 16.4375 11.5C16.0208 12.474 15.4427 13.3281 14.7031 14.0625C13.9635 14.8021 13.1042 15.3802 12.125 15.7969C11.151 16.2188 10.1068 16.4297 8.99219 16.4297ZM8.99219 14.8359C9.88802 14.8359 10.7266 14.6667 11.5078 14.3281C12.2891 13.9948 12.9766 13.5312 13.5703 12.9375C14.1693 12.3438 14.6354 11.6562 14.9688 10.875C15.3021 10.0938 15.4688 9.25521 15.4688 8.35938C15.4688 7.46354 15.3021 6.625 14.9688 5.84375C14.6354 5.05729 14.1693 4.36979 13.5703 3.78125C12.9766 3.1875 12.2891 2.72396 11.5078 2.39062C10.7266 2.05208 9.88802 1.88281 8.99219 1.88281C8.10156 1.88281 7.26302 2.05208 6.47656 2.39062C5.69531 2.72396 5.00781 3.1875 4.41406 3.78125C3.82031 4.36979 3.35417 5.05729 3.01562 5.84375C2.68229 6.625 2.51562 7.46354 2.51562 8.35938C2.51562 9.25521 2.68229 10.0938 3.01562 10.875C3.35417 11.6562 3.82031 12.3438 4.41406 12.9375C5.00781 13.5312 5.69531 13.9948 6.47656 14.3281C7.26302 14.6667 8.10156 14.8359 8.99219 14.8359ZM8.98438 12.2031C8.44271 12.2031 7.96354 12.1068 7.54688 11.9141C7.13542 11.7161 6.8151 11.4896 6.58594 11.2344C6.36198 10.9792 6.25 10.7656 6.25 10.5938C6.25 10.5 6.28646 10.4349 6.35938 10.3984C6.4375 10.3568 6.52083 10.3568 6.60938 10.3984C6.89583 10.5495 7.22135 10.6953 7.58594 10.8359C7.95052 10.9766 8.41667 11.0469 8.98438 11.0469C9.55208 11.0469 10.0182 10.9766 10.3828 10.8359C10.7526 10.6953 11.0781 10.5495 11.3594 10.3984C11.4479 10.3568 11.5312 10.3568 11.6094 10.3984C11.6875 10.4349 11.7266 10.5 11.7266 10.5938C11.7266 10.7656 11.612 10.9792 11.3828 11.2344C11.1536 11.4896 10.8333 11.7161 10.4219 11.9141C10.0104 12.1068 9.53125 12.2031 8.98438 12.2031ZM6.67969 7.65625C6.4349 7.65625 6.22135 7.55729 6.03906 7.35938C5.86198 7.16146 5.77344 6.90625 5.77344 6.59375C5.77344 6.28646 5.86198 6.03385 6.03906 5.83594C6.22135 5.63281 6.4349 5.53125 6.67969 5.53125C6.92448 5.53125 7.14062 5.63281 7.32812 5.83594C7.51562 6.03385 7.60938 6.28646 7.60938 6.59375C7.60938 6.90625 7.51562 7.16146 7.32812 7.35938C7.14062 7.55729 6.92448 7.65625 6.67969 7.65625ZM11.2891 7.65625C11.0443 7.65625 10.8307 7.55729 10.6484 7.35938C10.4714 7.16146 10.3828 6.90625 10.3828 6.59375C10.3828 6.28646 10.4714 6.03385 10.6484 5.83594C10.8307 5.63281 11.0443 5.53125 11.2891 5.53125C11.5339 5.53125 11.75 5.63281 11.9375 5.83594C12.125 6.03385 12.2188 6.28646 12.2188 6.59375C12.2188 6.90625 12.125 7.16146 11.9375 7.35938C11.75 7.55729 11.5339 7.65625 11.2891 7.65625Z",
          fill: t
        }
      )
    }
  ) });
}
function T5({
  fill: t = "#DE350B",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "14",
      height: "15",
      viewBox: "0 0 14 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "!",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M7 14.0371C6.03841 14.0371 5.13607 13.8548 4.29297 13.4902C3.44987 13.1302 2.70931 12.6312 2.07129 11.9932C1.43327 11.3506 0.931966 10.61 0.567383 9.77148C0.207357 8.92839 0.0273438 8.02604 0.0273438 7.06445C0.0273438 6.10286 0.207357 5.20052 0.567383 4.35742C0.931966 3.51432 1.43327 2.77376 2.07129 2.13574C2.70931 1.49772 3.44987 0.998698 4.29297 0.638672C5.13607 0.274089 6.03841 0.0917969 7 0.0917969C7.96159 0.0917969 8.86393 0.274089 9.70703 0.638672C10.5501 0.998698 11.2907 1.49772 11.9287 2.13574C12.5667 2.77376 13.0658 3.51432 13.4258 4.35742C13.7904 5.20052 13.9727 6.10286 13.9727 7.06445C13.9727 8.02604 13.7904 8.92839 13.4258 9.77148C13.0658 10.61 12.5667 11.3506 11.9287 11.9932C11.2907 12.6312 10.5501 13.1302 9.70703 13.4902C8.86393 13.8548 7.96159 14.0371 7 14.0371ZM7 8.33594C7.35547 8.33594 7.53548 8.14909 7.54004 7.77539L7.64258 4.05664C7.64714 3.87891 7.58561 3.73079 7.45801 3.6123C7.33496 3.48926 7.18001 3.42773 6.99316 3.42773C6.80176 3.42773 6.64453 3.48698 6.52148 3.60547C6.40299 3.72396 6.34603 3.87207 6.35059 4.0498L6.43945 7.77539C6.44857 8.14909 6.63542 8.33594 7 8.33594ZM7 10.626C7.20508 10.626 7.38281 10.5553 7.5332 10.4141C7.68815 10.2728 7.76562 10.0996 7.76562 9.89453C7.76562 9.68945 7.68815 9.51628 7.5332 9.375C7.38281 9.22917 7.20508 9.15625 7 9.15625C6.79036 9.15625 6.61035 9.22917 6.45996 9.375C6.30957 9.52083 6.23438 9.69401 6.23438 9.89453C6.23438 10.0996 6.30957 10.2728 6.45996 10.4141C6.61491 10.5553 6.79492 10.626 7 10.626Z",
          fill: t
        }
      )
    }
  ) });
}
function m1({
  fill: t = "#FF4015",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ C(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "!",
      role: "img",
      children: [
        /* @__PURE__ */ e("circle", { cx: "8.58339", cy: "9.4872", r: "5.87294", fill: "white" }),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M9 18C7.75882 18 6.59412 17.7647 5.50588 17.2941C4.41765 16.8294 3.46177 16.1853 2.63824 15.3618C1.81471 14.5324 1.16765 13.5765 0.697059 12.4941C0.232353 11.4059 0 10.2412 0 9C0 7.75882 0.232353 6.59412 0.697059 5.50588C1.16765 4.41765 1.81471 3.46177 2.63824 2.63824C3.46177 1.81471 4.41765 1.17059 5.50588 0.705882C6.59412 0.235294 7.75882 0 9 0C10.2412 0 11.4059 0.235294 12.4941 0.705882C13.5824 1.17059 14.5382 1.81471 15.3618 2.63824C16.1853 3.46177 16.8294 4.41765 17.2941 5.50588C17.7647 6.59412 18 7.75882 18 9C18 10.2412 17.7647 11.4059 17.2941 12.4941C16.8294 13.5765 16.1853 14.5324 15.3618 15.3618C14.5382 16.1853 13.5824 16.8294 12.4941 17.2941C11.4059 17.7647 10.2412 18 9 18ZM9 10.6412C9.45883 10.6412 9.69118 10.4 9.69706 9.91765L9.82941 5.11765C9.8353 4.88824 9.75588 4.69706 9.59118 4.54412C9.43235 4.38529 9.23235 4.30588 8.99118 4.30588C8.74412 4.30588 8.54118 4.38235 8.38235 4.53529C8.22941 4.68824 8.15588 4.87941 8.16177 5.10882L8.27647 9.91765C8.28824 10.4 8.52941 10.6412 9 10.6412ZM9 13.5971C9.26471 13.5971 9.49412 13.5059 9.68824 13.3235C9.88824 13.1412 9.98824 12.9176 9.98824 12.6529C9.98824 12.3882 9.88824 12.1647 9.68824 11.9824C9.49412 11.7941 9.26471 11.7 9 11.7C8.72941 11.7 8.49706 11.7941 8.30294 11.9824C8.10882 12.1706 8.01177 12.3941 8.01177 12.6529C8.01177 12.9176 8.10882 13.1412 8.30294 13.3235C8.50294 13.5059 8.7353 13.5971 9 13.5971Z",
            fill: t
          }
        )
      ]
    }
  ) });
}
function z5({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ C(
    "svg",
    {
      width: "18",
      height: "16",
      viewBox: "0 0 18 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e("title", { children: "Screen" }),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M1.83105 12.9182C1.25977 12.9182 0.810547 12.7571 0.483398 12.4348C0.161133 12.1077 0 11.656 0 11.0798V2.26147C0 1.6853 0.161133 1.23608 0.483398 0.913818C0.810547 0.591553 1.25977 0.43042 1.83105 0.43042H15.9521C16.5234 0.43042 16.9702 0.591553 17.2925 0.913818C17.6196 1.23608 17.7832 1.6853 17.7832 2.26147V11.0798C17.7832 11.656 17.6196 12.1077 17.2925 12.4348C16.9702 12.7571 16.5234 12.9182 15.9521 12.9182H1.83105ZM1.91162 11.512H15.8716C16.0229 11.512 16.145 11.4656 16.2378 11.3728C16.3306 11.28 16.377 11.158 16.377 11.0066V2.34937C16.377 2.18823 16.3306 2.06372 16.2378 1.97583C16.145 1.88306 16.0229 1.83667 15.8716 1.83667H1.91162C1.76025 1.83667 1.63818 1.88306 1.54541 1.97583C1.45264 2.06372 1.40625 2.18823 1.40625 2.34937V11.0066C1.40625 11.158 1.45264 11.28 1.54541 11.3728C1.63818 11.4656 1.76025 11.512 1.91162 11.512ZM6.50391 14.5881V12.7644H11.2793V14.5881H6.50391ZM6.46729 15.5696C6.28174 15.5696 6.12305 15.5037 5.99121 15.3718C5.86426 15.24 5.80078 15.0837 5.80078 14.9031C5.80078 14.7175 5.86426 14.5588 5.99121 14.427C6.12305 14.3 6.28174 14.2366 6.46729 14.2366H11.3159C11.5015 14.2366 11.6577 14.3 11.7847 14.427C11.9116 14.5588 11.9751 14.7175 11.9751 14.9031C11.9751 15.0837 11.9116 15.24 11.7847 15.3718C11.6577 15.5037 11.5015 15.5696 11.3159 15.5696H6.46729Z",
            fill: t
          }
        )
      ]
    }
  ) });
}
function E5({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ C(
    "svg",
    {
      width: "18",
      height: "14",
      viewBox: "0 0 18 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e("title", { children: "Window" }),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M0 11.4568V2.54321C0 1.75708 0.202637 1.16382 0.60791 0.763428C1.01318 0.363037 1.61133 0.162842 2.40234 0.162842H14.9414C15.7373 0.162842 16.3379 0.363037 16.7432 0.763428C17.1484 1.16382 17.3511 1.75708 17.3511 2.54321V11.4568C17.3511 12.238 17.1484 12.8289 16.7432 13.2292C16.3379 13.6345 15.7373 13.8372 14.9414 13.8372H2.40234C1.61133 13.8372 1.01318 13.6345 0.60791 13.2292C0.202637 12.8289 0 12.238 0 11.4568ZM2.53418 2.74097C2.72461 2.74097 2.88574 2.67261 3.01758 2.53589C3.1543 2.39917 3.22266 2.24048 3.22266 2.05981C3.22266 1.87915 3.1543 1.72046 3.01758 1.58374C2.88574 1.44702 2.72461 1.37866 2.53418 1.37866C2.34863 1.37866 2.1875 1.44702 2.05078 1.58374C1.91895 1.72046 1.85303 1.87915 1.85303 2.05981C1.85303 2.24048 1.91895 2.39917 2.05078 2.53589C2.1875 2.67261 2.34863 2.74097 2.53418 2.74097ZM4.69482 2.74097C4.88525 2.74097 5.04639 2.67505 5.17822 2.54321C5.31494 2.40649 5.3833 2.24536 5.3833 2.05981C5.3833 1.87915 5.31494 1.72046 5.17822 1.58374C5.04639 1.44702 4.88525 1.37866 4.69482 1.37866C4.50439 1.37866 4.34326 1.44702 4.21143 1.58374C4.07959 1.72046 4.01367 1.87915 4.01367 2.05981C4.01367 2.24536 4.07959 2.40649 4.21143 2.54321C4.34326 2.67505 4.50439 2.74097 4.69482 2.74097ZM6.85547 2.74097C7.04102 2.74097 7.19971 2.67505 7.33154 2.54321C7.46826 2.40649 7.53662 2.24536 7.53662 2.05981C7.53662 1.87915 7.46826 1.72046 7.33154 1.58374C7.19971 1.44702 7.04102 1.37866 6.85547 1.37866C6.66504 1.37866 6.50391 1.44702 6.37207 1.58374C6.24023 1.72046 6.17432 1.87915 6.17432 2.05981C6.17432 2.24536 6.24023 2.40649 6.37207 2.54321C6.50391 2.67505 6.66504 2.74097 6.85547 2.74097ZM1.44287 11.3323C1.44287 11.6887 1.53076 11.9548 1.70654 12.1306C1.88721 12.3064 2.14844 12.3943 2.49023 12.3943H14.8608C15.1978 12.3943 15.4565 12.3064 15.6372 12.1306C15.8179 11.9548 15.9082 11.6887 15.9082 11.3323V3.95679H1.44287V11.3323Z",
            fill: t
          }
        )
      ]
    }
  ) });
}
function t2({
  fill: t = "#FF4015",
  svgRef: n,
  size: o = "x1_5",
  ...r
}) {
  return /* @__PURE__ */ e(g, { ...r, size: o, children: /* @__PURE__ */ C(
    "svg",
    {
      ref: n,
      width: "17",
      height: "22",
      viewBox: "0 0 17 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e("title", { children: "Muted microphone" }),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M1.51758 11.1289V9.14648C1.51758 8.94466 1.58919 8.77214 1.73242 8.62891C1.87565 8.48568 2.04818 8.41406 2.25 8.41406C2.45833 8.41406 2.63411 8.48568 2.77734 8.62891C2.92057 8.77214 2.99219 8.94466 2.99219 9.14648V11.0703C2.99219 12.1771 3.22005 13.1471 3.67578 13.9805C4.13151 14.8138 4.77279 15.4616 5.59961 15.9238C6.42643 16.3796 7.39648 16.6074 8.50977 16.6074C9.00456 16.6074 9.47005 16.5586 9.90625 16.4609C10.349 16.3633 10.7591 16.2233 11.1367 16.041L12.1816 17.0957C11.7585 17.3366 11.2995 17.5319 10.8047 17.6816C10.3164 17.8249 9.79557 17.916 9.24219 17.9551V20.2305H12.8652C13.0736 20.2305 13.2493 20.3021 13.3926 20.4453C13.5358 20.5885 13.6074 20.7643 13.6074 20.9727C13.6074 21.1745 13.5358 21.347 13.3926 21.4902C13.2493 21.6335 13.0736 21.7051 12.8652 21.7051H4.14453C3.9362 21.7051 3.76042 21.6335 3.61719 21.4902C3.47396 21.347 3.40234 21.1745 3.40234 20.9727C3.40234 20.7643 3.47396 20.5885 3.61719 20.4453C3.76042 20.3021 3.9362 20.2305 4.14453 20.2305H7.76758V17.9551C6.52409 17.8509 5.43359 17.5026 4.49609 16.9102C3.55859 16.3112 2.82617 15.5169 2.29883 14.5273C1.77799 13.5378 1.51758 12.4049 1.51758 11.1289ZM13.6758 13.1406C13.9036 12.5026 14.0176 11.8125 14.0176 11.0703V9.14648C14.0176 8.94466 14.0892 8.77214 14.2324 8.62891C14.3757 8.48568 14.5514 8.41406 14.7598 8.41406C14.9616 8.41406 15.1341 8.48568 15.2773 8.62891C15.4206 8.77214 15.4922 8.94466 15.4922 9.14648V11.1289C15.4922 12.2878 15.2676 13.3392 14.8184 14.2832L13.6758 13.1406ZM8.50977 14.5078C7.85872 14.5078 7.28906 14.3581 6.80078 14.0586C6.3125 13.7591 5.93164 13.3457 5.6582 12.8184C5.38477 12.2845 5.24805 11.6693 5.24805 10.9727V10.1523L9.44727 14.3516C9.16732 14.4557 8.85482 14.5078 8.50977 14.5078ZM8.50977 0.904297C7.86523 0.904297 7.30208 1.05078 6.82031 1.34375C6.33854 1.63021 5.95768 2.0306 5.67773 2.54492C5.4043 3.05924 5.26107 3.65495 5.24805 4.33203V4.72266L11.7324 11.207C11.7454 11.1745 11.752 11.1387 11.752 11.0996C11.7585 11.054 11.7617 11.0117 11.7617 10.9727V4.43945C11.7617 3.74284 11.625 3.13086 11.3516 2.60352C11.0846 2.06966 10.7038 1.65299 10.209 1.35352C9.7207 1.05404 9.1543 0.904297 8.50977 0.904297ZM15.6777 18.9219L0.560547 3.82422C0.417318 3.6875 0.345703 3.51172 0.345703 3.29688C0.345703 3.08203 0.417318 2.90299 0.560547 2.75977C0.710286 2.61654 0.889323 2.54492 1.09766 2.54492C1.30599 2.54492 1.48503 2.61654 1.63477 2.75977L16.7422 17.8574C16.8854 18.0007 16.957 18.1764 16.957 18.3848C16.957 18.5931 16.8854 18.7721 16.7422 18.9219C16.599 19.0651 16.4199 19.1367 16.2051 19.1367C15.9967 19.1367 15.821 19.0651 15.6777 18.9219Z",
            fill: t
          }
        )
      ]
    }
  ) });
}
function n2({
  fill: t = "white",
  svgRef: n,
  size: o = "x1_5",
  ...r
}) {
  return /* @__PURE__ */ e(g, { ...r, size: o, children: /* @__PURE__ */ C(
    "svg",
    {
      ref: n,
      width: "15",
      height: "21",
      viewBox: "0 0 15 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e("title", { children: "Microphone" }),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M0 10.1825V8.31055C0 8.06473 0.0882424 7.85673 0.264727 7.68655C0.441212 7.51636 0.649212 7.43127 0.888727 7.43127C1.14085 7.43127 1.35515 7.51636 1.53164 7.68655C1.70812 7.85673 1.79636 8.06473 1.79636 8.31055V10.1164C1.79636 11.1879 2.02012 12.127 2.46764 12.9338C2.92145 13.7343 3.55491 14.3552 4.368 14.7964C5.18109 15.2376 6.12339 15.4582 7.19491 15.4582C8.27273 15.4582 9.21503 15.2376 10.0218 14.7964C10.8286 14.3552 11.4589 13.7343 11.9127 12.9338C12.3665 12.127 12.5935 11.1879 12.5935 10.1164V8.31055C12.5935 8.06473 12.6817 7.85673 12.8582 7.68655C13.0347 7.51636 13.2458 7.43127 13.4916 7.43127C13.7375 7.43127 13.9455 7.51636 14.1156 7.68655C14.2921 7.85673 14.3804 8.06473 14.3804 8.31055V10.1825C14.3804 11.481 14.1125 12.6281 13.5767 13.624C13.041 14.6199 12.2972 15.4172 11.3455 16.016C10.4 16.6148 9.30642 16.9741 8.06473 17.0938V19.032H11.5345C11.7804 19.032 11.9915 19.1171 12.168 19.2873C12.3445 19.4638 12.4327 19.6749 12.4327 19.9207C12.4327 20.1602 12.3445 20.3651 12.168 20.5353C11.9915 20.7118 11.7804 20.8 11.5345 20.8H2.85527C2.60945 20.8 2.3983 20.7118 2.22182 20.5353C2.04533 20.3651 1.95709 20.1602 1.95709 19.9207C1.95709 19.6749 2.04533 19.4638 2.22182 19.2873C2.3983 19.1171 2.60945 19.032 2.85527 19.032H6.32509V17.0938C5.08339 16.9741 3.98667 16.6148 3.03491 16.016C2.08315 15.4172 1.33939 14.6199 0.803636 13.624C0.267879 12.6281 0 11.481 0 10.1825ZM3.57382 9.76655V3.86691C3.57382 3.11055 3.72824 2.44242 4.03709 1.86255C4.34594 1.28267 4.77139 0.828849 5.31345 0.501091C5.86182 0.16703 6.48897 0 7.19491 0C7.90085 0 8.52485 0.16703 9.06691 0.501091C9.61527 0.828849 10.0407 1.28267 10.3433 1.86255C10.6521 2.44242 10.8065 3.11055 10.8065 3.86691V9.76655C10.8065 10.5229 10.6521 11.191 10.3433 11.7709C10.0407 12.3508 9.61527 12.8078 9.06691 13.1418C8.52485 13.4696 7.90085 13.6335 7.19491 13.6335C6.48897 13.6335 5.86182 13.4696 5.31345 13.1418C4.77139 12.8078 4.34594 12.3508 4.03709 11.7709C3.72824 11.191 3.57382 10.5229 3.57382 9.76655ZM5.37018 9.79491C5.37018 10.4252 5.53406 10.9358 5.86182 11.3265C6.19588 11.711 6.64024 11.9033 7.19491 11.9033C7.75588 11.9033 8.19709 11.711 8.51855 11.3265C8.8463 10.9358 9.01018 10.4252 9.01018 9.79491V3.83855C9.01018 3.20824 8.8463 2.70085 8.51855 2.31636C8.19709 1.92558 7.75588 1.73018 7.19491 1.73018C6.64024 1.73018 6.19588 1.92558 5.86182 2.31636C5.53406 2.70085 5.37018 3.20824 5.37018 3.83855V9.79491Z",
            fill: t
          }
        )
      ]
    }
  ) });
}
function D5({
  fill: t = "#DE350B",
  size: n = "x1_5",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "19",
      height: "19",
      fill: "none",
      "aria-label": "Speaker muted",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          fill: t,
          d: "M4.54 12.924c-.665 0-1.163-.17-1.495-.508-.332-.345-.498-.87-.498-1.572v-3.74c0-.652.143-1.14.43-1.465l11.132 11.123c-.078.28-.208.485-.39.615-.182.13-.4.195-.654.195a1.44 1.44 0 0 1-.635-.146 2.66 2.66 0 0 1-.645-.469l-4.219-3.945a.351.351 0 0 0-.244-.088H4.54Zm9.638-1.426L7.4 4.74h.293a.233.233 0 0 0 .166-.078l3.926-3.642a3.83 3.83 0 0 1 .655-.508c.182-.111.387-.166.615-.166.332 0 .602.114.81.342.209.22.313.491.313.81v10Zm3.379 7.1L.818 1.878a.717.717 0 0 1-.214-.526c0-.215.071-.394.214-.538A.7.7 0 0 1 1.355.6a.75.75 0 0 1 .538.214l16.718 16.72c.15.149.225.325.225.527a.733.733 0 0 1-.225.537.682.682 0 0 1-.527.224.702.702 0 0 1-.527-.224Z"
        }
      )
    }
  ) });
}
function o2({
  fill: t = "white",
  size: n = "x1_5",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "23",
      height: "18",
      fill: "none",
      "aria-label": "Speaker",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          fill: t,
          d: "M11.129 17.572c-.228 0-.443-.049-.645-.146a2.511 2.511 0 0 1-.634-.469l-4.16-3.945a.351.351 0 0 0-.245-.088H2.643c-.658 0-1.163-.18-1.514-.537-.352-.358-.527-.892-.527-1.602V7.152c0-.703.175-1.233.527-1.591.351-.365.856-.547 1.514-.547h2.802c.098 0 .18-.03.244-.088L9.85 1.02c.255-.235.47-.404.645-.508.182-.111.388-.166.615-.166.332 0 .603.114.81.342.21.22.313.491.313.81v14.98c0 .313-.104.573-.312.782-.202.208-.466.312-.791.312Zm4.59-4.463a.734.734 0 0 1-.332-.527c-.026-.215.035-.426.185-.635.28-.397.498-.853.655-1.367.156-.52.234-1.064.234-1.63 0-.567-.078-1.11-.234-1.632a4.298 4.298 0 0 0-.655-1.367c-.156-.202-.221-.41-.195-.625a.773.773 0 0 1 .342-.537c.169-.117.355-.156.556-.117.202.039.368.153.498.342.378.494.671 1.087.88 1.777.214.69.322 1.41.322 2.158 0 .749-.108 1.468-.323 2.158-.208.69-.501 1.283-.879 1.778a.772.772 0 0 1-.498.342.762.762 0 0 1-.556-.118Zm3.623 2.55a.684.684 0 0 1-.303-.49.88.88 0 0 1 .166-.614 9.226 9.226 0 0 0 1.23-2.588c.3-.97.45-1.976.45-3.018 0-1.041-.147-2.047-.44-3.017a8.908 8.908 0 0 0-1.24-2.588c-.143-.202-.202-.404-.176-.606a.724.724 0 0 1 .313-.498.742.742 0 0 1 .576-.127c.202.04.368.153.498.342.631.846 1.12 1.84 1.465 2.979s.517 2.31.517 3.515a11.76 11.76 0 0 1-.527 3.506c-.345 1.133-.83 2.129-1.455 2.988a.772.772 0 0 1-.498.342.8.8 0 0 1-.576-.127Z"
        }
      )
    }
  ) });
}
function r2({
  fill: t = "#FF4015",
  size: n = "x2",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "27",
      height: "22",
      viewBox: "0 0 27 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Camera",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M5.45312 18.8788C4.47005 18.8788 3.70182 18.6054 3.14844 18.0585C2.60156 17.5116 2.32812 16.7467 2.32812 15.7636V6.14445C2.32812 5.93612 2.3444 5.73104 2.37695 5.52922C2.40951 5.32739 2.45182 5.16463 2.50391 5.04093L16.3418 18.8788H5.45312ZM16.0391 3.01945C17.0221 3.01945 17.7741 3.28963 18.2949 3.83C18.8158 4.37036 19.0762 5.12882 19.0762 6.10539V14.914C19.0762 15.1223 19.0664 15.3339 19.0469 15.5487C19.0273 15.7571 19.0013 15.9459 18.9688 16.1152L5.87305 3.01945H16.0391ZM20.4043 13.83V8.05851L23.959 4.99211C24.1283 4.84237 24.304 4.72518 24.4863 4.64054C24.6751 4.55591 24.8574 4.51359 25.0332 4.51359C25.4108 4.51359 25.7135 4.64054 25.9414 4.89445C26.1758 5.14185 26.293 5.46737 26.293 5.87101V16.0273C26.293 16.4309 26.1758 16.7597 25.9414 17.0136C25.7135 17.261 25.4108 17.3847 25.0332 17.3847C24.8574 17.3847 24.6751 17.3424 24.4863 17.2577C24.304 17.1666 24.1283 17.0494 23.959 16.9062L20.4043 13.83ZM20.2676 21.164L0.970703 1.88664C0.827474 1.74341 0.755859 1.56763 0.755859 1.35929C0.755859 1.14445 0.827474 0.965413 0.970703 0.822184C1.12044 0.672445 1.29948 0.60083 1.50781 0.60734C1.71615 0.60734 1.89518 0.678955 2.04492 0.822184L21.332 20.0995C21.4818 20.2493 21.5534 20.425 21.5469 20.6269C21.5469 20.8352 21.4753 21.0142 21.332 21.164C21.1888 21.3137 21.013 21.3886 20.8047 21.3886C20.5964 21.3886 20.4173 21.3137 20.2676 21.164Z",
          fill: t
        }
      )
    }
  ) });
}
function i2({
  fill: t = "white",
  size: n = "x2",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "25",
      height: "16",
      viewBox: "0 0 25 16",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Camera",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M3.45312 15.8789C2.47005 15.8789 1.70182 15.6087 1.14844 15.0684C0.595052 14.528 0.318359 13.7663 0.318359 12.7832V3.10547C0.318359 2.12891 0.604818 1.37044 1.17773 0.830078C1.75716 0.289714 2.51562 0.0195312 3.45312 0.0195312H14.0391C15.0221 0.0195312 15.7741 0.289714 16.2949 0.830078C16.8158 1.37044 17.0762 2.12891 17.0762 3.10547V12.7832C17.0762 13.7663 16.7995 14.528 16.2461 15.0684C15.6927 15.6087 14.9245 15.8789 13.9414 15.8789H3.45312ZM18.4043 10.8301V5.05859L21.959 1.99219C22.1283 1.84245 22.304 1.72526 22.4863 1.64062C22.6751 1.55599 22.8574 1.51367 23.0332 1.51367C23.4108 1.51367 23.7135 1.64062 23.9414 1.89453C24.1758 2.14193 24.293 2.46745 24.293 2.87109V13.0273C24.293 13.431 24.1758 13.7598 23.9414 14.0137C23.7135 14.2611 23.4108 14.3848 23.0332 14.3848C22.8574 14.3848 22.6751 14.3424 22.4863 14.2578C22.304 14.1667 22.1283 14.0495 21.959 13.9062L18.4043 10.8301Z",
          fill: t
        }
      )
    }
  ) });
}
function O5({
  fill: t = "#FF4015",
  size: n = "x1_5",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "17",
      height: "17",
      fill: "none",
      "aria-label": "Plus",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          fill: t,
          d: "M8.316 16.93a7.796 7.796 0 0 1-3.132-.633 8.112 8.112 0 0 1-2.57-1.735 8.222 8.222 0 0 1-1.743-2.57A7.88 7.88 0 0 1 .246 8.86a7.88 7.88 0 0 1 .625-3.132 8.103 8.103 0 0 1 1.742-2.57 8.111 8.111 0 0 1 2.57-1.735A7.796 7.796 0 0 1 8.317.789c1.115 0 2.16.211 3.133.633.98.417 1.839.995 2.578 1.734a7.995 7.995 0 0 1 1.735 2.57c.422.975.633 2.019.633 3.133 0 1.115-.211 2.16-.633 3.133a8.11 8.11 0 0 1-4.313 4.305 7.795 7.795 0 0 1-3.133.633Zm-3.82-8.063c0 .224.073.406.219.547.146.14.33.211.555.211h2.28v2.29c0 .223.071.408.212.554.14.14.323.21.547.21a.75.75 0 0 0 .554-.21.752.752 0 0 0 .219-.555V9.625h2.29c.218 0 .4-.07.546-.21a.726.726 0 0 0 .219-.548.736.736 0 0 0-.219-.555.726.726 0 0 0-.547-.218H9.082V5.813a.752.752 0 0 0-.219-.555.722.722 0 0 0-.554-.227.713.713 0 0 0-.547.227.767.767 0 0 0-.211.554v2.282H5.27a.752.752 0 0 0-.555.219.735.735 0 0 0-.219.554Z"
        }
      )
    }
  ) });
}
function j5({
  fill: t = "white",
  size: n = "x1_5",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "17",
      height: "17",
      fill: "none",
      "aria-label": "Clock",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          fill: t,
          d: "M4.871 9.836H8.81c.177 0 .325-.06.445-.18s.18-.268.18-.445V4.094a.595.595 0 0 0-.18-.438.605.605 0 0 0-.445-.18.595.595 0 0 0-.438.18.595.595 0 0 0-.18.438v4.5h-3.32a.605.605 0 0 0-.445.18.58.58 0 0 0-.18.437c0 .177.06.325.18.445s.268.18.445.18Zm3.945 7.094a7.796 7.796 0 0 1-3.132-.633 8.112 8.112 0 0 1-2.57-1.735 8.222 8.222 0 0 1-1.743-2.57A7.88 7.88 0 0 1 .746 8.86a7.88 7.88 0 0 1 .625-3.132 8.103 8.103 0 0 1 1.742-2.57 8.111 8.111 0 0 1 2.57-1.735A7.796 7.796 0 0 1 8.817.789c1.115 0 2.16.211 3.133.633.98.417 1.839.995 2.578 1.734a7.995 7.995 0 0 1 1.735 2.57c.422.975.633 2.019.633 3.133 0 1.115-.211 2.16-.633 3.133a8.11 8.11 0 0 1-4.313 4.305 7.795 7.795 0 0 1-3.133.633Z"
        }
      )
    }
  ) });
}
function B5({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ C(
    "svg",
    {
      width: "12",
      height: "8",
      viewBox: "0 0 12 8",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e("title", { children: "Up caret" }),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.5303 7.03033C11.2374 7.32322 10.7626 7.32322 10.4697 7.03033L6 2.56066L1.53033 7.03033C1.23744 7.32322 0.762564 7.32322 0.46967 7.03033C0.176777 6.73744 0.176777 6.26256 0.46967 5.96967L5.46967 0.96967C5.76256 0.676777 6.23744 0.676777 6.53033 0.96967L11.5303 5.96967C11.8232 6.26256 11.8232 6.73744 11.5303 7.03033Z",
            fill: t
          }
        )
      ]
    }
  ) });
}
function F5({
  fill: t = "#EBEBF5",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "11",
      height: "6",
      viewBox: "0 0 11 6",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Down caret",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M5.80859 5.98242C5.61328 5.98242 5.43555 5.9043 5.27539 5.74805L0.816406 1.18359C0.75 1.12109 0.699219 1.05078 0.664062 0.972656C0.632812 0.890625 0.617188 0.802734 0.617188 0.708984C0.617188 0.580078 0.646484 0.462891 0.705078 0.357422C0.767578 0.251953 0.849609 0.169922 0.951172 0.111328C1.05273 0.0488281 1.16797 0.0175781 1.29688 0.0175781C1.48438 0.0175781 1.64844 0.0878906 1.78906 0.228516L6.0957 4.64062H5.52734L9.82812 0.228516C9.96875 0.0878906 10.1328 0.0175781 10.3203 0.0175781C10.4492 0.0175781 10.5645 0.0488281 10.666 0.111328C10.7676 0.169922 10.8477 0.251953 10.9062 0.357422C10.9688 0.462891 11 0.580078 11 0.708984C11 0.892578 10.9336 1.05078 10.8008 1.18359L6.3418 5.74805C6.26758 5.82617 6.18555 5.88477 6.0957 5.92383C6.00586 5.96289 5.91016 5.98242 5.80859 5.98242Z",
          fill: t,
          fillOpacity: "0.6"
        }
      )
    }
  ) });
}
function W5({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "14",
      height: "16",
      viewBox: "0 0 14 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Copy icon",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M3.80078 3.66797V2.23828C3.80078 1.60547 3.96094 1.12695 4.28125 0.802734C4.60156 0.474609 5.07617 0.310547 5.70508 0.310547H7.9082C8.24805 0.310547 8.55078 0.359375 8.81641 0.457031C9.08594 0.550781 9.33008 0.710937 9.54883 0.9375L12.4668 3.9082C12.6973 4.14648 12.8594 4.40039 12.9531 4.66992C13.0469 4.93555 13.0938 5.26172 13.0938 5.64844V10.2891C13.0938 10.9219 12.9316 11.4004 12.6074 11.7246C12.2871 12.0488 11.8145 12.2109 11.1895 12.2109H9.98828V11.0625H11.084C11.3691 11.0625 11.582 10.9902 11.7227 10.8457C11.8672 10.6973 11.9395 10.4883 11.9395 10.2188V5.36719H9.36133C8.99805 5.36719 8.72266 5.27539 8.53516 5.0918C8.34766 4.9043 8.25391 4.62891 8.25391 4.26562V1.46484H5.79883C5.51758 1.46484 5.30469 1.53711 5.16016 1.68164C5.01953 1.82617 4.94922 2.03516 4.94922 2.30859V3.66797H3.80078ZM9.21484 4.11914C9.21484 4.2207 9.23633 4.29492 9.2793 4.3418C9.32617 4.38477 9.39844 4.40625 9.49609 4.40625H11.6406L9.21484 1.94531V4.11914ZM0.900391 13.2949V5.24414C0.900391 4.61133 1.06055 4.13281 1.38086 3.80859C1.70117 3.48047 2.17578 3.31641 2.80469 3.31641H4.84375C5.19922 3.31641 5.49219 3.35547 5.72266 3.43359C5.95703 3.50781 6.19141 3.66602 6.42578 3.9082L9.60156 7.13086C9.76562 7.29883 9.89062 7.45898 9.97656 7.61133C10.0625 7.76367 10.1191 7.93359 10.1465 8.12109C10.1777 8.30469 10.1934 8.52734 10.1934 8.78906V13.2949C10.1934 13.9277 10.0332 14.4062 9.71289 14.7305C9.39258 15.0547 8.91797 15.2168 8.28906 15.2168H2.80469C2.17578 15.2168 1.70117 15.0547 1.38086 14.7305C1.06055 14.4102 0.900391 13.9316 0.900391 13.2949ZM2.05469 13.2246C2.05469 13.498 2.125 13.707 2.26562 13.8516C2.40625 13.9961 2.61719 14.0684 2.89844 14.0684H8.18945C8.4707 14.0684 8.68164 13.9961 8.82227 13.8516C8.9668 13.707 9.03906 13.498 9.03906 13.2246V8.92383H5.94531C5.53125 8.92383 5.2207 8.82227 5.01367 8.61914C4.80664 8.41211 4.70312 8.09766 4.70312 7.67578V4.4707H2.9043C2.61914 4.4707 2.40625 4.54297 2.26562 4.6875C2.125 4.83203 2.05469 5.03906 2.05469 5.30859V13.2246ZM6.0625 7.91016H8.88086L5.7168 4.69336V7.56445C5.7168 7.68555 5.74414 7.77344 5.79883 7.82812C5.85352 7.88281 5.94141 7.91016 6.0625 7.91016Z",
          fill: t
        }
      )
    }
  ) });
}
function U5({
  fill: t = "white",
  size: n = "x1_5",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "16",
      height: "20",
      viewBox: "0 0 16 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Copy icon",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M4.00098 4.58496V2.79785C4.00098 2.00684 4.20117 1.40869 4.60156 1.00342C5.00195 0.593262 5.59521 0.388184 6.38135 0.388184H9.13525C9.56006 0.388184 9.93848 0.449219 10.2705 0.571289C10.6074 0.688477 10.9126 0.888672 11.186 1.17188L14.8335 4.88525C15.1216 5.18311 15.3242 5.50049 15.4414 5.8374C15.5586 6.16943 15.6172 6.57715 15.6172 7.06055V12.8613C15.6172 13.6523 15.4146 14.2505 15.0093 14.6558C14.6089 15.061 14.0181 15.2637 13.2368 15.2637H11.7354V13.8281H13.105C13.4614 13.8281 13.7275 13.7378 13.9033 13.5571C14.084 13.3716 14.1743 13.1104 14.1743 12.7734V6.70898H10.9517C10.4976 6.70898 10.1533 6.59424 9.91895 6.36475C9.68457 6.13037 9.56738 5.78613 9.56738 5.33203V1.83105H6.49854C6.14697 1.83105 5.88086 1.92139 5.7002 2.10205C5.52441 2.28271 5.43652 2.54395 5.43652 2.88574V4.58496H4.00098ZM10.7686 5.14893C10.7686 5.27588 10.7954 5.36865 10.8491 5.42725C10.9077 5.48096 10.998 5.50781 11.1201 5.50781H13.8008L10.7686 2.43164V5.14893ZM0.375488 16.6187V6.55518C0.375488 5.76416 0.575684 5.16602 0.976074 4.76074C1.37646 4.35059 1.96973 4.14551 2.75586 4.14551H5.30469C5.74902 4.14551 6.11523 4.19434 6.40332 4.29199C6.69629 4.38477 6.98926 4.58252 7.28223 4.88525L11.252 8.91357C11.457 9.12354 11.6133 9.32373 11.7207 9.51416C11.8281 9.70459 11.8989 9.91699 11.9331 10.1514C11.9722 10.3809 11.9917 10.6592 11.9917 10.9863V16.6187C11.9917 17.4097 11.7915 18.0078 11.3911 18.4131C10.9907 18.8184 10.3975 19.021 9.61133 19.021H2.75586C1.96973 19.021 1.37646 18.8184 0.976074 18.4131C0.575684 18.0127 0.375488 17.4146 0.375488 16.6187ZM1.81836 16.5308C1.81836 16.8726 1.90625 17.1338 2.08203 17.3145C2.25781 17.4951 2.52148 17.5854 2.87305 17.5854H9.48682C9.83838 17.5854 10.1021 17.4951 10.2778 17.3145C10.4585 17.1338 10.5488 16.8726 10.5488 16.5308V11.1548H6.68164C6.16406 11.1548 5.77588 11.0278 5.51709 10.7739C5.2583 10.5151 5.12891 10.1221 5.12891 9.59473V5.58838H2.88037C2.52393 5.58838 2.25781 5.67871 2.08203 5.85938C1.90625 6.04004 1.81836 6.29883 1.81836 6.63574V16.5308ZM6.82812 9.8877H10.3511L6.396 5.8667V9.45557C6.396 9.60693 6.43018 9.7168 6.49854 9.78516C6.56689 9.85352 6.67676 9.8877 6.82812 9.8877Z",
          fill: t
        }
      )
    }
  ) });
}
function J5({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "14",
      height: "18",
      viewBox: "0 0 14 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Share icon",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M2.78125 17.7393C1.99023 17.7393 1.39209 17.5391 0.986816 17.1387C0.581543 16.7383 0.378906 16.145 0.378906 15.3589V8.18848C0.378906 7.40234 0.581543 6.80908 0.986816 6.40869C1.39209 6.0083 1.99023 5.80811 2.78125 5.80811H4.93457V7.24365H2.86914C2.52734 7.24365 2.26611 7.33154 2.08545 7.50732C1.90967 7.68311 1.82178 7.94922 1.82178 8.30566V15.2344C1.82178 15.5908 1.90967 15.8569 2.08545 16.0327C2.26611 16.2134 2.52734 16.3037 2.86914 16.3037H11.1235C11.4604 16.3037 11.7192 16.2134 11.8999 16.0327C12.0854 15.8569 12.1782 15.5908 12.1782 15.2344V8.30566C12.1782 7.94922 12.0854 7.68311 11.8999 7.50732C11.7192 7.33154 11.4604 7.24365 11.1235 7.24365H9.05811V5.80811H11.2188C12.0098 5.80811 12.6079 6.0083 13.0132 6.40869C13.4185 6.80908 13.6211 7.40234 13.6211 8.18848V15.3589C13.6211 16.145 13.4185 16.7383 13.0132 17.1387C12.6079 17.5391 12.0098 17.7393 11.2188 17.7393H2.78125ZM7 11.8286C6.81445 11.8286 6.65332 11.7627 6.5166 11.6309C6.38477 11.499 6.31885 11.3452 6.31885 11.1694V3.81592L6.37744 2.73193L5.98926 3.19336L4.94189 4.30664C4.82471 4.44336 4.6709 4.51172 4.48047 4.51172C4.31445 4.51172 4.17285 4.45801 4.05566 4.35059C3.93848 4.23828 3.87988 4.09668 3.87988 3.92578C3.87988 3.76465 3.9458 3.62061 4.07764 3.49365L6.47998 1.17188C6.57275 1.08398 6.66064 1.02539 6.74365 0.996094C6.82666 0.961914 6.91211 0.944824 7 0.944824C7.08789 0.944824 7.17334 0.961914 7.25635 0.996094C7.33936 1.02539 7.4248 1.08398 7.5127 1.17188L9.92236 3.49365C10.0493 3.62061 10.1128 3.76465 10.1128 3.92578C10.1128 4.09668 10.0518 4.23828 9.92969 4.35059C9.8125 4.45801 9.6709 4.51172 9.50488 4.51172C9.32422 4.51172 9.17285 4.44336 9.05078 4.30664L8.01074 3.19336L7.62256 2.73193L7.68115 3.81592V11.1694C7.68115 11.3452 7.61279 11.499 7.47607 11.6309C7.34424 11.7627 7.18555 11.8286 7 11.8286Z",
          fill: t
        }
      )
    }
  ) });
}
function Y5({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "12",
      height: "15",
      viewBox: "0 0 12 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Share icon",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M2.625 14.1914C1.99219 14.1914 1.51367 14.0312 1.18945 13.7109C0.865234 13.3906 0.703125 12.916 0.703125 12.2871V6.55078C0.703125 5.92188 0.865234 5.44727 1.18945 5.12695C1.51367 4.80664 1.99219 4.64648 2.625 4.64648H4.34766V5.79492H2.69531C2.42188 5.79492 2.21289 5.86523 2.06836 6.00586C1.92773 6.14648 1.85742 6.35938 1.85742 6.64453V12.1875C1.85742 12.4727 1.92773 12.6855 2.06836 12.8262C2.21289 12.9707 2.42188 13.043 2.69531 13.043H9.29883C9.56836 13.043 9.77539 12.9707 9.91992 12.8262C10.0684 12.6855 10.1426 12.4727 10.1426 12.1875V6.64453C10.1426 6.35938 10.0684 6.14648 9.91992 6.00586C9.77539 5.86523 9.56836 5.79492 9.29883 5.79492H7.64648V4.64648H9.375C10.0078 4.64648 10.4863 4.80664 10.8105 5.12695C11.1348 5.44727 11.2969 5.92188 11.2969 6.55078V12.2871C11.2969 12.916 11.1348 13.3906 10.8105 13.7109C10.4863 14.0312 10.0078 14.1914 9.375 14.1914H2.625ZM6 9.46289C5.85156 9.46289 5.72266 9.41016 5.61328 9.30469C5.50781 9.19922 5.45508 9.07617 5.45508 8.93555V3.05273L5.50195 2.18555L5.19141 2.55469L4.35352 3.44531C4.25977 3.55469 4.13672 3.60938 3.98438 3.60938C3.85156 3.60938 3.73828 3.56641 3.64453 3.48047C3.55078 3.39063 3.50391 3.27734 3.50391 3.14062C3.50391 3.01172 3.55664 2.89648 3.66211 2.79492L5.58398 0.9375C5.6582 0.867188 5.72852 0.820312 5.79492 0.796875C5.86133 0.769531 5.92969 0.755859 6 0.755859C6.07031 0.755859 6.13867 0.769531 6.20508 0.796875C6.27148 0.820312 6.33984 0.867188 6.41016 0.9375L8.33789 2.79492C8.43945 2.89648 8.49023 3.01172 8.49023 3.14062C8.49023 3.27734 8.44141 3.39063 8.34375 3.48047C8.25 3.56641 8.13672 3.60938 8.00391 3.60938C7.85938 3.60938 7.73828 3.55469 7.64062 3.44531L6.80859 2.55469L6.49805 2.18555L6.54492 3.05273V8.93555C6.54492 9.07617 6.49023 9.19922 6.38086 9.30469C6.27539 9.41016 6.14844 9.46289 6 9.46289Z",
          fill: t
        }
      )
    }
  ) });
}
function G5({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "17",
      height: "15",
      viewBox: "0 0 17 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Share icon",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M8.98877 14.5234C8.70557 14.5234 8.46875 14.4307 8.27832 14.2451C8.09277 14.0596 8 13.8276 8 13.5493V10.9053H7.81689C6.92334 10.9053 6.13721 11.0005 5.4585 11.1909C4.77979 11.3813 4.18408 11.6914 3.67139 12.1211C3.15869 12.5508 2.70947 13.127 2.32373 13.8496C2.18213 14.1133 2.02344 14.2866 1.84766 14.3696C1.67676 14.4526 1.49609 14.4941 1.30566 14.4941C1.05176 14.4941 0.836914 14.377 0.661133 14.1426C0.490234 13.9131 0.404785 13.5713 0.404785 13.1172C0.404785 11.7891 0.553711 10.5977 0.851562 9.54297C1.14941 8.4834 1.60107 7.58008 2.20654 6.83301C2.81689 6.08594 3.58594 5.51709 4.51367 5.12646C5.44629 4.73096 6.54736 4.5332 7.81689 4.5332H8V1.91113C8 1.63281 8.09277 1.396 8.27832 1.20068C8.46875 1.00049 8.70801 0.900391 8.99609 0.900391C9.19141 0.900391 9.36719 0.944336 9.52344 1.03223C9.68457 1.11523 9.87012 1.25684 10.0801 1.45703L15.8809 6.8623C16.0225 6.99414 16.1226 7.13574 16.1812 7.28711C16.2446 7.43359 16.2764 7.5752 16.2764 7.71191C16.2764 7.84375 16.2446 7.98535 16.1812 8.13672C16.1226 8.28809 16.0225 8.42969 15.8809 8.56152L10.0801 14.0107C9.88965 14.1914 9.70654 14.3208 9.53076 14.3989C9.35986 14.4819 9.1792 14.5234 8.98877 14.5234Z",
          fill: t
        }
      )
    }
  ) });
}
function K5({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "17",
      height: "16",
      fill: "none",
      "aria-label": "Eye icon",
      role: "img",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            stroke: t,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M1.167 8S3.833 2.667 8.5 2.667C13.166 2.667 15.833 8 15.833 8s-2.667 5.333-7.333 5.333C3.833 13.333 1.167 8 1.167 8Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            stroke: t,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M8.5 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
          }
        )
      ]
    }
  ) });
}
function G8({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "19",
      height: "12",
      viewBox: "0 0 19 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Eye icon",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M9.5 11.8887C8.63411 11.8887 7.8138 11.7839 7.03906 11.5742C6.26888 11.3646 5.55794 11.0866 4.90625 10.7402C4.25456 10.3939 3.66895 10.0133 3.14941 9.59863C2.62988 9.18392 2.18555 8.76693 1.81641 8.34766C1.45182 7.92839 1.17383 7.54329 0.982422 7.19238C0.791016 6.83691 0.695312 6.5498 0.695312 6.33105C0.695312 6.1123 0.791016 5.8252 0.982422 5.46973C1.17839 5.11426 1.45866 4.72917 1.82324 4.31445C2.18783 3.89518 2.62988 3.47819 3.14941 3.06348C3.66895 2.64421 4.25456 2.26139 4.90625 1.91504C5.5625 1.56868 6.27572 1.29297 7.0459 1.08789C7.82064 0.878255 8.63867 0.773438 9.5 0.773438C10.3796 0.773438 11.2067 0.878255 11.9814 1.08789C12.7562 1.29297 13.4694 1.56868 14.1211 1.91504C14.7773 2.26139 15.363 2.64421 15.8779 3.06348C16.3929 3.47819 16.8304 3.89518 17.1904 4.31445C17.555 4.72917 17.8307 5.11426 18.0176 5.46973C18.209 5.8252 18.3047 6.1123 18.3047 6.33105C18.3047 6.5498 18.209 6.83691 18.0176 7.19238C17.8307 7.54329 17.5573 7.92839 17.1973 8.34766C16.8372 8.76693 16.3975 9.18392 15.8779 9.59863C15.363 10.0133 14.7796 10.3939 14.1279 10.7402C13.4762 11.0866 12.7607 11.3646 11.9814 11.5742C11.2067 11.7839 10.3796 11.8887 9.5 11.8887ZM9.5 9.85156C10.1471 9.85156 10.7373 9.69434 11.2705 9.37988C11.8037 9.06087 12.2298 8.63477 12.5488 8.10156C12.8678 7.56836 13.0273 6.97819 13.0273 6.33105C13.0273 5.68392 12.8678 5.09375 12.5488 4.56055C12.2298 4.02734 11.8037 3.60352 11.2705 3.28906C10.7373 2.97005 10.1471 2.81055 9.5 2.81055C8.85742 2.81055 8.26953 2.97005 7.73633 3.28906C7.20312 3.60352 6.77702 4.02734 6.45801 4.56055C6.139 5.09375 5.97949 5.68392 5.97949 6.33105C5.97949 6.97819 6.139 7.56836 6.45801 8.10156C6.77702 8.63477 7.20312 9.06087 7.73633 9.37988C8.26953 9.69434 8.85742 9.85156 9.5 9.85156ZM9.5 7.6709C9.13086 7.6709 8.81641 7.54102 8.55664 7.28125C8.29688 7.01693 8.16699 6.7002 8.16699 6.33105C8.16699 5.96191 8.29688 5.64746 8.55664 5.3877C8.81641 5.12337 9.13086 4.99121 9.5 4.99121C9.8737 4.99121 10.1904 5.12337 10.4502 5.3877C10.71 5.64746 10.8398 5.96191 10.8398 6.33105C10.8398 6.7002 10.71 7.01693 10.4502 7.28125C10.1904 7.54102 9.8737 7.6709 9.5 7.6709Z",
          fill: t
        }
      )
    }
  ) });
}
function a2({
  fill: t = "white",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "8",
      height: "15",
      viewBox: "0 0 8 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": ">",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M8.00781 7.35938C8.00781 7.49479 7.98177 7.61979 7.92969 7.73438C7.8776 7.84896 7.79948 7.95833 7.69531 8.0625L1.60938 14.0156C1.4375 14.1927 1.22396 14.2812 0.96875 14.2812C0.802083 14.2812 0.648438 14.2396 0.507812 14.1562C0.367188 14.0781 0.255208 13.9688 0.171875 13.8281C0.09375 13.6927 0.0546875 13.5417 0.0546875 13.375C0.0546875 13.125 0.148438 12.9036 0.335938 12.7109L5.82031 7.35938L0.335938 2.00781C0.148438 1.8151 0.0546875 1.59635 0.0546875 1.35156C0.0546875 1.17969 0.09375 1.02604 0.171875 0.890625C0.255208 0.755208 0.367188 0.648438 0.507812 0.570312C0.648438 0.486979 0.802083 0.445312 0.96875 0.445312C1.22396 0.445312 1.4375 0.53125 1.60938 0.703125L7.69531 6.65625C7.79948 6.76042 7.8776 6.86979 7.92969 6.98438C7.98177 7.09896 8.00781 7.22396 8.00781 7.35938Z",
          fill: t
        }
      )
    }
  ) });
}
function A5({
  fill: t = "white",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "8",
      height: "15",
      viewBox: "0 0 8 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "<",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M0 7.35938C0 7.22396 0.0234375 7.09896 0.0703125 6.98438C0.122396 6.86979 0.200521 6.76042 0.304688 6.65625L6.39062 0.703125C6.56771 0.53125 6.78125 0.445312 7.03125 0.445312C7.20312 0.445312 7.35677 0.486979 7.49219 0.570312C7.63281 0.648438 7.74479 0.755208 7.82812 0.890625C7.91146 1.02604 7.95312 1.17969 7.95312 1.35156C7.95312 1.59635 7.85677 1.8151 7.66406 2.00781L2.17969 7.35938L7.66406 12.7109C7.85677 12.9036 7.95312 13.125 7.95312 13.375C7.95312 13.5417 7.91146 13.6927 7.82812 13.8281C7.74479 13.9688 7.63281 14.0781 7.49219 14.1562C7.35677 14.2396 7.20312 14.2812 7.03125 14.2812C6.78125 14.2812 6.56771 14.1927 6.39062 14.0156L0.304688 8.0625C0.200521 7.95833 0.122396 7.84896 0.0703125 7.73438C0.0234375 7.61979 0 7.49479 0 7.35938Z",
          fill: t
        }
      )
    }
  ) });
}
function Q5({
  fill: t = "#EBEBF5",
  fillOpacity: n = 1,
  size: o = "x1_25",
  ...r
}) {
  return /* @__PURE__ */ e(g, { ...r, size: o, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Info",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M7.99268 15.2778C6.94775 15.2778 5.96875 15.0801 5.05566 14.6846C4.14258 14.2939 3.33936 13.752 2.646 13.0586C1.95264 12.3652 1.4082 11.562 1.0127 10.6489C0.62207 9.73584 0.426758 8.75684 0.426758 7.71191C0.426758 6.66699 0.62207 5.68799 1.0127 4.7749C1.4082 3.85693 1.95264 3.05371 2.646 2.36523C3.33936 1.67187 4.14258 1.12988 5.05566 0.739258C5.96875 0.34375 6.94775 0.145996 7.99268 0.145996C9.0376 0.145996 10.0166 0.34375 10.9297 0.739258C11.8477 1.12988 12.6533 1.67187 13.3467 2.36523C14.04 3.05371 14.582 3.85693 14.9727 4.7749C15.3682 5.68799 15.5659 6.66699 15.5659 7.71191C15.5659 8.75684 15.3682 9.73584 14.9727 10.6489C14.582 11.562 14.04 12.3652 13.3467 13.0586C12.6533 13.752 11.8477 14.2939 10.9297 14.6846C10.0166 15.0801 9.0376 15.2778 7.99268 15.2778ZM6.65234 11.9233H9.73584C9.91162 11.9233 10.0581 11.8696 10.1753 11.7622C10.2925 11.6499 10.3511 11.5059 10.3511 11.3301C10.3511 11.1641 10.2925 11.0249 10.1753 10.9126C10.0581 10.7954 9.91162 10.7368 9.73584 10.7368H8.89355V7.14795C8.89355 6.91846 8.8374 6.73291 8.7251 6.59131C8.61279 6.44971 8.44922 6.37891 8.23438 6.37891H6.78418C6.61328 6.37891 6.46924 6.4375 6.35205 6.55469C6.23486 6.67188 6.17627 6.81104 6.17627 6.97217C6.17627 7.14795 6.23486 7.29199 6.35205 7.4043C6.46924 7.51172 6.61328 7.56543 6.78418 7.56543H7.55322V10.7368H6.65234C6.48145 10.7368 6.33496 10.7954 6.21289 10.9126C6.0957 11.0249 6.03711 11.1641 6.03711 11.3301C6.03711 11.5059 6.0957 11.6499 6.21289 11.7622C6.33496 11.8696 6.48145 11.9233 6.65234 11.9233ZM7.94873 5.19971C8.2417 5.19971 8.48828 5.09717 8.68848 4.89209C8.88867 4.68701 8.98877 4.44287 8.98877 4.15967C8.98877 3.86182 8.88867 3.61279 8.68848 3.4126C8.48828 3.20752 8.2417 3.10498 7.94873 3.10498C7.66064 3.10498 7.41406 3.20752 7.20898 3.4126C7.00391 3.61279 6.90137 3.86182 6.90137 4.15967C6.90137 4.44287 7.00391 4.68701 7.20898 4.89209C7.41406 5.09717 7.66064 5.19971 7.94873 5.19971Z",
          fill: t,
          fillOpacity: n
        }
      )
    }
  ) });
}
function l2({
  fill: t = "currentColor",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Info",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M8 16.3438C6.9375 16.3438 5.94271 16.1432 5.01562 15.7422C4.09375 15.3464 3.27865 14.7943 2.57031 14.0859C1.86719 13.3828 1.3151 12.5703 0.914062 11.6484C0.518229 10.7214 0.320312 9.72656 0.320312 8.66406C0.320312 7.60156 0.518229 6.60677 0.914062 5.67969C1.3151 4.7526 1.86719 3.9375 2.57031 3.23438C3.27865 2.53125 4.09375 1.98177 5.01562 1.58594C5.94271 1.1849 6.9375 0.984375 8 0.984375C9.0625 0.984375 10.0573 1.1849 10.9844 1.58594C11.9115 1.98177 12.7266 2.53125 13.4297 3.23438C14.1328 3.9375 14.6823 4.7526 15.0781 5.67969C15.4792 6.60677 15.6797 7.60156 15.6797 8.66406C15.6797 9.72656 15.4792 10.7214 15.0781 11.6484C14.6823 12.5703 14.1328 13.3828 13.4297 14.0859C12.7266 14.7943 11.9115 15.3464 10.9844 15.7422C10.0573 16.1432 9.0625 16.3438 8 16.3438ZM8 14.7266C8.83854 14.7266 9.6224 14.5677 10.3516 14.25C11.0859 13.9375 11.7318 13.5052 12.2891 12.9531C12.8464 12.3958 13.2812 11.7526 13.5938 11.0234C13.9062 10.2891 14.0625 9.5026 14.0625 8.66406C14.0625 7.82552 13.9062 7.04167 13.5938 6.3125C13.2812 5.57812 12.8464 4.9349 12.2891 4.38281C11.7318 3.82552 11.0859 3.39062 10.3516 3.07812C9.6224 2.76042 8.83854 2.60156 8 2.60156C7.16146 2.60156 6.375 2.76042 5.64062 3.07812C4.91146 3.39062 4.26823 3.82552 3.71094 4.38281C3.15365 4.9349 2.71875 5.57812 2.40625 6.3125C2.09375 7.04167 1.9375 7.82552 1.9375 8.66406C1.9375 9.5026 2.09375 10.2891 2.40625 11.0234C2.71875 11.7526 3.15365 12.3958 3.71094 12.9531C4.26823 13.5052 4.91146 13.9375 5.64062 14.25C6.375 14.5677 7.16146 14.7266 8 14.7266ZM6.70312 12.6875C6.53646 12.6875 6.39323 12.6328 6.27344 12.5234C6.15885 12.4141 6.10156 12.2734 6.10156 12.1016C6.10156 11.9453 6.15885 11.8125 6.27344 11.7031C6.39323 11.5885 6.53646 11.5312 6.70312 11.5312H7.5625V8.57031H6.83594C6.66406 8.57031 6.52083 8.51562 6.40625 8.40625C6.29167 8.29688 6.23438 8.15625 6.23438 7.98438C6.23438 7.82292 6.29167 7.6875 6.40625 7.57812C6.52083 7.46354 6.66406 7.40625 6.83594 7.40625H8.22656C8.4401 7.40625 8.60156 7.47396 8.71094 7.60938C8.82552 7.74479 8.88281 7.92969 8.88281 8.16406V11.5312H9.66406C9.83073 11.5312 9.97135 11.5885 10.0859 11.7031C10.2057 11.8125 10.2656 11.9453 10.2656 12.1016C10.2656 12.2734 10.2057 12.4141 10.0859 12.5234C9.97135 12.6328 9.83073 12.6875 9.66406 12.6875H6.70312ZM7.96094 6.29688C7.67969 6.29688 7.4401 6.19792 7.24219 6C7.04427 5.80208 6.94531 5.5651 6.94531 5.28906C6.94531 5.0026 7.04427 4.76042 7.24219 4.5625C7.4401 4.36458 7.67969 4.26562 7.96094 4.26562C8.24219 4.26562 8.47917 4.36458 8.67188 4.5625C8.86979 4.76042 8.96875 5.0026 8.96875 5.28906C8.96875 5.5651 8.86979 5.80208 8.67188 6C8.47917 6.19792 8.24219 6.29688 7.96094 6.29688Z",
          fill: t
        }
      )
    }
  ) });
}
function X5({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Edit",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M2.8252 15.5454C2.03418 15.5454 1.43359 15.3428 1.02344 14.9375C0.618164 14.5371 0.415527 13.9463 0.415527 13.165V4.76416C0.415527 3.97803 0.618164 3.38477 1.02344 2.98438C1.43359 2.58398 2.03418 2.38379 2.8252 2.38379H10.9771L9.5415 3.81934H2.91309C2.57129 3.81934 2.31006 3.90967 2.12939 4.09033C1.94873 4.26611 1.8584 4.53223 1.8584 4.88867V13.0405C1.8584 13.397 1.94873 13.6631 2.12939 13.8389C2.31006 14.0146 2.57129 14.1025 2.91309 14.1025H11.27C11.519 14.1025 11.7241 14.0146 11.8853 13.8389C12.0513 13.6631 12.1343 13.397 12.1343 13.0405V6.47803L13.5771 5.03516V13.165C13.5771 13.9463 13.3818 14.5371 12.9912 14.9375C12.6055 15.3428 12.061 15.5454 11.3579 15.5454H2.8252ZM5.58643 10.6455C5.50342 10.6797 5.42773 10.6626 5.35938 10.5942C5.29102 10.521 5.27393 10.4429 5.30811 10.3599L5.96729 8.90967L12.647 2.22998L13.7676 3.33594L7.08057 10.0156L5.58643 10.6455ZM14.3242 2.78662L13.2036 1.65869L13.7163 1.15332C13.853 1.02148 14.0117 0.948242 14.1924 0.933594C14.3779 0.918945 14.5317 0.972656 14.6538 1.09473L14.8442 1.29248C14.9858 1.4292 15.0542 1.58789 15.0493 1.76855C15.0493 1.94922 14.9785 2.11279 14.8369 2.25928L14.3242 2.78662Z",
          fill: t
        }
      )
    }
  ) });
}
function q5({
  fill: t = "#F1F4F7",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "18",
      height: "20",
      viewBox: "0 0 18 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Trash can",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M6.55957 16.7925C6.38802 16.7925 6.24967 16.7454 6.14453 16.6514C6.03939 16.5518 5.98405 16.4189 5.97852 16.2529L5.72949 7.55371C5.72396 7.39323 5.77376 7.26318 5.87891 7.16357C5.98405 7.05843 6.1224 7.00586 6.29395 7.00586C6.46549 7.00586 6.60384 7.05566 6.70898 7.15527C6.81413 7.25488 6.8667 7.38493 6.8667 7.54541L7.12402 16.2446C7.12402 16.4106 7.07145 16.5435 6.96631 16.6431C6.8667 16.7427 6.73112 16.7925 6.55957 16.7925ZM9 16.7925C8.82845 16.7925 8.68734 16.7427 8.57666 16.6431C8.47152 16.5435 8.41895 16.4134 8.41895 16.2529V7.55371C8.41895 7.39323 8.47152 7.26318 8.57666 7.16357C8.68734 7.05843 8.82845 7.00586 9 7.00586C9.17708 7.00586 9.3182 7.05843 9.42334 7.16357C9.53402 7.26318 9.58936 7.39323 9.58936 7.55371V16.2529C9.58936 16.4134 9.53402 16.5435 9.42334 16.6431C9.3182 16.7427 9.17708 16.7925 9 16.7925ZM11.4487 16.7925C11.2716 16.7925 11.1305 16.7427 11.0254 16.6431C10.9258 16.5435 10.8787 16.4106 10.8843 16.2446L11.1333 7.55371C11.1388 7.3877 11.1942 7.25488 11.2993 7.15527C11.4045 7.05566 11.54 7.00586 11.7061 7.00586C11.8831 7.00586 12.0215 7.05843 12.1211 7.16357C12.2262 7.26318 12.276 7.39323 12.2705 7.55371L12.0215 16.2529C12.016 16.4189 11.9606 16.5518 11.8555 16.6514C11.7503 16.7454 11.6147 16.7925 11.4487 16.7925ZM5.23145 4.68994V2.89697C5.23145 2.26058 5.42236 1.7653 5.8042 1.41113C6.19157 1.05143 6.72835 0.871582 7.41455 0.871582H10.5688C11.255 0.871582 11.7918 1.05143 12.1792 1.41113C12.5666 1.7653 12.7603 2.26058 12.7603 2.89697V4.68994H11.2246V2.97168C11.2246 2.76139 11.1554 2.59261 11.0171 2.46533C10.8787 2.33252 10.6934 2.26611 10.4609 2.26611H7.52246C7.29557 2.26611 7.11296 2.33252 6.97461 2.46533C6.83626 2.59261 6.76709 2.76139 6.76709 2.97168V4.68994H5.23145ZM1.5542 5.60303C1.34945 5.60303 1.17513 5.53109 1.03125 5.38721C0.88737 5.24333 0.81543 5.06901 0.81543 4.86426C0.81543 4.66504 0.88737 4.49626 1.03125 4.35791C1.17513 4.21403 1.34945 4.14209 1.5542 4.14209H16.4541C16.6589 4.14209 16.8304 4.21126 16.9688 4.34961C17.1126 4.48796 17.1846 4.65951 17.1846 4.86426C17.1846 5.06901 17.1126 5.24333 16.9688 5.38721C16.8304 5.53109 16.6589 5.60303 16.4541 5.60303H1.5542ZM5.18994 19.6064C4.54801 19.6064 4.03337 19.4266 3.646 19.0669C3.26416 18.7072 3.05941 18.2064 3.03174 17.5645L2.45068 5.44531H3.96973L4.54248 17.3071C4.55355 17.5506 4.63379 17.7498 4.7832 17.9048C4.93262 18.0597 5.12354 18.1372 5.35596 18.1372H12.644C12.8765 18.1372 13.0674 18.0597 13.2168 17.9048C13.3662 17.7554 13.4465 17.5562 13.4575 17.3071L14.0054 5.44531H15.5493L14.9766 17.5562C14.9489 18.1981 14.7414 18.6989 14.354 19.0586C13.9666 19.4238 13.4548 19.6064 12.8184 19.6064H5.18994Z",
          fill: t
        }
      )
    }
  ) });
}
function $5({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "15",
      fill: "none",
      "aria-label": "Settings",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          fill: t,
          d: "M4.367 5.766a.578.578 0 0 1-.414-.164.569.569 0 0 1-.164-.407c0-.156.055-.289.164-.398a.578.578 0 0 1 .414-.164h3.836v1.133H4.367Zm4.875 1.046c-.297 0-.568-.072-.812-.218a1.662 1.662 0 0 1-.586-.586 1.572 1.572 0 0 1-.219-.82c0-.297.073-.566.219-.805.146-.245.34-.44.586-.586.244-.146.515-.219.812-.219.297 0 .568.073.813.219.245.146.44.341.586.586.146.24.218.508.218.804 0 .303-.072.576-.218.82-.146.246-.341.44-.586.587a1.558 1.558 0 0 1-.813.218Zm0-.89c.203 0 .373-.07.508-.211a.71.71 0 0 0 .21-.524.676.676 0 0 0-.21-.507.676.676 0 0 0-.508-.211.701.701 0 0 0-.515.21.689.689 0 0 0-.204.508c0 .209.068.383.204.524.14.14.312.21.515.21Zm.977-.156V4.633h1.437c.151 0 .281.054.39.164.11.11.165.242.165.398a.569.569 0 0 1-.164.407.534.534 0 0 1-.39.164h-1.438Zm1.406 3.062c.167 0 .305.055.414.164a.54.54 0 0 1 .172.406.53.53 0 0 1-.172.399.561.561 0 0 1-.414.164H7.797V8.828h3.828ZM6.75 7.773a1.572 1.572 0 0 1 1.398.813c.146.245.22.518.22.82 0 .292-.074.56-.22.805a1.6 1.6 0 0 1-1.398.805c-.297 0-.568-.073-.813-.22a1.752 1.752 0 0 1-.585-.585 1.543 1.543 0 0 1-.22-.805c0-.302.074-.575.22-.82.15-.25.346-.448.585-.594.245-.146.516-.219.813-.219Zm0 .899a.692.692 0 0 0-.508.21.71.71 0 0 0-.21.524.706.706 0 0 0 .719.719.715.715 0 0 0 .515-.203c.14-.14.21-.313.21-.516a.71.71 0 0 0-.21-.523.701.701 0 0 0-.516-.211Zm-.969.156v1.133H4.336a.542.542 0 0 1-.383-.164.542.542 0 0 1-.164-.399c0-.161.055-.296.164-.406a.542.542 0 0 1 .383-.164H5.78Zm-2.515 5.828c-.844 0-1.482-.216-1.914-.648-.433-.427-.649-1.055-.649-1.883V2.609c0-.838.216-1.471.649-1.898.432-.427 1.07-.64 1.914-.64h9.46c.844 0 1.482.215 1.915.648.432.427.648 1.057.648 1.89v9.516c0 .828-.216 1.456-.648 1.883-.433.432-1.07.648-1.914.648H3.266Zm.093-1.539h9.274c.36 0 .635-.094.828-.281.193-.188.289-.471.289-.852V2.742c0-.38-.096-.664-.29-.851-.192-.188-.468-.282-.827-.282H3.359c-.364 0-.643.094-.836.282-.187.187-.28.471-.28.851v9.242c0 .38.093.664.28.852.193.187.472.281.836.281Z"
        }
      )
    }
  ) });
}
function c2({
  fill: t = "#DE350B",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      fill: "none",
      "aria-label": "Warning",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          fill: t,
          d: "M2.336 13.62c-.397 0-.74-.086-1.032-.26a1.808 1.808 0 0 1-.677-.697 2.036 2.036 0 0 1 .041-1.962L5.959 1.48c.178-.323.417-.567.718-.731.3-.164.615-.246.943-.246.328 0 .64.082.937.246.296.16.537.403.724.731l5.291 9.222a1.963 1.963 0 0 1 .274.991c0 .356-.08.68-.24.971-.16.292-.385.524-.676.697-.287.174-.63.26-1.026.26H2.336Zm5.291-4.682c.406 0 .613-.212.622-.636l.11-3.432a.63.63 0 0 0-.199-.513.745.745 0 0 0-.54-.205.73.73 0 0 0-.54.205c-.137.133-.2.301-.191.506l.095 3.446c.014.419.228.629.643.629Zm0 2.351a.855.855 0 0 0 .588-.219.716.716 0 0 0 .246-.56.73.73 0 0 0-.246-.56.84.84 0 0 0-.588-.226.849.849 0 0 0-.595.225.73.73 0 0 0-.246.56c0 .229.082.415.246.561a.88.88 0 0 0 .595.22Z"
        }
      )
    }
  ) });
}
function e3({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "19",
      viewBox: "0 0 24 19",
      fill: "none",
      "aria-label": "Screen share",
      role: "img",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            fill: t,
            fillRule: "evenodd",
            d: "M7.597 12.003a1.068 1.068 0 0 1 0-1.45l3.505-3.966c.38-.387.948-.387 1.232 0l3.6 4.062a1.068 1.068 0 0 1 0 1.451c-.378.387-.947.387-1.231 0l-2.937-3.385-2.938 3.288c-.379.387-.947.387-1.231 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            stroke: t,
            strokeMiterlimit: "10",
            strokeWidth: "1.5",
            d: "M19.012 17.78H4.989c-1.816 0-3.3-1.59-3.3-3.533V4.44c0-1.944 1.484-3.534 3.3-3.534h14.024c1.816 0 3.3 1.59 3.3 3.534v9.807c0 1.944-1.485 3.534-3.3 3.534Z"
          }
        )
      ]
    }
  ) });
}
function t3({
  fill: t = "white",
  size: n = "x1_5",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ C(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Maximize",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            d: "M21 9V3H15",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M3 15V21H9",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M21 3L13.5 10.5",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M10.5 13.5L3 21",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  ) });
}
function n3({
  fill: t = "white",
  size: n = "x1_5",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ C(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Minimize",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            d: "M10 20V14H4",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M14 4V10H20",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M10 14L2.5 21.5",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M21.5 2.5L14 10",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  ) });
}
function o3({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "20",
      height: "14",
      viewBox: "0 0 20 14",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Camera",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M3.16406 13.5312C2.16406 13.5312 1.38542 13.2656 0.828125 12.7344C0.276042 12.2083 0 11.4531 0 10.4688V3.57031C0 2.59115 0.286458 1.83073 0.859375 1.28906C1.43229 0.742188 2.20052 0.46875 3.16406 0.46875H11.2891C12.2891 0.46875 13.0651 0.742188 13.6172 1.28906C14.1693 1.83073 14.4453 2.59115 14.4453 3.57031V10.4219C14.4453 11.4062 14.1693 12.1693 13.6172 12.7109C13.0651 13.2578 12.2891 13.5312 11.2891 13.5312H3.16406ZM3.41406 12.1328H11.0312C11.6406 12.1328 12.112 11.9714 12.4453 11.6484C12.7839 11.3255 12.9531 10.8438 12.9531 10.2031V3.79688C12.9531 3.15625 12.7865 2.67448 12.4531 2.35156C12.1198 2.02344 11.6458 1.85938 11.0312 1.85938H3.41406C2.80469 1.85938 2.33073 2.02083 1.99219 2.34375C1.65885 2.66667 1.49219 3.15104 1.49219 3.79688V10.2031C1.49219 10.8438 1.65885 11.3255 1.99219 11.6484C2.33073 11.9714 2.80469 12.1328 3.41406 12.1328ZM14.1875 4.77344L17.2656 2.16406C17.4479 2.01302 17.6302 1.89062 17.8125 1.79688C18 1.70312 18.1875 1.65625 18.375 1.65625C18.7344 1.65625 19.0234 1.77344 19.2422 2.00781C19.4661 2.24219 19.5781 2.55208 19.5781 2.9375V11.0938C19.5781 11.4792 19.4661 11.7917 19.2422 12.0312C19.0234 12.2656 18.7344 12.3828 18.375 12.3828C18.1875 12.3828 18 12.3359 17.8125 12.2422C17.6302 12.1484 17.4479 12.0234 17.2656 11.8672L14.1875 9.25781V7.60156L17.8516 10.6016C17.888 10.6224 17.9193 10.6432 17.9453 10.6641C17.9714 10.6797 18 10.6875 18.0312 10.6875C18.1146 10.6875 18.1562 10.6302 18.1562 10.5156V3.52344C18.1562 3.40365 18.1146 3.34375 18.0312 3.34375C18 3.34375 17.9714 3.35417 17.9453 3.375C17.9193 3.39062 17.888 3.41146 17.8516 3.4375L14.1875 6.4375V4.77344Z",
          fill: t
        }
      )
    }
  ) });
}
function r3({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "12",
      height: "18",
      viewBox: "0 0 12 18",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Microphone",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M0 8.82031V7.27344C0 7.07031 0.0729167 6.89844 0.21875 6.75781C0.364583 6.61719 0.536458 6.54688 0.734375 6.54688C0.942708 6.54688 1.11979 6.61719 1.26562 6.75781C1.41146 6.89844 1.48438 7.07031 1.48438 7.27344V8.76562C1.48438 9.65104 1.66927 10.4271 2.03906 11.0938C2.41406 11.7552 2.9375 12.2682 3.60938 12.6328C4.28125 12.9974 5.0599 13.1797 5.94531 13.1797C6.83594 13.1797 7.61458 12.9974 8.28125 12.6328C8.94792 12.2682 9.46875 11.7552 9.84375 11.0938C10.2188 10.4271 10.4062 9.65104 10.4062 8.76562V7.27344C10.4062 7.07031 10.4792 6.89844 10.625 6.75781C10.7708 6.61719 10.9453 6.54688 11.1484 6.54688C11.3516 6.54688 11.5234 6.61719 11.6641 6.75781C11.8099 6.89844 11.8828 7.07031 11.8828 7.27344V8.82031C11.8828 9.89323 11.6615 10.8411 11.2188 11.6641C10.776 12.487 10.1615 13.1458 9.375 13.6406C8.59375 14.1354 7.6901 14.4323 6.66406 14.5312V16.1328H9.53125C9.73438 16.1328 9.90885 16.2031 10.0547 16.3438C10.2005 16.4896 10.2734 16.6641 10.2734 16.8672C10.2734 17.0651 10.2005 17.2344 10.0547 17.375C9.90885 17.5208 9.73438 17.5938 9.53125 17.5938H2.35938C2.15625 17.5938 1.98177 17.5208 1.83594 17.375C1.6901 17.2344 1.61719 17.0651 1.61719 16.8672C1.61719 16.6641 1.6901 16.4896 1.83594 16.3438C1.98177 16.2031 2.15625 16.1328 2.35938 16.1328H5.22656V14.5312C4.20052 14.4323 3.29427 14.1354 2.50781 13.6406C1.72135 13.1458 1.10677 12.487 0.664062 11.6641C0.221354 10.8411 0 9.89323 0 8.82031ZM2.95312 8.47656V3.60156C2.95312 2.97656 3.08073 2.42448 3.33594 1.94531C3.59115 1.46615 3.94271 1.09115 4.39062 0.820312C4.84375 0.544271 5.36198 0.40625 5.94531 0.40625C6.52865 0.40625 7.04427 0.544271 7.49219 0.820312C7.94531 1.09115 8.29688 1.46615 8.54688 1.94531C8.80208 2.42448 8.92969 2.97656 8.92969 3.60156V8.47656C8.92969 9.10156 8.80208 9.65365 8.54688 10.1328C8.29688 10.612 7.94531 10.9896 7.49219 11.2656C7.04427 11.5365 6.52865 11.6719 5.94531 11.6719C5.36198 11.6719 4.84375 11.5365 4.39062 11.2656C3.94271 10.9896 3.59115 10.612 3.33594 10.1328C3.08073 9.65365 2.95312 9.10156 2.95312 8.47656ZM4.4375 8.5C4.4375 9.02083 4.57292 9.44271 4.84375 9.76562C5.11979 10.0833 5.48698 10.2422 5.94531 10.2422C6.40885 10.2422 6.77344 10.0833 7.03906 9.76562C7.3099 9.44271 7.44531 9.02083 7.44531 8.5V3.57812C7.44531 3.05729 7.3099 2.63802 7.03906 2.32031C6.77344 1.9974 6.40885 1.83594 5.94531 1.83594C5.48698 1.83594 5.11979 1.9974 4.84375 2.32031C4.57292 2.63802 4.4375 3.05729 4.4375 3.57812V8.5Z",
          fill: t
        }
      )
    }
  ) });
}
function i3({
  fill: t = "white",
  size: n = "x3",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "41",
      height: "41",
      viewBox: "0 0 41 41",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Microphone",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M20.3711 40.7422C9.14062 40.7422 0 31.6016 0 20.3711C0 9.12109 9.14062 0 20.3711 0C31.6211 0 40.7422 9.12109 40.7422 20.3711C40.7422 31.6016 31.6211 40.7422 20.3711 40.7422ZM20.3711 23.9844C22.3633 23.9844 23.9258 22.4414 23.9258 20.293V12.0312C23.9258 9.88281 22.3633 8.33984 20.3711 8.33984C18.3984 8.33984 16.8164 9.86328 16.8164 12.0117V20.293C16.8164 22.4414 18.3984 23.9844 20.3711 23.9844ZM15.3516 32.4414H25.4102C26.0938 32.4414 26.6992 31.875 26.6992 31.2109C26.6992 30.5078 26.0938 29.9219 25.4102 29.9219H21.6211V28.1836C25.6641 27.6758 28.5352 24.6875 28.5352 20.4883V18.0273C28.5352 17.3438 27.9492 16.7969 27.2656 16.7969C26.582 16.7969 25.9961 17.3438 25.9961 18.0273V20.4688C25.9961 23.6133 23.5938 25.8984 20.3711 25.8984C17.1484 25.8984 14.7461 23.6133 14.7461 20.4688V18.0273C14.7461 17.3438 14.1797 16.7969 13.4766 16.7969C12.793 16.7969 12.2266 17.3438 12.2266 18.0273V20.4883C12.2266 24.6875 15.0977 27.6953 19.1406 28.1836V29.9219H15.3516C14.6484 29.9219 14.0625 30.5078 14.0625 31.2109C14.0625 31.875 14.6484 32.4414 15.3516 32.4414Z",
          fill: t
        }
      )
    }
  ) });
}
function a3({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Report",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M5.27344 17.0703C4.96094 17.0703 4.71615 16.9688 4.53906 16.7656C4.36719 16.5625 4.28125 16.2865 4.28125 15.9375V14.0156H3.85938C3.10417 14.0156 2.45573 13.8698 1.91406 13.5781C1.3776 13.2865 0.963542 12.8698 0.671875 12.3281C0.385417 11.7812 0.242188 11.1198 0.242188 10.3438V4.28125C0.242188 3.50521 0.385417 2.84635 0.671875 2.30469C0.958333 1.75781 1.3724 1.33854 1.91406 1.04688C2.46094 0.755208 3.1276 0.609375 3.91406 0.609375H14.0781C14.8594 0.609375 15.5234 0.755208 16.0703 1.04688C16.6172 1.33854 17.0339 1.75781 17.3203 2.30469C17.6068 2.84635 17.75 3.50521 17.75 4.28125V10.3438C17.75 11.1198 17.6068 11.7812 17.3203 12.3281C17.0339 12.8698 16.6172 13.2865 16.0703 13.5781C15.5234 13.8698 14.8594 14.0156 14.0781 14.0156H9.25L6.57812 16.3828C6.3125 16.6172 6.08333 16.7891 5.89062 16.8984C5.69792 17.013 5.49219 17.0703 5.27344 17.0703ZM5.65625 15.3438L8.13281 12.8906C8.29948 12.724 8.45312 12.6146 8.59375 12.5625C8.73958 12.5052 8.93229 12.4766 9.17188 12.4766H14.0312C14.7708 12.4766 15.3177 12.2943 15.6719 11.9297C16.0312 11.5599 16.2109 11.013 16.2109 10.2891V4.32812C16.2109 3.60938 16.0312 3.06771 15.6719 2.70312C15.3177 2.33333 14.7708 2.14844 14.0312 2.14844H3.95312C3.21875 2.14844 2.67188 2.33333 2.3125 2.70312C1.95833 3.06771 1.78125 3.60938 1.78125 4.32812V10.2891C1.78125 11.013 1.95833 11.5599 2.3125 11.9297C2.67188 12.2943 3.21875 12.4766 3.95312 12.4766H5.02344C5.24219 12.4766 5.40104 12.526 5.5 12.625C5.60417 12.7188 5.65625 12.8828 5.65625 13.1172V15.3438ZM9 8.60938C8.54688 8.60938 8.3125 8.38021 8.29688 7.92188L8.1875 4.125C8.17708 3.89583 8.2474 3.70833 8.39844 3.5625C8.54948 3.41667 8.74479 3.34375 8.98438 3.34375C9.22396 3.34375 9.42188 3.41927 9.57812 3.57031C9.73438 3.71615 9.80729 3.90104 9.79688 4.125L9.67188 7.92188C9.66146 8.38021 9.4375 8.60938 9 8.60938ZM9 11.2031C8.74479 11.2031 8.52604 11.1224 8.34375 10.9609C8.16667 10.7943 8.07812 10.5885 8.07812 10.3438C8.07812 10.099 8.16667 9.89583 8.34375 9.73438C8.52604 9.56771 8.74479 9.48438 9 9.48438C9.25 9.48438 9.46354 9.5651 9.64062 9.72656C9.82292 9.88802 9.91406 10.0938 9.91406 10.3438C9.91406 10.5938 9.82292 10.7995 9.64062 10.9609C9.45833 11.1224 9.24479 11.2031 9 11.2031Z",
          fill: t
        }
      )
    }
  ) });
}
function w1({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "13",
      height: "14",
      viewBox: "0 0 13 14",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Check",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M4.9585 13.3538C4.60693 13.3538 4.30664 13.1975 4.05762 12.885L0.263672 8.13892C0.170898 8.02661 0.102539 7.91675 0.0585938 7.80933C0.0195312 7.7019 0 7.59204 0 7.47974C0 7.22583 0.0830078 7.01587 0.249023 6.84985C0.419922 6.68384 0.634766 6.60083 0.893555 6.60083C1.19141 6.60083 1.44287 6.73511 1.64795 7.00366L4.9292 11.2151L11.2866 1.11499C11.3989 0.944092 11.5137 0.824463 11.6309 0.756104C11.748 0.682861 11.8994 0.64624 12.085 0.64624C12.3389 0.64624 12.5464 0.726807 12.7075 0.887939C12.8687 1.04419 12.9492 1.24927 12.9492 1.50317C12.9492 1.60571 12.9321 1.71069 12.8979 1.81812C12.8638 1.92065 12.8101 2.03052 12.7368 2.14771L5.85205 12.8777C5.63721 13.1951 5.33936 13.3538 4.9585 13.3538Z",
          fill: t
        }
      )
    }
  ) });
}
function l3({ size: t = "x1", ...n }) {
  return /* @__PURE__ */ e(g, { ...n, size: t });
}
function c3({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "17",
      fill: "none",
      role: "img",
      "aria-label": "Calendar",
      children: /* @__PURE__ */ e(
        "path",
        {
          fill: t,
          d: "M3.25 15.164c-.844 0-1.482-.216-1.914-.648-.432-.428-.649-1.058-.649-1.891V3.117c0-.838.217-1.471.649-1.898.432-.427 1.07-.64 1.914-.64H14c.849 0 1.487.213 1.914.64.432.427.649 1.06.649 1.898V7.5a2.172 2.172 0 0 0-.375-.047 4.611 4.611 0 0 0-.774 0 5.68 5.68 0 0 0-.39.047V5.39c0-.338-.09-.593-.266-.765-.172-.172-.422-.258-.75-.258H3.234c-.328 0-.578.086-.75.258-.171.172-.257.427-.257.766v7.218c0 .339.086.594.257.766.172.167.422.25.75.25h7.579c.046.276.12.544.218.805.1.26.222.505.367.734H3.25Zm3.867-8.086c-.135 0-.232-.026-.289-.078-.057-.052-.086-.146-.086-.281v-.461c0-.14.029-.237.086-.29.057-.051.154-.077.29-.077h.46c.14 0 .237.026.29.078.056.052.085.148.085.289v.46c0 .136-.029.23-.086.282-.052.052-.148.078-.289.078h-.46Zm2.563 0c-.146 0-.245-.026-.297-.078-.052-.052-.078-.146-.078-.281v-.461c0-.14.026-.237.078-.29.052-.051.15-.077.297-.077h.453c.14 0 .237.026.289.078.057.052.086.148.086.289v.46c0 .136-.029.23-.086.282-.052.052-.149.078-.29.078H9.68Zm2.547 0c-.141 0-.24-.026-.297-.078-.052-.052-.078-.146-.078-.281v-.461c0-.14.026-.237.078-.29.057-.051.156-.077.297-.077h.46c.141 0 .238.026.29.078.052.052.078.148.078.289v.46c0 .136-.026.23-.078.282-.053.052-.149.078-.29.078h-.46ZM4.562 9.586c-.14 0-.24-.024-.296-.07-.052-.052-.079-.149-.079-.29v-.46c0-.136.027-.23.079-.282.057-.052.156-.078.296-.078h.461c.141 0 .237.026.29.078.052.052.078.146.078.282v.46c0 .141-.026.238-.079.29-.052.046-.148.07-.289.07h-.46Zm2.555 0c-.135 0-.232-.024-.289-.07-.057-.052-.086-.149-.086-.29v-.46c0-.136.029-.23.086-.282.057-.052.154-.078.29-.078h.46c.14 0 .237.026.29.078.056.052.085.146.085.282v.46c0 .141-.029.238-.086.29-.052.046-.148.07-.289.07h-.46Zm2.563 0c-.146 0-.245-.024-.297-.07-.052-.052-.078-.149-.078-.29v-.46c0-.136.026-.23.078-.282.052-.052.15-.078.297-.078h.453c.14 0 .237.026.289.078.057.052.086.146.086.282v.46c0 .141-.029.238-.086.29-.052.046-.149.07-.29.07H9.68Zm-5.117 2.523c-.141 0-.24-.026-.297-.078-.052-.052-.079-.148-.079-.289v-.46c0-.136.027-.23.079-.282.057-.052.156-.078.296-.078h.461c.141 0 .237.026.29.078.052.052.078.146.078.281v.461c0 .14-.026.237-.079.29-.052.051-.148.077-.289.077h-.46Zm2.554 0c-.135 0-.232-.026-.289-.078-.057-.052-.086-.148-.086-.289v-.46c0-.136.029-.23.086-.282.057-.052.154-.078.29-.078h.46c.14 0 .237.026.29.078.056.052.085.146.085.281v.461c0 .14-.029.237-.086.29-.052.051-.148.077-.289.077h-.46Zm2.563 0c-.146 0-.245-.026-.297-.078-.052-.052-.078-.148-.078-.289v-.46c0-.136.026-.23.078-.282.052-.052.15-.078.297-.078h.453c.14 0 .237.026.289.078.057.052.086.146.086.281v.461c0 .14-.029.237-.086.29-.052.051-.149.077-.29.077H9.68Zm6.125 4.477c-.552 0-1.07-.104-1.555-.313a4.003 4.003 0 0 1-1.281-.875 4.179 4.179 0 0 1-.875-1.28 3.892 3.892 0 0 1-.313-1.556c0-.552.104-1.07.313-1.554a4.18 4.18 0 0 1 .875-1.281c.37-.375.797-.667 1.281-.875a3.893 3.893 0 0 1 1.555-.313c.552 0 1.07.104 1.554.313a4.068 4.068 0 0 1 2.149 2.156 3.81 3.81 0 0 1 .32 1.555c0 .546-.107 1.062-.32 1.546-.209.49-.5.92-.875 1.29-.37.37-.8.658-1.29.867-.484.213-.997.32-1.538.32Zm0-1.477c.161 0 .289-.05.383-.148a.518.518 0 0 0 .148-.383v-1.484h1.484a.534.534 0 0 0 .383-.14.528.528 0 0 0 .149-.392c0-.161-.05-.289-.149-.382a.518.518 0 0 0-.383-.149h-1.484v-1.484a.518.518 0 0 0-.148-.383.502.502 0 0 0-.383-.148.528.528 0 0 0-.39.148.534.534 0 0 0-.142.383v1.484H13.79a.518.518 0 0 0-.383.149.502.502 0 0 0-.148.383c0 .161.05.291.148.39.1.094.227.14.383.14h1.484v1.485c0 .156.047.284.141.383.099.099.23.148.39.148Z"
        }
      )
    }
  ) });
}
function s3({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Link",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M9.34375 6.00781C9.79688 6.09115 10.1823 6.21615 10.5 6.38281C10.8229 6.54948 11.099 6.75 11.3281 6.98438C11.974 7.625 12.4036 8.33333 12.6172 9.10938C12.8307 9.88542 12.8281 10.6615 12.6094 11.4375C12.3958 12.2083 11.9714 12.9141 11.3359 13.5547L8.61719 16.2734C7.98177 16.9089 7.27604 17.3333 6.5 17.5469C5.72917 17.7656 4.95573 17.7682 4.17969 17.5547C3.40365 17.3411 2.6901 16.9089 2.03906 16.2578C1.39844 15.6172 0.96875 14.9089 0.75 14.1328C0.536458 13.3568 0.536458 12.5833 0.75 11.8125C0.96875 11.0365 1.39583 10.3281 2.03125 9.6875L4.28125 7.45312C4.20833 7.76042 4.1901 8.08073 4.22656 8.41406C4.26302 8.74219 4.34375 9.04688 4.46875 9.32812L3.13281 10.6641C2.69531 11.1016 2.40365 11.5859 2.25781 12.1172C2.11198 12.6484 2.11198 13.1797 2.25781 13.7109C2.40365 14.2422 2.69792 14.7292 3.14062 15.1719C3.57812 15.6146 4.0625 15.9062 4.59375 16.0469C5.125 16.1927 5.65625 16.1927 6.1875 16.0469C6.71875 15.901 7.20312 15.6094 7.64062 15.1719L10.2422 12.5781C10.6797 12.1406 10.9688 11.6562 11.1094 11.125C11.2552 10.5938 11.2552 10.0625 11.1094 9.53125C10.9635 9 10.6693 8.51302 10.2266 8.07031C9.99219 7.83073 9.70573 7.63802 9.36719 7.49219C9.02865 7.34635 8.625 7.2526 8.15625 7.21094L9.34375 6.00781ZM8.64844 12.5938C8.19531 12.5104 7.80729 12.3854 7.48438 12.2188C7.16667 12.0521 6.89583 11.8542 6.67188 11.625C6.02083 10.9792 5.58854 10.2682 5.375 9.49219C5.16146 8.71615 5.16146 7.94271 5.375 7.17188C5.59375 6.39583 6.02344 5.6875 6.66406 5.04688L9.36719 2.33594C10.0078 1.69531 10.7135 1.26823 11.4844 1.05469C12.2604 0.835938 13.0365 0.833333 13.8125 1.04688C14.5885 1.26042 15.3021 1.69271 15.9531 2.34375C16.5938 2.98438 17.0208 3.69271 17.2344 4.46875C17.4531 5.24479 17.4531 6.02083 17.2344 6.79688C17.0208 7.57292 16.5964 8.27865 15.9609 8.91406L13.7188 11.1484C13.7865 10.8464 13.8021 10.5312 13.7656 10.2031C13.7292 9.86979 13.6484 9.5599 13.5234 9.27344L14.8594 7.9375C15.2969 7.5 15.5885 7.01823 15.7344 6.49219C15.8854 5.96094 15.8854 5.42969 15.7344 4.89844C15.5885 4.36198 15.2969 3.875 14.8594 3.4375C14.4115 2.98958 13.9219 2.69531 13.3906 2.55469C12.8646 2.40885 12.3359 2.40885 11.8047 2.55469C11.2786 2.70052 10.7917 2.99479 10.3438 3.4375L7.75781 6.02344C7.3151 6.46094 7.02083 6.94531 6.875 7.47656C6.72917 8.00781 6.72917 8.53906 6.875 9.07031C7.02083 9.60156 7.31771 10.0911 7.76562 10.5391C8.00521 10.7734 8.29167 10.9635 8.625 11.1094C8.96354 11.2552 9.36719 11.3516 9.83594 11.3984L8.64844 12.5938Z",
          fill: t
        }
      )
    }
  ) });
}
function C3({
  fill: t = "white",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Settings",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M0.601562 10.2734C0.601562 9.90885 0.692708 9.57552 0.875 9.27344C1.05729 8.96615 1.29948 8.72135 1.60156 8.53906C1.90365 8.35677 2.23958 8.26562 2.60938 8.26562C2.97917 8.26562 3.3151 8.35677 3.61719 8.53906C3.92448 8.72135 4.16927 8.96615 4.35156 9.27344C4.53385 9.57552 4.625 9.90885 4.625 10.2734C4.625 10.6432 4.53385 10.9818 4.35156 11.2891C4.16927 11.5911 3.92448 11.8333 3.61719 12.0156C3.3151 12.1927 2.97917 12.2812 2.60938 12.2812C2.23958 12.2812 1.90365 12.1927 1.60156 12.0156C1.29948 11.8333 1.05729 11.5911 0.875 11.2891C0.692708 10.9818 0.601562 10.6432 0.601562 10.2734ZM1.65625 10.2734C1.65625 10.5495 1.75 10.7786 1.9375 10.9609C2.125 11.1432 2.35156 11.2344 2.61719 11.2344C2.88281 11.2344 3.10938 11.1432 3.29688 10.9609C3.48438 10.7786 3.57812 10.5495 3.57812 10.2734C3.57812 10.0078 3.48438 9.78385 3.29688 9.60156C3.10938 9.41406 2.88281 9.32031 2.61719 9.32031C2.35156 9.32031 2.125 9.41406 1.9375 9.60156C1.75 9.78385 1.65625 10.0078 1.65625 10.2734ZM2.61719 0.914062C2.82031 0.914062 2.99479 0.986979 3.14062 1.13281C3.28646 1.27344 3.35938 1.44792 3.35938 1.65625V8.91406H1.86719V1.65625C1.86719 1.44792 1.9401 1.27344 2.08594 1.13281C2.23698 0.986979 2.41406 0.914062 2.61719 0.914062ZM2.61719 15.1094C2.41406 15.1094 2.23698 15.0391 2.08594 14.8984C1.9401 14.7578 1.86719 14.5911 1.86719 14.3984V11.7266H3.35938V14.3984C3.35938 14.5911 3.28646 14.7578 3.14062 14.8984C2.99479 15.0391 2.82031 15.1094 2.61719 15.1094ZM5.98438 5.66406C5.98438 5.29427 6.07552 4.95833 6.25781 4.65625C6.44531 4.35417 6.6901 4.11198 6.99219 3.92969C7.29948 3.7474 7.63542 3.65625 8 3.65625C8.36979 3.65625 8.70573 3.7474 9.00781 3.92969C9.3151 4.11198 9.55729 4.35417 9.73438 4.65625C9.91667 4.95833 10.0078 5.29427 10.0078 5.66406C10.0078 6.03385 9.91667 6.3724 9.73438 6.67969C9.55729 6.98177 9.3151 7.22396 9.00781 7.40625C8.70573 7.58333 8.36979 7.67188 8 7.67188C7.63542 7.67188 7.29948 7.58073 6.99219 7.39844C6.6901 7.21615 6.44531 6.97396 6.25781 6.67188C6.07552 6.36979 5.98438 6.03385 5.98438 5.66406ZM7.04688 5.66406C7.04688 5.9349 7.13802 6.16406 7.32031 6.35156C7.50781 6.53385 7.73438 6.625 8 6.625C8.27083 6.625 8.4974 6.53385 8.67969 6.35156C8.86719 6.16406 8.96094 5.9349 8.96094 5.66406C8.96094 5.39844 8.86719 5.17188 8.67969 4.98438C8.4974 4.79688 8.27083 4.70312 8 4.70312C7.73438 4.70312 7.50781 4.79688 7.32031 4.98438C7.13802 5.17188 7.04688 5.39844 7.04688 5.66406ZM8 0.914062C8.20833 0.914062 8.38542 0.984375 8.53125 1.125C8.67708 1.26562 8.75 1.43229 8.75 1.625V4.24219H7.25781V1.625C7.25781 1.43229 7.33073 1.26562 7.47656 1.125C7.6224 0.984375 7.79688 0.914062 8 0.914062ZM8 15.1094C7.79688 15.1094 7.6224 15.0365 7.47656 14.8906C7.33073 14.75 7.25781 14.5755 7.25781 14.3672V7.00781H8.75V14.3672C8.75 14.5755 8.67708 14.75 8.53125 14.8906C8.38542 15.0365 8.20833 15.1094 8 15.1094ZM11.3828 10.2734C11.3828 9.90885 11.474 9.57552 11.6562 9.27344C11.8385 8.96615 12.0807 8.72135 12.3828 8.53906C12.6849 8.35677 13.0208 8.26562 13.3906 8.26562C13.7604 8.26562 14.0964 8.35677 14.3984 8.53906C14.7057 8.72135 14.9479 8.96615 15.125 9.27344C15.3073 9.57552 15.3984 9.90885 15.3984 10.2734C15.3984 10.6432 15.3073 10.9818 15.125 11.2891C14.9479 11.5911 14.7057 11.8333 14.3984 12.0156C14.0964 12.1927 13.7604 12.2812 13.3906 12.2812C13.0208 12.2812 12.6849 12.1927 12.3828 12.0156C12.0807 11.8333 11.8385 11.5911 11.6562 11.2891C11.474 10.9818 11.3828 10.6432 11.3828 10.2734ZM12.4375 10.2734C12.4375 10.5495 12.5286 10.7786 12.7109 10.9609C12.8984 11.1432 13.125 11.2344 13.3906 11.2344C13.6667 11.2344 13.8958 11.1432 14.0781 10.9609C14.2604 10.7786 14.3516 10.5495 14.3516 10.2734C14.3516 10.0078 14.2604 9.78385 14.0781 9.60156C13.8958 9.41406 13.6667 9.32031 13.3906 9.32031C13.125 9.32031 12.8984 9.41406 12.7109 9.60156C12.5286 9.78385 12.4375 10.0078 12.4375 10.2734ZM13.3906 0.914062C13.5938 0.914062 13.7682 0.986979 13.9141 1.13281C14.0599 1.27344 14.1328 1.44792 14.1328 1.65625V8.94531H12.6484V1.65625C12.6484 1.44792 12.7214 1.27344 12.8672 1.13281C13.013 0.986979 13.1875 0.914062 13.3906 0.914062ZM13.3906 15.1094C13.1875 15.1094 13.013 15.0391 12.8672 14.8984C12.7214 14.7578 12.6484 14.5911 12.6484 14.3984V11.6328H14.1328V14.3984C14.1328 14.5911 14.0599 14.7578 13.9141 14.8984C13.7682 15.0391 13.5938 15.1094 13.3906 15.1094Z",
          fill: t
        }
      )
    }
  ) });
}
function d3({
  fill: t = "white",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "20",
      height: "15",
      viewBox: "0 0 20 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Toggle sidebar",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M13.7422 11.9844C13.5234 11.9844 13.3646 11.9349 13.2656 11.8359C13.1719 11.737 13.125 11.5755 13.125 11.3516V3.38281C13.125 3.15885 13.1719 2.9974 13.2656 2.89844C13.3646 2.79948 13.5234 2.75 13.7422 2.75H15.9609C16.1797 2.75 16.3359 2.79948 16.4297 2.89844C16.5286 2.9974 16.5781 3.15885 16.5781 3.38281V11.3516C16.5781 11.5755 16.5286 11.737 16.4297 11.8359C16.3359 11.9349 16.1797 11.9844 15.9609 11.9844H13.7422ZM3.30469 14.6562C2.46094 14.6562 1.82292 14.4427 1.39062 14.0156C0.958333 13.5885 0.742188 12.9583 0.742188 12.125V2.60938C0.742188 1.77604 0.958333 1.14583 1.39062 0.71875C1.82292 0.286458 2.46094 0.0703125 3.30469 0.0703125H16.6797C17.5286 0.0703125 18.1693 0.286458 18.6016 0.71875C19.0339 1.14583 19.25 1.77604 19.25 2.60938V12.125C19.25 12.9583 19.0339 13.5885 18.6016 14.0156C18.1693 14.4427 17.5286 14.6562 16.6797 14.6562H3.30469ZM3.39844 13.125H16.5938C16.9531 13.125 17.2292 13.0312 17.4219 12.8438C17.6146 12.651 17.7109 12.3672 17.7109 11.9922V2.74219C17.7109 2.36719 17.6146 2.08594 17.4219 1.89844C17.2292 1.70573 16.9531 1.60938 16.5938 1.60938H3.39844C3.03385 1.60938 2.75521 1.70573 2.5625 1.89844C2.375 2.08594 2.28125 2.36719 2.28125 2.74219V11.9922C2.28125 12.3672 2.375 12.651 2.5625 12.8438C2.75521 13.0312 3.03385 13.125 3.39844 13.125Z",
          fill: t
        }
      )
    }
  ) });
}
function u3({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "14",
      height: "16",
      viewBox: "0 0 14 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Up",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M6.99219 15.8047C6.70573 15.8047 6.47135 15.7135 6.28906 15.5312C6.11198 15.349 6.02344 15.1094 6.02344 14.8125V5.54688L6.125 2.83594L6.69531 3.16406L4.23438 5.95312L2.46875 7.70312C2.38021 7.79167 2.27865 7.86198 2.16406 7.91406C2.04948 7.96615 1.92188 7.99219 1.78125 7.99219C1.51562 7.99219 1.29427 7.90365 1.11719 7.72656C0.940104 7.54948 0.851562 7.32552 0.851562 7.05469C0.851562 6.79427 0.953125 6.5599 1.15625 6.35156L6.27344 1.21875C6.36719 1.125 6.47656 1.05208 6.60156 1C6.73177 0.947917 6.86198 0.921875 6.99219 0.921875C7.1276 0.921875 7.25781 0.947917 7.38281 1C7.51302 1.05208 7.625 1.125 7.71875 1.21875L12.8359 6.35156C13.0391 6.5599 13.1406 6.79427 13.1406 7.05469C13.1406 7.32552 13.0521 7.54948 12.875 7.72656C12.6979 7.90365 12.4766 7.99219 12.2109 7.99219C12.0703 7.99219 11.9401 7.96615 11.8203 7.91406C11.7057 7.86198 11.6042 7.79167 11.5156 7.70312L9.75 5.95312L7.28125 3.16406L7.85938 2.83594L7.96094 5.54688V14.8125C7.96094 15.1094 7.86979 15.349 7.6875 15.5312C7.51042 15.7135 7.27865 15.8047 6.99219 15.8047Z",
          fill: t
        }
      )
    }
  ) });
}
function f1({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "14",
      height: "13",
      viewBox: "0 0 14 13",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "X",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M0.953125 12.4062C0.838542 12.2969 0.763021 12.1667 0.726562 12.0156C0.690104 11.8646 0.690104 11.7135 0.726562 11.5625C0.768229 11.4115 0.84375 11.2839 0.953125 11.1797L5.75 6.36719L0.953125 1.5625C0.84375 1.45833 0.770833 1.33073 0.734375 1.17969C0.697917 1.02865 0.697917 0.877604 0.734375 0.726562C0.770833 0.575521 0.84375 0.445312 0.953125 0.335938C1.06771 0.221354 1.20052 0.145833 1.35156 0.109375C1.5026 0.0729167 1.65365 0.0729167 1.80469 0.109375C1.95573 0.145833 2.08594 0.21875 2.19531 0.328125L7 5.13281L11.7969 0.328125C11.9062 0.213542 12.0365 0.140625 12.1875 0.109375C12.3385 0.0729167 12.487 0.0729167 12.6328 0.109375C12.7839 0.145833 12.9193 0.221354 13.0391 0.335938C13.1484 0.445312 13.2214 0.575521 13.2578 0.726562C13.2995 0.877604 13.2995 1.02865 13.2578 1.17969C13.2214 1.32552 13.1484 1.45573 13.0391 1.57031L8.24219 6.36719L13.0391 11.1719C13.1484 11.2865 13.2214 11.4193 13.2578 11.5703C13.2943 11.7161 13.2943 11.8646 13.2578 12.0156C13.2214 12.1667 13.1484 12.2969 13.0391 12.4062C12.9245 12.5208 12.7917 12.5964 12.6406 12.6328C12.4896 12.6693 12.3385 12.6693 12.1875 12.6328C12.0365 12.5964 11.9062 12.5234 11.7969 12.4141L7 7.60938L2.19531 12.4141C2.08594 12.5234 1.95573 12.5964 1.80469 12.6328C1.65885 12.6693 1.50781 12.6693 1.35156 12.6328C1.20052 12.5964 1.06771 12.5208 0.953125 12.4062Z",
          fill: t
        }
      )
    }
  ) });
}
function h3({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      viewBox: "0 0 16 15",
      width: "100%",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Heart",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M8 14.7734C7.92188 14.7734 7.82813 14.75 7.71875 14.7031C7.61458 14.6615 7.52083 14.6146 7.4375 14.5625C5.96875 13.625 4.69531 12.6432 3.61719 11.6172C2.53906 10.5859 1.70573 9.52865 1.11719 8.44531C0.533854 7.35677 0.242188 6.25781 0.242188 5.14844C0.242188 4.45573 0.351563 3.82292 0.570313 3.25C0.794271 2.67187 1.10417 2.17187 1.5 1.75C1.89583 1.32812 2.35677 1.0026 2.88281 0.773437C3.40885 0.544271 3.97917 0.429687 4.59375 0.429687C5.35938 0.429687 6.03125 0.625 6.60938 1.01562C7.1875 1.40625 7.65104 1.92187 8 2.5625C8.35417 1.91667 8.82031 1.40104 9.39844 1.01562C9.97656 0.625 10.6458 0.429687 11.4063 0.429687C12.0208 0.429687 12.5911 0.544271 13.1172 0.773437C13.6484 1.0026 14.1094 1.32812 14.5 1.75C14.8958 2.17187 15.2031 2.67187 15.4219 3.25C15.6458 3.82292 15.7578 4.45573 15.7578 5.14844C15.7578 6.25781 15.4635 7.35677 14.875 8.44531C14.2917 9.52865 13.4609 10.5859 12.3828 11.6172C11.3099 12.6432 10.0391 13.625 8.57031 14.5625C8.48698 14.6146 8.39063 14.6615 8.28125 14.7031C8.17708 14.75 8.08333 14.7734 8 14.7734Z",
          fill: t,
          fillOpacity: "0.96"
        }
      )
    }
  ) });
}
function m3({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "16",
      height: "15",
      viewBox: "0 0 16 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Plugins",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M2.38281 6.75781C1.82031 6.75781 1.39844 6.61979 1.11719 6.34375C0.841146 6.0625 0.703125 5.63021 0.703125 5.04688V1.78125C0.703125 1.20312 0.841146 0.773438 1.11719 0.492188C1.39844 0.210938 1.82031 0.0703125 2.38281 0.0703125H5.70312C6.26562 0.0703125 6.6875 0.210938 6.96875 0.492188C7.25 0.773438 7.39062 1.20312 7.39062 1.78125V5.04688C7.39062 5.63021 7.25 6.0625 6.96875 6.34375C6.6875 6.61979 6.26562 6.75781 5.70312 6.75781H2.38281ZM2.39844 5.46875H5.6875C5.82292 5.46875 5.92448 5.4349 5.99219 5.36719C6.0651 5.29427 6.10156 5.1875 6.10156 5.04688V1.77344C6.10156 1.63281 6.0651 1.52865 5.99219 1.46094C5.92448 1.39323 5.82292 1.35938 5.6875 1.35938H2.39844C2.25781 1.35938 2.15365 1.39323 2.08594 1.46094C2.02344 1.52865 1.99219 1.63281 1.99219 1.77344V5.04688C1.99219 5.1875 2.02344 5.29427 2.08594 5.36719C2.15365 5.4349 2.25781 5.46875 2.39844 5.46875ZM10.2891 6.75781C9.72656 6.75781 9.30469 6.61979 9.02344 6.34375C8.74219 6.0625 8.60156 5.63021 8.60156 5.04688V1.78125C8.60156 1.20312 8.74219 0.773438 9.02344 0.492188C9.30469 0.210938 9.72656 0.0703125 10.2891 0.0703125H13.6094C14.1719 0.0703125 14.5911 0.210938 14.8672 0.492188C15.1484 0.773438 15.2891 1.20312 15.2891 1.78125V5.04688C15.2891 5.63021 15.1484 6.0625 14.8672 6.34375C14.5911 6.61979 14.1719 6.75781 13.6094 6.75781H10.2891ZM10.3047 5.46875H13.5938C13.7344 5.46875 13.8359 5.4349 13.8984 5.36719C13.9661 5.29427 14 5.1875 14 5.04688V1.77344C14 1.63281 13.9661 1.52865 13.8984 1.46094C13.8359 1.39323 13.7344 1.35938 13.5938 1.35938H10.3047C10.1641 1.35938 10.0599 1.39323 9.99219 1.46094C9.92448 1.52865 9.89062 1.63281 9.89062 1.77344V5.04688C9.89062 5.1875 9.92448 5.29427 9.99219 5.36719C10.0599 5.4349 10.1641 5.46875 10.3047 5.46875ZM2.38281 14.6562C1.82031 14.6562 1.39844 14.5156 1.11719 14.2344C0.841146 13.9583 0.703125 13.5286 0.703125 12.9453V9.6875C0.703125 9.10938 0.841146 8.67969 1.11719 8.39844C1.39844 8.11719 1.82031 7.97656 2.38281 7.97656H5.70312C6.26562 7.97656 6.6875 8.11719 6.96875 8.39844C7.25 8.67969 7.39062 9.10938 7.39062 9.6875V12.9453C7.39062 13.5286 7.25 13.9583 6.96875 14.2344C6.6875 14.5156 6.26562 14.6562 5.70312 14.6562H2.38281ZM2.39844 13.3672H5.6875C5.82292 13.3672 5.92448 13.3333 5.99219 13.2656C6.0651 13.2031 6.10156 13.1016 6.10156 12.9609V9.6875C6.10156 9.54688 6.0651 9.44271 5.99219 9.375C5.92448 9.30208 5.82292 9.26562 5.6875 9.26562H2.39844C2.25781 9.26562 2.15365 9.30208 2.08594 9.375C2.02344 9.44271 1.99219 9.54688 1.99219 9.6875V12.9609C1.99219 13.1016 2.02344 13.2031 2.08594 13.2656C2.15365 13.3333 2.25781 13.3672 2.39844 13.3672ZM10.2891 14.6562C9.72656 14.6562 9.30469 14.5156 9.02344 14.2344C8.74219 13.9583 8.60156 13.5286 8.60156 12.9453V9.6875C8.60156 9.10938 8.74219 8.67969 9.02344 8.39844C9.30469 8.11719 9.72656 7.97656 10.2891 7.97656H13.6094C14.1719 7.97656 14.5911 8.11719 14.8672 8.39844C15.1484 8.67969 15.2891 9.10938 15.2891 9.6875V12.9453C15.2891 13.5286 15.1484 13.9583 14.8672 14.2344C14.5911 14.5156 14.1719 14.6562 13.6094 14.6562H10.2891ZM10.3047 13.3672H13.5938C13.7344 13.3672 13.8359 13.3333 13.8984 13.2656C13.9661 13.2031 14 13.1016 14 12.9609V9.6875C14 9.54688 13.9661 9.44271 13.8984 9.375C13.8359 9.30208 13.7344 9.26562 13.5938 9.26562H10.3047C10.1641 9.26562 10.0599 9.30208 9.99219 9.375C9.92448 9.44271 9.89062 9.54688 9.89062 9.6875V12.9609C9.89062 13.1016 9.92448 13.2031 9.99219 13.2656C10.0599 13.3333 10.1641 13.3672 10.3047 13.3672Z",
          fill: t
        }
      )
    }
  ) });
}
function s2({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "18",
      height: "17",
      viewBox: "0 0 18 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Record Off",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M8.99219 16.4297C7.8776 16.4297 6.83333 16.2188 5.85938 15.7969C4.88542 15.3802 4.02865 14.8021 3.28906 14.0625C2.54948 13.3281 1.96875 12.474 1.54688 11.5C1.13021 10.5208 0.921875 9.47396 0.921875 8.35938C0.921875 7.24479 1.13021 6.20052 1.54688 5.22656C1.96875 4.2474 2.54948 3.38802 3.28906 2.64844C4.02865 1.90885 4.88542 1.33073 5.85938 0.914062C6.83333 0.497396 7.8776 0.289062 8.99219 0.289062C10.1068 0.289062 11.151 0.497396 12.125 0.914062C13.1042 1.33073 13.9635 1.90885 14.7031 2.64844C15.4427 3.38802 16.0208 4.2474 16.4375 5.22656C16.8594 6.20052 17.0703 7.24479 17.0703 8.35938C17.0703 9.47396 16.8594 10.5208 16.4375 11.5C16.0208 12.474 15.4427 13.3281 14.7031 14.0625C13.9635 14.8021 13.1042 15.3802 12.125 15.7969C11.151 16.2188 10.1068 16.4297 8.99219 16.4297ZM8.99219 14.8359C9.88802 14.8359 10.7266 14.6667 11.5078 14.3281C12.2891 13.9948 12.9766 13.5312 13.5703 12.9375C14.1693 12.3438 14.6354 11.6562 14.9688 10.875C15.3021 10.0938 15.4688 9.25521 15.4688 8.35938C15.4688 7.46354 15.3021 6.625 14.9688 5.84375C14.6354 5.05729 14.1693 4.36979 13.5703 3.78125C12.9766 3.1875 12.2891 2.72396 11.5078 2.39062C10.7266 2.05208 9.88802 1.88281 8.99219 1.88281C8.10156 1.88281 7.26302 2.05208 6.47656 2.39062C5.69531 2.72396 5.00781 3.1875 4.41406 3.78125C3.82031 4.36979 3.35417 5.05729 3.01562 5.84375C2.68229 6.625 2.51562 7.46354 2.51562 8.35938C2.51562 9.25521 2.68229 10.0938 3.01562 10.875C3.35417 11.6562 3.82031 12.3438 4.41406 12.9375C5.00781 13.5312 5.69531 13.9948 6.47656 14.3281C7.26302 14.6667 8.10156 14.8359 8.99219 14.8359ZM9 11.4062C8.4375 11.4062 7.92188 11.2682 7.45312 10.9922C6.98958 10.7161 6.61979 10.3464 6.34375 9.88281C6.06771 9.41927 5.92969 8.90625 5.92969 8.34375C5.92969 7.78125 6.06771 7.26823 6.34375 6.80469C6.61979 6.34115 6.98958 5.97135 7.45312 5.69531C7.92188 5.41406 8.4375 5.27344 9 5.27344C9.5625 5.27344 10.0729 5.41406 10.5312 5.69531C10.9948 5.97135 11.3646 6.34115 11.6406 6.80469C11.9167 7.26823 12.0547 7.78125 12.0547 8.34375C12.0547 8.90625 11.9167 9.41927 11.6406 9.88281C11.3646 10.3464 10.9948 10.7161 10.5312 10.9922C10.0729 11.2682 9.5625 11.4062 9 11.4062Z",
          fill: t
        }
      )
    }
  ) });
}
function C2({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "18",
      height: "17",
      viewBox: "0 0 18 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Record On",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M9 16.4297C4.54688 16.4297 0.929688 12.8125 0.929688 8.35938C0.929688 3.90625 4.54688 0.289062 9 0.289062C13.4531 0.289062 17.0703 3.90625 17.0703 8.35938C17.0703 12.8125 13.4531 16.4297 9 16.4297ZM9 11.5312C10.7578 11.5312 12.1875 10.1094 12.1875 8.34375C12.1875 6.58594 10.7578 5.16406 9 5.16406C7.24219 5.16406 5.8125 6.58594 5.8125 8.34375C5.8125 10.1094 7.24219 11.5312 9 11.5312Z",
          fill: t
        }
      )
    }
  ) });
}
function p3({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Settings",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M3.91406 15.9531C3.27344 15.9531 2.6901 15.8125 2.16406 15.5312C1.64323 15.25 1.22917 14.8594 0.921875 14.3594C0.614583 13.8594 0.460938 13.2812 0.460938 12.625C0.460938 11.9688 0.614583 11.3906 0.921875 10.8906C1.22917 10.3906 1.64323 10 2.16406 9.71875C2.6901 9.4375 3.27344 9.29688 3.91406 9.29688H12.0859C12.7266 9.29688 13.3073 9.4375 13.8281 9.71875C14.3542 10 14.7708 10.3906 15.0781 10.8906C15.3854 11.3906 15.5391 11.9688 15.5391 12.625C15.5391 13.2812 15.3854 13.8594 15.0781 14.3594C14.7708 14.8594 14.3542 15.25 13.8281 15.5312C13.3073 15.8125 12.7266 15.9531 12.0859 15.9531H3.91406ZM12.2891 14.5547C12.6432 14.5547 12.9661 14.4688 13.2578 14.2969C13.5495 14.125 13.7812 13.8906 13.9531 13.5938C14.125 13.2917 14.2135 12.9635 14.2188 12.6094C14.224 12.2552 14.138 11.9349 13.9609 11.6484C13.7891 11.3568 13.5547 11.125 13.2578 10.9531C12.9661 10.776 12.6432 10.6875 12.2891 10.6875C11.9297 10.6875 11.6042 10.776 11.3125 10.9531C11.0208 11.125 10.7891 11.3568 10.6172 11.6484C10.4453 11.9401 10.3594 12.263 10.3594 12.6172C10.3594 12.9766 10.4453 13.3021 10.6172 13.5938C10.7891 13.8854 11.0208 14.1172 11.3125 14.2891C11.6042 14.4609 11.9297 14.5495 12.2891 14.5547ZM4.23438 8.10156C3.53125 8.10156 2.89323 7.94792 2.32031 7.64062C1.7526 7.33333 1.29948 6.90365 0.960938 6.35156C0.627604 5.79948 0.460938 5.15885 0.460938 4.42969C0.460938 3.69531 0.627604 3.05208 0.960938 2.5C1.29948 1.94792 1.7526 1.52083 2.32031 1.21875C2.89323 0.911458 3.53125 0.757812 4.23438 0.757812H11.7656C12.4688 0.757812 13.1042 0.911458 13.6719 1.21875C14.2448 1.52083 14.6979 1.94792 15.0312 2.5C15.3698 3.05208 15.5391 3.69531 15.5391 4.42969C15.5391 5.15885 15.3698 5.79948 15.0312 6.35156C14.6979 6.90365 14.2448 7.33333 13.6719 7.64062C13.1042 7.94792 12.4688 8.10156 11.7656 8.10156H4.23438ZM4.23438 6.69531H11.7656C12.1875 6.69531 12.5781 6.59896 12.9375 6.40625C13.2969 6.21354 13.5859 5.94792 13.8047 5.60938C14.0234 5.27083 14.1328 4.8776 14.1328 4.42969C14.1328 3.98177 14.0234 3.58854 13.8047 3.25C13.5859 2.90625 13.2969 2.64062 12.9375 2.45312C12.5781 2.26042 12.1875 2.16406 11.7656 2.16406H4.23438C3.8125 2.16406 3.42188 2.26042 3.0625 2.45312C2.70312 2.64062 2.41406 2.90625 2.19531 3.25C1.97656 3.58854 1.86719 3.98177 1.86719 4.42969C1.86719 4.8776 1.97656 5.27083 2.19531 5.60938C2.41406 5.94792 2.70312 6.21354 3.0625 6.40625C3.42188 6.59896 3.8125 6.69531 4.23438 6.69531ZM4.23438 6.17188C3.91146 6.17188 3.61719 6.09375 3.35156 5.9375C3.08594 5.78125 2.875 5.57031 2.71875 5.30469C2.56771 5.03906 2.49219 4.74479 2.49219 4.42188C2.49219 4.09896 2.56771 3.80469 2.71875 3.53906C2.875 3.27344 3.08594 3.0625 3.35156 2.90625C3.61719 2.75 3.91146 2.67188 4.23438 2.67188C4.5625 2.67188 4.85938 2.75 5.125 2.90625C5.39583 3.0625 5.60938 3.27344 5.76562 3.53906C5.92188 3.79948 5.9974 4.09115 5.99219 4.41406C5.99219 4.73698 5.91146 5.03385 5.75 5.30469C5.59375 5.57031 5.38281 5.78385 5.11719 5.94531C4.85677 6.10156 4.5625 6.17708 4.23438 6.17188Z",
          fill: t
        }
      )
    }
  ) });
}
function d2({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "14",
      height: "13",
      viewBox: "0 0 14 13",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Plus",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M0.869629 6.71191C0.869629 6.4873 0.950195 6.29443 1.11133 6.1333C1.27246 5.96729 1.46533 5.88428 1.68994 5.88428H6.17969V1.40186C6.17969 1.17725 6.26025 0.984375 6.42139 0.823242C6.58252 0.662109 6.77539 0.581543 7 0.581543C7.22949 0.581543 7.4248 0.662109 7.58594 0.823242C7.74707 0.984375 7.82764 1.17725 7.82764 1.40186V5.88428H12.3101C12.5347 5.88428 12.7275 5.96729 12.8887 6.1333C13.0498 6.29443 13.1304 6.4873 13.1304 6.71191C13.1304 6.94141 13.0498 7.13672 12.8887 7.29785C12.7275 7.4541 12.5347 7.53223 12.3101 7.53223H7.82764V12.0293C7.82764 12.249 7.74707 12.4395 7.58594 12.6006C7.4248 12.7617 7.22949 12.8423 7 12.8423C6.77539 12.8423 6.58252 12.7617 6.42139 12.6006C6.26025 12.4395 6.17969 12.249 6.17969 12.0293V7.53223H1.68994C1.46533 7.53223 1.27246 7.4541 1.11133 7.29785C0.950195 7.13672 0.869629 6.94141 0.869629 6.71191Z",
          fill: t
        }
      )
    }
  ) });
}
function g3({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "External Link",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M11.6172 8.39844C11.6172 8.65885 11.5312 8.8776 11.3594 9.05469C11.1875 9.22656 10.9818 9.3125 10.7422 9.3125C10.5078 9.3125 10.3073 9.22656 10.1406 9.05469C9.97917 8.8776 9.89844 8.66667 9.89844 8.42188V5.64062L10.0156 2.76562L8.82812 4.09375L1.90625 11.0156C1.71875 11.2031 1.50781 11.2969 1.27344 11.2969C1.11719 11.2969 0.971354 11.2526 0.835938 11.1641C0.700521 11.0807 0.588542 10.9714 0.5 10.8359C0.416667 10.7005 0.375 10.5547 0.375 10.3984C0.375 10.1693 0.46875 9.95833 0.65625 9.76562L7.57031 2.84375L8.90625 1.67188L5.91406 1.77344H3.25C3.01042 1.77344 2.80208 1.69271 2.625 1.53125C2.44792 1.36458 2.35938 1.16406 2.35938 0.929688C2.35938 0.695312 2.44531 0.492188 2.61719 0.320312C2.78906 0.148438 3.00521 0.0625 3.26562 0.0625H10.6875C10.9688 0.0625 11.1927 0.148438 11.3594 0.320312C11.526 0.492188 11.6094 0.713542 11.6094 0.984375L11.6172 8.39844Z",
          fill: t
        }
      )
    }
  ) });
}
function v3({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "22",
      height: "21",
      viewBox: "0 0 22 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Chat",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M6.12695 20.8867C5.82747 20.8867 5.59635 20.7891 5.43359 20.5938C5.27083 20.4049 5.18945 20.1478 5.18945 19.8223V17.0098H4.57422C3.63021 17.0098 2.81966 16.8307 2.14258 16.4727C1.47201 16.1081 0.954427 15.5872 0.589844 14.9102C0.231771 14.2266 0.0527344 13.3997 0.0527344 12.4297V4.85156C0.0527344 3.88151 0.231771 3.05794 0.589844 2.38086C0.947917 1.69727 1.46549 1.17318 2.14258 0.808594C2.82617 0.44401 3.65951 0.261719 4.64258 0.261719H17.3477C18.3242 0.261719 19.1543 0.44401 19.8379 0.808594C20.5215 1.17318 21.0423 1.69727 21.4004 2.38086C21.7585 3.05794 21.9375 3.88151 21.9375 4.85156V12.4297C21.9375 13.3997 21.7585 14.2266 21.4004 14.9102C21.0423 15.5872 20.5215 16.1081 19.8379 16.4727C19.1543 16.8307 18.3242 17.0098 17.3477 17.0098H10.9023L7.32812 20.2422C7.08073 20.4635 6.86914 20.6263 6.69336 20.7305C6.51758 20.8346 6.32878 20.8867 6.12695 20.8867Z",
          fill: t
        }
      )
    }
  ) });
}
function w3({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "23",
      height: "22",
      viewBox: "0 0 23 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Chat",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M6.78711 21.2109C6.30534 21.2109 5.92773 21.0579 5.6543 20.752C5.38086 20.446 5.24414 20.026 5.24414 19.4922V17.3242H4.61914C3.71419 17.3242 2.91341 17.1322 2.2168 16.748C1.52669 16.3574 0.983073 15.804 0.585938 15.0879C0.195312 14.3717 0 13.5189 0 12.5293V4.79492C0 3.80534 0.192057 2.95247 0.576172 2.23633C0.960286 1.52018 1.50716 0.970052 2.2168 0.585938C2.93294 0.195312 3.78906 0 4.78516 0H17.7148C18.7109 0 19.5671 0.195312 20.2832 0.585938C20.9993 0.970052 21.5462 1.52018 21.9238 2.23633C22.3079 2.95247 22.5 3.80534 22.5 4.79492V12.5293C22.5 13.5189 22.3079 14.3717 21.9238 15.0879C21.5462 15.804 20.9993 16.3574 20.2832 16.748C19.5671 17.1322 18.7109 17.3242 17.7148 17.3242H12.0996L8.79883 20.2148C8.39518 20.5664 8.04036 20.8203 7.73438 20.9766C7.4349 21.1328 7.11914 21.2109 6.78711 21.2109ZM7.39258 18.418L10.4492 15.4102C10.6901 15.1693 10.9082 15.0098 11.1035 14.9316C11.3053 14.847 11.5755 14.8047 11.9141 14.8047H17.5684C18.3757 14.8047 18.9779 14.6029 19.375 14.1992C19.7786 13.7891 19.9805 13.1836 19.9805 12.3828V4.94141C19.9805 4.14062 19.7786 3.53841 19.375 3.13477C18.9779 2.72461 18.3757 2.51953 17.5684 2.51953H4.94141C4.1276 2.51953 3.51888 2.72461 3.11523 3.13477C2.7181 3.53841 2.51953 4.14062 2.51953 4.94141V12.3828C2.51953 13.1836 2.7181 13.7891 3.11523 14.1992C3.51888 14.6029 4.1276 14.8047 4.94141 14.8047H6.49414C6.78711 14.8047 7.00846 14.873 7.1582 15.0098C7.31445 15.1465 7.39258 15.3776 7.39258 15.7031V18.418Z",
          fill: t,
          fillOpacity: "0.96"
        }
      )
    }
  ) });
}
function f3({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Public",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M7.99268 14.6846C7.47998 14.6846 6.99658 14.5088 6.54248 14.1572C6.08838 13.8105 5.69043 13.3223 5.34863 12.6924C5.00684 12.0625 4.73828 11.3252 4.54297 10.4805C4.34766 9.63574 4.25 8.71777 4.25 7.72656C4.25 6.73535 4.34766 5.81494 4.54297 4.96533C4.73828 4.11572 5.00684 3.37598 5.34863 2.74609C5.69043 2.11621 6.08594 1.62793 6.53516 1.28125C6.98926 0.929688 7.4751 0.753906 7.99268 0.753906C8.51514 0.753906 9.00098 0.929688 9.4502 1.28125C9.9043 1.62793 10.3022 2.11621 10.644 2.74609C10.9907 3.37598 11.2593 4.11572 11.4497 4.96533C11.6401 5.81494 11.7354 6.73535 11.7354 7.72656C11.7354 8.71777 11.6377 9.63574 11.4424 10.4805C11.252 11.3252 10.9834 12.0625 10.6367 12.6924C10.2949 13.3223 9.89697 13.8105 9.44287 14.1572C8.99365 14.5088 8.51025 14.6846 7.99268 14.6846ZM7.99268 1.70605C7.64111 1.70605 7.30176 1.86719 6.97461 2.18945C6.65234 2.51172 6.36426 2.95361 6.11035 3.51514C5.86133 4.07178 5.66357 4.71387 5.51709 5.44141C5.37061 6.16406 5.29736 6.92578 5.29736 7.72656C5.29736 8.52246 5.37061 9.2793 5.51709 9.99707C5.66357 10.7148 5.86133 11.3545 6.11035 11.916C6.36426 12.4727 6.65234 12.9121 6.97461 13.2344C7.30176 13.5615 7.64111 13.7251 7.99268 13.7251C8.34424 13.7251 8.68115 13.5615 9.00342 13.2344C9.33057 12.9121 9.62109 12.4702 9.875 11.9087C10.1289 11.3472 10.3291 10.7075 10.4756 9.98975C10.6221 9.27197 10.6953 8.51758 10.6953 7.72656C10.6953 6.92578 10.6221 6.16406 10.4756 5.44141C10.3291 4.71387 10.1289 4.07178 9.875 3.51514C9.62109 2.95361 9.33057 2.51172 9.00342 2.18945C8.68115 1.86719 8.34424 1.70605 7.99268 1.70605ZM7.4873 0.849121H8.5127V14.5454H7.4873V0.849121ZM7.99268 10.2827C8.75928 10.2827 9.48438 10.3462 10.168 10.4731C10.8516 10.5952 11.4644 10.771 12.0063 11.0005C12.5532 11.23 12.9951 11.501 13.332 11.8135L12.5483 12.458C12.231 12.2139 11.8428 12.0063 11.3838 11.8354C10.9297 11.6597 10.417 11.5278 9.8457 11.4399C9.27441 11.3472 8.65674 11.3008 7.99268 11.3008C7.3335 11.3008 6.71582 11.3472 6.13965 11.4399C5.56836 11.5278 5.05322 11.6597 4.59424 11.8354C4.14014 12.0063 3.75684 12.2139 3.44434 12.458L2.66064 11.8135C2.99756 11.501 3.43701 11.23 3.979 11.0005C4.521 10.771 5.13379 10.5952 5.81738 10.4731C6.50586 10.3462 7.23096 10.2827 7.99268 10.2827ZM14.709 7.19922V8.21729H1.28369V7.19922H14.709ZM7.99268 5.17773C7.23096 5.17773 6.50586 5.1167 5.81738 4.99463C5.13379 4.86768 4.521 4.68945 3.979 4.45996C3.43701 4.23047 2.99756 3.95947 2.66064 3.64697L3.44434 3.00244C3.76172 3.24658 4.14746 3.45654 4.60156 3.63232C5.05566 3.80322 5.56836 3.93506 6.13965 4.02783C6.71582 4.11572 7.3335 4.15967 7.99268 4.15967C8.65674 4.15967 9.27441 4.11572 9.8457 4.02783C10.417 3.93506 10.9297 3.80322 11.3838 3.63232C11.8428 3.45654 12.231 3.24658 12.5483 3.00244L13.332 3.64697C12.9951 3.95947 12.5532 4.23047 12.0063 4.45996C11.4644 4.68945 10.8516 4.86768 10.168 4.99463C9.48438 5.1167 8.75928 5.17773 7.99268 5.17773ZM7.99268 15.2778C6.94775 15.2778 5.96875 15.0801 5.05566 14.6846C4.14258 14.2939 3.33936 13.752 2.646 13.0586C1.95264 12.3701 1.4082 11.5693 1.0127 10.6562C0.62207 9.73828 0.426758 8.75684 0.426758 7.71191C0.426758 6.66699 0.62207 5.68799 1.0127 4.7749C1.4082 3.85693 1.95264 3.05127 2.646 2.35791C3.33936 1.66455 4.14258 1.12256 5.05566 0.731934C5.96875 0.341309 6.94775 0.145996 7.99268 0.145996C9.0376 0.145996 10.0166 0.341309 10.9297 0.731934C11.8477 1.12256 12.6533 1.66455 13.3467 2.35791C14.04 3.05127 14.582 3.85693 14.9727 4.7749C15.3682 5.68799 15.5659 6.66699 15.5659 7.71191C15.5659 8.75684 15.3682 9.73828 14.9727 10.6562C14.582 11.5693 14.04 12.3701 13.3467 13.0586C12.6533 13.752 11.8477 14.2939 10.9297 14.6846C10.0166 15.0801 9.0376 15.2778 7.99268 15.2778ZM7.99268 14.106C8.87646 14.106 9.7041 13.9375 10.4756 13.6006C11.2471 13.2686 11.9258 12.812 12.5117 12.231C13.0977 11.645 13.5566 10.9663 13.8887 10.1948C14.2207 9.42334 14.3867 8.5957 14.3867 7.71191C14.3867 6.82812 14.2207 6.00049 13.8887 5.229C13.5566 4.45752 13.0977 3.77881 12.5117 3.19287C11.9258 2.60693 11.2471 2.14795 10.4756 1.81592C9.7041 1.48389 8.87646 1.31787 7.99268 1.31787C7.11377 1.31787 6.28857 1.48389 5.51709 1.81592C4.74561 2.14795 4.06445 2.60693 3.47363 3.19287C2.8877 3.77881 2.42871 4.45752 2.09668 5.229C1.76953 6.00049 1.60596 6.82812 1.60596 7.71191C1.60596 8.5957 1.76953 9.42334 2.09668 10.1948C2.42871 10.9663 2.8877 11.645 3.47363 12.231C4.06445 12.812 4.74561 13.2686 5.51709 13.6006C6.28857 13.9375 7.11377 14.106 7.99268 14.106Z",
          fill: t
        }
      )
    }
  ) });
}
function M3({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "12",
      height: "15",
      viewBox: "0 0 12 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Private",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M6 11.1396C5.85352 11.1396 5.73877 11.0981 5.65576 11.0151C5.57275 10.9272 5.52881 10.8125 5.52393 10.6709L5.45068 8.46631C5.45068 8.31494 5.49951 8.19043 5.59717 8.09277C5.69971 7.99512 5.83398 7.94629 6 7.94629C6.16113 7.94629 6.29297 7.99512 6.39551 8.09277C6.49805 8.19043 6.54688 8.31738 6.54199 8.47363L6.46875 10.6709C6.46387 10.8125 6.41992 10.9272 6.33691 11.0151C6.25391 11.0981 6.1416 11.1396 6 11.1396ZM6 12.7949C5.82422 12.7949 5.67529 12.7363 5.55322 12.6191C5.43604 12.4971 5.37744 12.353 5.37744 12.187C5.37744 12.0161 5.43604 11.8721 5.55322 11.7549C5.67529 11.6377 5.82422 11.5791 6 11.5791C6.17578 11.5791 6.32471 11.6377 6.44678 11.7549C6.56885 11.8672 6.62988 12.0112 6.62988 12.187C6.62988 12.353 6.56885 12.4971 6.44678 12.6191C6.32471 12.7363 6.17578 12.7949 6 12.7949ZM2.57227 14.8237C2.01562 14.8237 1.59326 14.6724 1.30518 14.3696C1.01709 14.0718 0.873047 13.6226 0.873047 13.022V7.8291C0.873047 7.2334 1.01709 6.78662 1.30518 6.48877C1.59326 6.19092 2.01562 6.04199 2.57227 6.04199H9.42773C9.98438 6.04199 10.4067 6.19092 10.6948 6.48877C10.9829 6.78662 11.127 7.2334 11.127 7.8291V13.022C11.127 13.6226 10.9829 14.0718 10.6948 14.3696C10.4067 14.6724 9.98438 14.8237 9.42773 14.8237H2.57227ZM2.77734 13.5054H9.22266C9.37402 13.5054 9.49121 13.459 9.57422 13.3662C9.65723 13.2783 9.69873 13.1465 9.69873 12.9707V7.8877C9.69873 7.71191 9.65723 7.58008 9.57422 7.49219C9.49121 7.4043 9.37402 7.36035 9.22266 7.36035H2.77734C2.63086 7.36035 2.51367 7.4043 2.42578 7.49219C2.34277 7.58008 2.30127 7.71191 2.30127 7.8877V12.9707C2.30127 13.1465 2.34277 13.2783 2.42578 13.3662C2.51367 13.459 2.63086 13.5054 2.77734 13.5054ZM2.21338 6.65723V4.32812C2.21338 3.4248 2.38916 2.67041 2.74072 2.06494C3.09717 1.45459 3.56348 0.995605 4.13965 0.687988C4.71582 0.380371 5.33594 0.226562 6 0.226562C6.66406 0.226562 7.28418 0.380371 7.86035 0.687988C8.43652 0.995605 8.90039 1.45459 9.25195 2.06494C9.6084 2.67041 9.78662 3.4248 9.78662 4.32812V6.65723H8.41699V4.19629C8.41699 3.625 8.30469 3.14404 8.08008 2.75342C7.86035 2.35791 7.56738 2.05762 7.20117 1.85254C6.83496 1.64746 6.43457 1.54492 6 1.54492C5.56543 1.54492 5.16504 1.64746 4.79883 1.85254C4.43262 2.05762 4.13965 2.35791 3.91992 2.75342C3.7002 3.14404 3.59033 3.625 3.59033 4.19629V6.65723H2.21338Z",
          fill: t
        }
      )
    }
  ) });
}
function x3({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "18",
      height: "23",
      viewBox: "0 0 18 23",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Recordings",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M3.77686 22.3047C2.7749 22.3047 2.01725 22.048 1.50391 21.5347C0.99056 21.0275 0.733887 20.2791 0.733887 19.2896V8.7876C0.733887 7.79183 0.99056 7.04036 1.50391 6.5332C2.01725 6.02604 2.7749 5.77246 3.77686 5.77246H14.2231C15.2189 5.77246 15.9735 6.02604 16.4868 6.5332C17.0063 7.04036 17.2661 7.79183 17.2661 8.7876V19.2896C17.2661 20.2729 17.0187 21.0213 16.5239 21.5347C16.0291 22.048 15.3395 22.3047 14.4551 22.3047H3.77686ZM3.88818 20.4771H14.3345C14.6499 20.4771 14.9128 20.3626 15.123 20.1338C15.3333 19.9111 15.4385 19.5741 15.4385 19.1226V8.93604C15.4385 8.49072 15.321 8.15674 15.0859 7.93408C14.8571 7.70524 14.5293 7.59082 14.1025 7.59082H3.88818C3.45524 7.59082 3.12435 7.70524 2.89551 7.93408C2.67285 8.15674 2.56152 8.49072 2.56152 8.93604V19.1226C2.56152 19.5741 2.67285 19.9111 2.89551 20.1338C3.12435 20.3626 3.45524 20.4771 3.88818 20.4771ZM2.78418 4.30664C2.84603 3.86133 2.99756 3.51807 3.23877 3.27686C3.48617 3.03564 3.85726 2.91504 4.35205 2.91504H13.5737C14.0685 2.91504 14.4365 3.03564 14.6777 3.27686C14.9251 3.51807 15.0828 3.86133 15.1509 4.30664H2.78418ZM4.37988 1.60693C4.40462 1.18636 4.54069 0.867839 4.78809 0.651367C5.03548 0.434896 5.38184 0.32666 5.82715 0.32666H12.0986C12.5501 0.32666 12.8965 0.434896 13.1377 0.651367C13.3851 0.867839 13.5243 1.18636 13.5552 1.60693H4.37988ZM7.37646 17.7124C7.20947 17.8114 7.04248 17.8547 6.87549 17.8423C6.71468 17.8237 6.57861 17.7619 6.46729 17.6567C6.35596 17.5454 6.30029 17.4001 6.30029 17.2207V10.9399C6.30029 10.7606 6.35596 10.6183 6.46729 10.5132C6.57861 10.408 6.71777 10.3493 6.88477 10.3369C7.05794 10.3184 7.22184 10.3555 7.37646 10.4482L12.5347 13.5005C12.6831 13.5871 12.7821 13.7077 12.8315 13.8623C12.881 14.0107 12.881 14.1623 12.8315 14.3169C12.7882 14.4653 12.6893 14.5859 12.5347 14.6787L7.37646 17.7124Z",
          fill: t
        }
      )
    }
  ) });
}
function b3({
  fill: t = "currentColor",
  size: n = "x1",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ e(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Pencil",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M13.267 0.732957C12.7971 0.263624 12.1601 0 11.496 0C10.8318 0 10.1948 0.263624 9.72491 0.732957L1.35828 9.09908C1.07375 9.3833 0.87381 9.741 0.78077 10.1322L0.0142493 13.3535C-0.00650514 13.4408 -0.00455926 13.5319 0.0199014 13.6182C0.0443621 13.7045 0.090522 13.7831 0.153979 13.8464C0.217435 13.9098 0.296073 13.9559 0.382391 13.9803C0.46871 14.0046 0.559832 14.0065 0.647066 13.9856L3.86785 13.2184C4.25937 13.1255 4.61735 12.9256 4.90178 12.641L13.267 4.27624C13.7364 3.80637 14 3.16941 14 2.5053C14 1.84118 13.7364 1.20423 13.267 0.734357M10.4669 1.47633C10.6021 1.34121 10.7625 1.23402 10.939 1.16089C11.1156 1.08776 11.3048 1.05012 11.496 1.05012C11.6871 1.05012 11.8763 1.08776 12.0529 1.16089C12.2294 1.23402 12.3898 1.34121 12.525 1.47633C12.6601 1.61146 12.7673 1.77188 12.8404 1.94843C12.9136 2.12498 12.9512 2.3142 12.9512 2.5053C12.9512 2.69639 12.9136 2.88562 12.8404 3.06217C12.7673 3.23872 12.6601 3.39914 12.525 3.53426L11.9006 4.15654L9.84251 2.09931L10.4669 1.47633ZM9.10049 2.84269L11.1585 4.89922L4.15836 11.899C4.01136 12.046 3.82655 12.1489 3.62425 12.1972L1.23298 12.767L1.8021 10.3758C1.8504 10.1728 1.954 9.98805 2.101 9.84105L9.10049 2.84269Z",
          fill: t
        }
      )
    }
  ) });
}
function H3({
  fill: t = "currentColor",
  size: n = "x1_25",
  ...o
}) {
  return /* @__PURE__ */ e(g, { ...o, size: n, children: /* @__PURE__ */ C(
    "svg",
    {
      width: "20",
      height: "16",
      viewBox: "0 0 20 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Layout",
      children: [
        /* @__PURE__ */ e(
          "rect",
          {
            x: "0.5",
            y: "0.5",
            width: "19",
            height: "15",
            rx: "2.5",
            stroke: t,
            strokeOpacity: "0.6"
          }
        ),
        /* @__PURE__ */ e(
          "rect",
          {
            x: "1",
            y: "3",
            width: "7",
            height: "1.5",
            rx: "0.75",
            fill: t
          }
        ),
        /* @__PURE__ */ e(
          "rect",
          {
            x: "1",
            y: "7",
            width: "7",
            height: "1.5",
            rx: "0.75",
            fill: t
          }
        ),
        /* @__PURE__ */ e(
          "rect",
          {
            x: "1",
            y: "11",
            width: "7",
            height: "1.5",
            rx: "0.75",
            fill: t
          }
        ),
        /* @__PURE__ */ e("rect", { x: "11", y: "2", width: "8", height: "12", rx: "1.5", fill: t })
      ]
    }
  ) });
}
function g(t) {
  const { className: n, size: o, ...r } = t;
  return /* @__PURE__ */ e(
    "div",
    {
      ...r,
      className: b(F1.iconWrap, n, F1[o])
    }
  );
}
const K8 = {
  DollarSignIcon: R5,
  DotDotDotIcon: I5,
  DotDotDotVerticalIcon: _5,
  EmojiIcon: P5,
  ExclamationMarkIcon: T5,
  LargeExclamationMarkIcon: m1,
  ScreenIcon: z5,
  WindowIcon: E5,
  MutedMicrophoneIcon: t2,
  UnmutedMicrophoneIcon: n2,
  MutedSpeakerIcon: D5,
  UnmutedSpeakerIcon: o2,
  MutedCameraIcon: r2,
  UnmutedCameraIcon: i2,
  PlusIcon: O5,
  ClockIcon: j5,
  CaretIcon: B5,
  DownCaretIcon: F5,
  CopyIcon: W5,
  LargeCopyIcon: U5,
  ShareIcon: J5,
  SmallShareIcon: Y5,
  ShareIconArrow: G5,
  EyeIcon: K5,
  RightCaretIcon: a2,
  LeftCaretIcon: A5,
  InfoIcon: Q5,
  OutlinedInfoIcon: l2,
  EditIcon: X5,
  TrashCanIcon: q5,
  SettingsIcon: $5,
  WarningIcon: c2,
  ScreenShareIcon: e3,
  MaximizeIcon: t3,
  MinimizeIcon: n3,
  SmallCameraIcon: o3,
  SmallMicrophoneIcon: r3,
  LargeMicrophoneIcon: i3,
  ReportIcon: a3,
  CheckMarkIcon: w1,
  BlankIcon: l3,
  CalendarIcon: c3,
  LinkIcon: s3,
  KnobsIcon: C3,
  SidebarIcon: d3,
  UpArrowIcon: u3,
  CloseIcon: f1,
  HeartIcon: h3,
  PluginsIcon: m3,
  RecordOffIcon: s2,
  RecordOnIcon: C2,
  SwitchesIcon: p3,
  PlusIconPlain: d2,
  ExternalLinkIcon: g3,
  ChatIcon: v3,
  ChatIconOutline: w3,
  PublicIcon: f3,
  PrivateIcon: M3,
  RecordingsIcon: x3,
  PencilIcon: b3,
  LayoutIcon: H3
}, L3 = "Switch-module__root__1vFcs", Z3 = "Switch-module__input__cdY9I", V3 = "Switch-module__track__kidGD", y3 = "Switch-module__thumb__444cU", S3 = "Switch-module__disabled__MwbfB", a1 = {
  root: L3,
  input: Z3,
  track: V3,
  thumb: y3,
  disabled: S3
}, N3 = ({
  checked: t,
  disabled: n = !1,
  onChange: o,
  className: r,
  id: l,
  name: i,
  ...u
}) => {
  const a = C1(), d = l ?? a, c = t1(() => !!t, [t]);
  return /* @__PURE__ */ C(
    "label",
    {
      className: b(a1.root, n && a1.disabled, r),
      htmlFor: d,
      "data-checked": c ? "true" : "false",
      children: [
        /* @__PURE__ */ e(
          "input",
          {
            ...u,
            id: d,
            name: i,
            type: "checkbox",
            className: a1.input,
            checked: t,
            disabled: n,
            onChange: (s) => {
              const h = s.target.checked;
              o?.(h);
            },
            "aria-checked": c,
            role: "switch"
          }
        ),
        /* @__PURE__ */ e("span", { className: a1.track, "aria-hidden": !0, children: /* @__PURE__ */ e("span", { className: a1.thumb }) })
      ]
    }
  );
}, A8 = ({
  className: t,
  label: n,
  devicesList: o = [],
  selectedDevice: r,
  onDeviceSelect: l,
  isEnabled: i,
  onEnableChange: u,
  onClose: a,
  hasAccessToDevices: d,
  onAllowAccess: c
}) => /* @__PURE__ */ C("div", { className: b(E.root, t), children: [
  d && (o.length > 0 ? /* @__PURE__ */ C(p1, { children: [
    /* @__PURE__ */ C("div", { className: E.switchContainer, children: [
      /* @__PURE__ */ e("span", { className: E.title, children: n }),
      /* @__PURE__ */ e(
        N3,
        {
          checked: i,
          onChange: (s) => u(s)
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { className: E.separator }),
    /* @__PURE__ */ e("span", { className: E.listTitle, children: "Devices" }),
    /* @__PURE__ */ e(e2, { className: E.devicesList, children: o.map((s) => /* @__PURE__ */ C(
      W,
      {
        type: "button",
        className: E.device,
        onClick: () => l(s),
        children: [
          /* @__PURE__ */ e("span", { className: E.deviceName, children: s.label }),
          /* @__PURE__ */ e("div", { children: r?.deviceId === s.deviceId && /* @__PURE__ */ e(
            w1,
            {
              className: E.icon,
              fill: "var(--tv-ui-color-9)",
              size: "x1_5"
            }
          ) })
        ]
      },
      s.deviceId
    )) })
  ] }) : /* @__PURE__ */ C(B1, { children: [
    /* @__PURE__ */ C("div", { className: E.errorHeading, children: [
      /* @__PURE__ */ e(m1, {}),
      `Can't find your ${n.toLowerCase()}`
    ] }),
    /* @__PURE__ */ C("span", { className: E.errorMessage, children: [
      "Check your system settings to make sure that a",
      " ",
      n.toLowerCase(),
      " is available."
    ] }),
    /* @__PURE__ */ e(
      W,
      {
        className: E.continueButton,
        type: "button",
        onClick: () => {
          a();
        },
        children: "Understood"
      }
    )
  ] })),
  !d && /* @__PURE__ */ C(B1, { children: [
    /* @__PURE__ */ C("div", { className: E.errorHeading, children: [
      /* @__PURE__ */ e(m1, {}),
      `Your ${n.toLowerCase()} is blocked`
    ] }),
    /* @__PURE__ */ C(
      W,
      {
        className: E.continueButton,
        type: "button",
        onClick: () => {
          c();
        },
        children: [
          "Allow ",
          n.toLowerCase()
        ]
      }
    )
  ] })
] }), Q8 = (t, n, o) => o ? n ? "Not Available" : t?.label || "Off" : "Blocked", k3 = "DeviceSettingsButton-module__root__YeTTJ", R3 = "DeviceSettingsButton-module__icon-container__eQlQc", I3 = "DeviceSettingsButton-module__inactive__6lM-g", _3 = "DeviceSettingsButton-module__icon__uEHi0", P3 = "DeviceSettingsButton-module__error-icon__86zdM", T3 = "DeviceSettingsButton-module__text-container__GutUn", z3 = "DeviceSettingsButton-module__label__4n74y", E3 = "DeviceSettingsButton-module__status-text__-mBNk", F = {
  root: k3,
  iconContainer: R3,
  inactive: I3,
  icon: _3,
  errorIcon: P3,
  textContainer: T3,
  label: z3,
  statusText: E3
}, D3 = ({
  icon: t,
  isActive: n
}) => {
  if (t === "microphone")
    return n ? /* @__PURE__ */ e(n2, { className: F.icon, fill: "white" }) : /* @__PURE__ */ e(t2, { className: F.icon, fill: "red" });
  if (t === "camera")
    return n ? /* @__PURE__ */ e(i2, { className: F.icon, fill: "white" }) : /* @__PURE__ */ e(r2, { className: F.icon, fill: "red" });
}, X8 = ({
  icon: t,
  label: n,
  statusText: o,
  isActive: r,
  onClick: l,
  displayErrorIcon: i
}) => /* @__PURE__ */ C("button", { type: "button", className: F.root, onClick: l, children: [
  /* @__PURE__ */ C(
    "div",
    {
      className: b(
        F.iconContainer,
        (!r || i) && F.inactive
      ),
      children: [
        /* @__PURE__ */ e(
          D3,
          {
            icon: t,
            isActive: r && !i
          }
        ),
        i && /* @__PURE__ */ e(
          m1,
          {
            className: F.errorIcon,
            size: "x1"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ C("div", { className: F.textContainer, children: [
    /* @__PURE__ */ e("span", { className: F.label, children: n }),
    /* @__PURE__ */ e("span", { className: F.statusText, children: o })
  ] })
] }), O3 = "DragAndDropList-module__container__Qb-th", j3 = "DragAndDropList-module__item__7MFEb", B3 = "DragAndDropList-module__dragging__VkcuD", F3 = "DragAndDropList-module__dragOver__5GNqb", W3 = "DragAndDropList-module__dragHandle__mV-gg", U3 = "DragAndDropList-module__orderNumber__U30s9", J3 = "DragAndDropList-module__content__pHrld", q = {
  container: O3,
  item: j3,
  dragging: B3,
  dragOver: F3,
  dragHandle: W3,
  orderNumber: U3,
  content: J3
}, q8 = ({
  items: t,
  onReorder: n,
  className: o
}) => {
  const [r, l] = j(null), [i, u] = j(null), a = k(null), d = k(null), c = k(null), s = k(null), h = k(0), f = k(0), M = (w) => {
    a.current = w, l(w);
  }, m = () => {
    const w = a.current, H = d.current;
    if (w !== null && H !== null && w !== H) {
      const V = [...t], S = V[w];
      V.splice(w, 1), V.splice(H, 0, S), n(V);
    }
  }, v = () => {
    a.current = null, d.current = null, s.current = null, l(null), u(null);
  }, p = (w) => {
    const H = w.cloneNode(!0);
    return H.style.position = "absolute", H.style.boxSizing = "border-box", H.style.width = `${w.offsetWidth}px`, H.style.opacity = "1", H.style.transform = "none", H.style.background = "var(--tv-ui-color-11)", H.style.cursor = "grabbing", H.style.boxShadow = "-1px -1.5px 4px 0px rgba(255, 255, 255, 0.05) inset, -1px -1.5px 4px 0px rgba(255, 255, 255, 0.04) inset, 0.5px 0.5px 1px 0px rgba(255, 255, 255, 0.125) inset, 0.5px 0.5px 1px 0px rgba(255, 255, 255, 0.15) inset", H.style.pointerEvents = "none", H.style.zIndex = "9999", c.current = H, document.body.appendChild(H), H;
  }, Z = () => {
    c.current && (document.body.removeChild(c.current), c.current = null);
  }, _ = (w, H) => {
    M(H), w.dataTransfer.effectAllowed = "move";
    const V = p(w.currentTarget);
    V.style.top = "-9999px", V.style.left = "-9999px", w.dataTransfer.setDragImage(
      V,
      w.nativeEvent.offsetX,
      w.nativeEvent.offsetY
    );
  }, x = (w, H) => {
    w.preventDefault(), d.current = H, u(H);
  }, y = (w) => {
    w.preventDefault(), w.dataTransfer.dropEffect = "move";
  }, N = (w) => {
    w.currentTarget === w.target && u(null);
  }, P = (w) => {
    w.preventDefault(), m(), v();
  }, T = () => {
    v(), setTimeout(() => {
      Z();
    }, 0);
  }, z = (w, H) => {
    M(H);
    const V = w.touches[0];
    s.current = V.clientY;
    const S = p(w.currentTarget), U = w.currentTarget.getBoundingClientRect();
    h.current = V.clientX - U.left, f.current = V.clientY - U.top, S.style.top = `${V.clientY - f.current}px`, S.style.left = `${V.clientX - h.current}px`, w.currentTarget.style.touchAction = "none";
  }, B = (w) => {
    if (a.current === null || s.current === null)
      return;
    w.preventDefault();
    const H = w.touches[0];
    c.current && (c.current.style.top = `${H.clientY - f.current}px`, c.current.style.left = `${H.clientX - h.current}px`);
    let S = document.elementFromPoint(H.clientX, H.clientY);
    for (; S && !S.hasAttribute("data-drag-index"); )
      S = S.parentElement;
    if (S) {
      const U = Number(
        S.getAttribute("data-drag-index")
      );
      !Number.isNaN(U) && U !== i && (d.current = U, u(U));
    }
  }, L = () => {
    m(), v(), Z();
  };
  return X(() => () => {
    Z();
  }, []), /* @__PURE__ */ e("div", { className: b(q.container, o), children: t.map((w, H) => (
    // biome-ignore lint/a11y/noStaticElementInteractions: There is no interactive element designed for drag and drop. We need to use something.
    /* @__PURE__ */ C(
      "div",
      {
        "data-drag-index": H,
        className: b(q.item, {
          [q.dragging]: r === H,
          [q.dragOver]: i === H
        }),
        draggable: !0,
        onDragStart: (V) => _(V, H),
        onDragEnter: (V) => x(V, H),
        onDragOver: y,
        onDragLeave: N,
        onDrop: P,
        onDragEnd: T,
        onTouchStart: (V) => z(V, H),
        onTouchMove: B,
        onTouchEnd: L,
        children: [
          /* @__PURE__ */ e("div", { className: q.dragHandle, children: /* @__PURE__ */ e("span", { className: q.orderNumber, children: H + 1 }) }),
          /* @__PURE__ */ e("div", { className: q.content, children: w.content })
        ]
      },
      w.id
    )
  )) });
}, Y3 = "Forms-module__root__0wDsy", G3 = "Forms-module__select__xn3eY", K3 = "Forms-module__invalid__lgwQG", s1 = {
  root: Y3,
  select: G3,
  invalid: K3
}, $8 = ({ className: t, invalid: n, ...o }) => /* @__PURE__ */ e(
  "select",
  {
    ...o,
    className: b(
      s1.root,
      s1.select,
      n && s1.invalid,
      t
    )
  }
), e6 = ({ className: t, invalid: n, ...o }) => /* @__PURE__ */ e(
  "input",
  {
    ...o,
    className: b(s1.root, n && s1.invalid, t)
  }
), A3 = "InfoPlate-module__content__OtFyv", Q3 = {
  content: A3
}, X3 = "Plate-module__plateTitleContainer__8mDw5", q3 = "Plate-module__plateTitle__HjvWA", $3 = "Plate-module__plateSubtitle__jGjIH", e0 = "Plate-module__plateHeader__ui4bZ", t0 = "Plate-module__plateFooter__lkgNO", c1 = {
  plateTitleContainer: X3,
  plateTitle: q3,
  plateSubtitle: $3,
  plateHeader: e0,
  plateFooter: t0
};
function R1({
  className: t,
  title: n,
  subtitle: o,
  utils: r
}) {
  return /* @__PURE__ */ C("div", { className: b(c1.plateHeader, t), children: [
    /* @__PURE__ */ C("div", { className: c1.plateTitleContainer, children: [
      /* @__PURE__ */ e("div", { className: c1.plateTitle, children: n }),
      r
    ] }),
    /* @__PURE__ */ e("div", { className: c1.plateSubtitle, children: o })
  ] });
}
function u2({ className: t, children: n }) {
  return /* @__PURE__ */ e("div", { className: b(c1.plateFooter, t), children: n });
}
function t6({
  className: t,
  title: n,
  children: o,
  buttons: r
}) {
  return /* @__PURE__ */ C(p1, { children: [
    /* @__PURE__ */ e(R1, { className: t, title: n }),
    /* @__PURE__ */ e("div", { className: Q3.content, children: o }),
    /* @__PURE__ */ e(u2, { children: r })
  ] });
}
const n0 = "ListHeader-module__root__4dOeI", o0 = "ListHeader-module__labelGroup__BpxTL", r0 = "ListHeader-module__label__6cLbs", i0 = "ListHeader-module__count__wnBLs", a0 = "ListHeader-module__toggleButton__TLBq9", l0 = "ListHeader-module__toggleIcon__5YRlG", c0 = "ListHeader-module__collapsed__Pr8-k", e1 = {
  root: n0,
  labelGroup: o0,
  label: r0,
  count: i0,
  toggleButton: a0,
  toggleIcon: l0,
  collapsed: c0
};
function n6({
  label: t,
  count: n,
  collapsed: o = !1,
  onToggle: r,
  className: l
}) {
  const i = typeof r == "function";
  return /* @__PURE__ */ C("div", { className: b(e1.root, l), children: [
    /* @__PURE__ */ C("div", { className: e1.labelGroup, children: [
      /* @__PURE__ */ e("span", { className: e1.label, children: t }),
      n !== void 0 && /* @__PURE__ */ e("span", { className: e1.count, children: n })
    ] }),
    i && /* @__PURE__ */ e(
      "button",
      {
        type: "button",
        className: e1.toggleButton,
        "aria-expanded": !o,
        "aria-label": o ? "Expand section" : "Collapse section",
        onClick: r,
        children: /* @__PURE__ */ e(s0, { collapsed: o })
      }
    )
  ] });
}
function s0({ collapsed: t }) {
  return /* @__PURE__ */ e(
    "svg",
    {
      className: b(e1.toggleIcon, t && e1.collapsed),
      width: "12",
      height: "8",
      viewBox: "0 0 12 8",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": "true",
      focusable: "false",
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M1 5.75L6 1.25L11 5.75",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function o6() {
  return /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "29",
      height: "28",
      fill: "none",
      "aria-label": "Streamr logo",
      role: "img",
      children: /* @__PURE__ */ e(
        "path",
        {
          fill: "#FF5924",
          d: "M17.872 1.3V.496A.496.496 0 0 0 17.355 0 10.51 10.51 0 0 0 7.37 10.065a.429.429 0 0 0 .45.43h.828a.482.482 0 0 0 .485-.45 8.76 8.76 0 0 1 8.291-8.287c.341-.043.45-.23.45-.457l-.002-.002Zm-7.38 9.203h.785a.48.48 0 0 0 .48-.443 6.124 6.124 0 0 1 5.707-5.674.439.439 0 0 0 .408-.464v-.799a.497.497 0 0 0-.522-.485 7.884 7.884 0 0 0-7.348 7.342.496.496 0 0 0 .485.522l.005.001Zm7.38-4.744v.803a.47.47 0 0 1-.424.463 3.506 3.506 0 0 0-3.053 3.041.497.497 0 0 1-.484.436h-.694c-.377 0-.604-.245-.576-.528a5.257 5.257 0 0 1 4.704-4.7.485.485 0 0 1 .527.485Zm9.201 11.724c-.226 0-.413-.109-.457-.45a8.76 8.76 0 0 0-8.3-8.294.482.482 0 0 1-.45-.484v-.828a.429.429 0 0 1 .431-.45 10.51 10.51 0 0 1 10.071 9.98.497.497 0 0 1-.487.518l-.808.008Zm-9.201-7.378a.496.496 0 0 1 .523-.485 7.884 7.884 0 0 1 7.346 7.34.496.496 0 0 1-.485.523h-.8a.439.439 0 0 1-.464-.412 6.124 6.124 0 0 0-5.675-5.7.48.48 0 0 1-.444-.48l-.002-.786Zm4.744 7.377h-.804a.47.47 0 0 1-.464-.424 3.506 3.506 0 0 0-3.044-3.051.496.496 0 0 1-.436-.484v-.78a.485.485 0 0 1 .528-.486 5.257 5.257 0 0 1 4.704 4.7.485.485 0 0 1-.485.526l.002-.001ZM1.66 10.5c.226 0 .414.11.457.45a8.76 8.76 0 0 0 8.304 8.294c.255.017.453.23.45.485v.827a.428.428 0 0 1-.43.45A10.51 10.51 0 0 1 .37 11.026a.496.496 0 0 1 .487-.518l.803-.008Zm9.207 7.372a.496.496 0 0 1-.524.485A7.884 7.884 0 0 1 3 11.021a.496.496 0 0 1 .485-.523h.8c.242-.014.45.17.463.413a6.124 6.124 0 0 0 5.674 5.702.48.48 0 0 1 .444.48l.002.78ZM6.117 10.5h.803a.47.47 0 0 1 .463.424 3.506 3.506 0 0 0 3.045 3.051c.245.03.43.236.435.483v.783a.485.485 0 0 1-.525.48 5.257 5.257 0 0 1-4.703-4.7.485.485 0 0 1 .482-.52Zm4.748 16.206c0-.227.11-.414.45-.457a8.76 8.76 0 0 0 8.3-8.294.482.482 0 0 1 .485-.45h.828a.429.429 0 0 1 .45.43A10.51 10.51 0 0 1 11.391 28a.497.497 0 0 1-.518-.487l-.008-.808Zm7.382-9.203a.497.497 0 0 1 .485.523 7.884 7.884 0 0 1-7.346 7.34.497.497 0 0 1-.523-.484v-.8a.439.439 0 0 1 .412-.463 6.124 6.124 0 0 0 5.706-5.67.48.48 0 0 1 .48-.444l.786-.002Zm-7.379 4.743v-.803a.47.47 0 0 1 .424-.463 3.506 3.506 0 0 0 3.053-3.042.497.497 0 0 1 .483-.435h.694c.378 0 .604.245.576.528a5.257 5.257 0 0 1-4.703 4.7.485.485 0 0 1-.527-.485Zm0 4.46c0-.227.11-.414.45-.457a8.76 8.76 0 0 0 8.3-8.294.482.482 0 0 1 .485-.45h.828a.429.429 0 0 1 .45.43A10.51 10.51 0 0 1 11.395 28a.497.497 0 0 1-.518-.487l-.009-.808Zm7.383-9.203a.497.497 0 0 1 .485.523 7.884 7.884 0 0 1-7.346 7.34.497.497 0 0 1-.524-.484v-.8a.439.439 0 0 1 .413-.463 6.124 6.124 0 0 0 5.705-5.67.48.48 0 0 1 .48-.444l.787-.002Zm-7.383 4.743v-.803a.47.47 0 0 1 .424-.463 3.506 3.506 0 0 0 3.053-3.042.497.497 0 0 1 .483-.435h.694c.378 0 .604.245.576.528a5.257 5.257 0 0 1-4.703 4.7.485.485 0 0 1-.527-.485Z"
        }
      )
    }
  );
}
function r6() {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "36",
      height: "37",
      fill: "none",
      "aria-label": "StreamrTV logo",
      role: "img",
      children: [
        /* @__PURE__ */ e(
          "rect",
          {
            width: "36",
            height: "36",
            y: ".108",
            fill: "#E7E7E7",
            fillOpacity: ".2",
            rx: "18"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M7.15 18.108c.268 0 .488.13.54.531.267 5.273 4.492 9.503 9.764 9.777a.574.574 0 0 1 .546.572v.967c0 .19-.105.516-.507.53-6.408-.258-11.563-5.384-11.867-11.78a.573.573 0 0 1 .573-.597h.952Zm3.093 0c.416 0 .536.325.547.485a7.227 7.227 0 0 0 6.677 6.721.57.57 0 0 1 .533.567v.925a.575.575 0 0 1-.614.572 9.292 9.292 0 0 1-8.657-8.656.575.575 0 0 1 .572-.614h.942Zm3.111 0c.388 0 .527.336.546.5a4.131 4.131 0 0 0 3.589 3.598c.29.035.511.277.511.57v.923c0 .337-.29.605-.624.571a6.196 6.196 0 0 1-5.54-5.538.572.572 0 0 1 .572-.624h.946ZM28.85 18.108c-.268 0-.488-.129-.54-.531-.267-5.273-4.492-9.502-9.764-9.777A.574.574 0 0 1 18 7.228V6.26c0-.19.105-.516.507-.53 6.408.258 11.563 5.384 11.867 11.78a.573.573 0 0 1-.573.597h-.951Zm-3.093 0a.517.517 0 0 1-.546-.485 7.227 7.227 0 0 0-6.677-6.721.57.57 0 0 1-.534-.567V9.41c0-.332.282-.594.614-.572a9.292 9.292 0 0 1 8.657 8.656.575.575 0 0 1-.572.614h-.942Zm-3.111 0c-.387 0-.527-.336-.546-.5a4.131 4.131 0 0 0-3.589-3.598.577.577 0 0 1-.51-.57v-.923c0-.337.288-.605.623-.571a6.196 6.196 0 0 1 5.54 5.538.572.572 0 0 1-.572.624h-.946Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
const i6 = () => /* @__PURE__ */ C(
  "svg",
  {
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "StreamrTV logo",
    role: "img",
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.15044 13C2.41811 13 2.63795 13.129 2.68962 13.5312C2.957 18.8043 7.18216 23.0335 12.4542 23.3079C12.7596 23.3238 12.9998 23.5745 12.9998 23.8802V24.8465C12.9998 25.0377 12.8946 25.3627 12.493 25.3764C6.08459 25.1185 0.929566 19.9933 0.625652 13.5977C0.610166 13.2719 0.872672 13 1.19895 13H2.15044ZM5.24276 13C5.65857 13 5.77866 13.325 5.78933 13.4854C6.02735 17.0732 8.88446 19.9448 12.4663 20.2061C12.7658 20.2279 12.9998 20.4727 12.9998 20.7729V21.6976C12.9998 22.0303 12.7176 22.2915 12.3855 22.2699C7.74353 21.967 4.03146 18.2555 3.72852 13.6142C3.70684 13.2821 3.9682 13 4.30096 13H5.24276ZM8.35417 13C8.7413 13 8.8805 13.336 8.90028 13.4999C9.12689 15.3769 10.613 16.866 12.4888 17.0975C12.7791 17.1334 12.9998 17.375 12.9998 17.6675V18.5909C12.9998 18.9276 12.7106 19.1957 12.3755 19.1622C9.453 18.8697 7.12916 16.5462 6.83666 13.6242C6.80316 13.2891 7.07129 13 7.40807 13H8.35417Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.8496 13C23.5819 13 23.3621 12.871 23.3104 12.4688C23.043 7.19566 18.8178 2.96653 13.5458 2.69207C13.2404 2.67619 13.0002 2.42554 13.0002 2.11977V1.15345C13.0002 0.962322 13.1054 0.637349 13.507 0.623644C19.9154 0.881467 25.0704 6.00673 25.3743 12.4023C25.3898 12.7281 25.1273 13 24.801 13H23.8496ZM20.7572 13C20.3414 13 20.2213 12.675 20.2107 12.5146C19.9727 8.92685 17.1155 6.05524 13.5337 5.79392C13.2342 5.77207 13.0002 5.52732 13.0002 5.22712V4.30243C13.0002 3.96972 13.2824 3.70846 13.6145 3.73008C18.2565 4.03303 21.9685 7.74451 22.2715 12.3858C22.2932 12.7179 22.0318 13 21.699 13H20.7572ZM17.6458 13C17.2587 13 17.1195 12.664 17.0997 12.5001C16.8731 10.6231 15.387 9.13398 13.5112 8.90247C13.2209 8.86663 13.0002 8.62504 13.0002 8.33252V7.4091C13.0002 7.07237 13.2894 6.80428 13.6245 6.83777C16.547 7.13029 18.8708 9.45379 19.1633 12.3758C19.1968 12.7109 18.9287 13 18.5919 13H17.6458Z",
          fill: "white"
        }
      )
    ]
  }
), a6 = () => {
  const t = C1(), n = `gradient-0-${t}`, o = `gradient-1-${t}`, r = `gradient-2-${t}`, l = `gradient-3-${t}`;
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "121",
      height: "32",
      viewBox: "0 0 121 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Streamr logo",
      role: "img",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            d: "M40.7229 23.1498C39.9068 22.8025 39.265 22.3251 38.7939 21.7174C38.3227 21.1098 38.0556 20.4298 38 19.6774H41.6243C41.6688 20.0825 41.8617 20.4081 42.203 20.6613C42.5443 20.9145 42.9672 21.0374 43.468 21.0374C43.9243 21.0374 44.2804 20.9506 44.529 20.777C44.7775 20.6034 44.9036 20.3755 44.9036 20.097C44.9036 19.7642 44.7256 19.5147 44.3657 19.3555C44.0096 19.1964 43.4309 19.0191 42.6296 18.8238C41.7727 18.6285 41.0567 18.4223 40.4855 18.2089C39.9142 17.9919 39.4208 17.6519 39.0053 17.1853C38.5898 16.7187 38.3821 16.0893 38.3821 15.2936C38.3821 14.6244 38.5713 14.0132 38.9497 13.4634C39.3281 12.9136 39.8845 12.4759 40.6227 12.1576C41.3609 11.8357 42.2364 11.6766 43.2491 11.6766C44.7515 11.6766 45.9312 12.0383 46.7993 12.7653C47.6636 13.4887 48.1607 14.4508 48.2905 15.6517H44.9036C44.848 15.2466 44.6625 14.9283 44.3583 14.6896C44.0504 14.4544 43.6461 14.3351 43.1453 14.3351C42.715 14.3351 42.3885 14.4147 42.1585 14.5738C41.9285 14.733 41.8172 14.9536 41.8172 15.2321C41.8172 15.5649 41.999 15.8181 42.3625 15.9845C42.7261 16.1508 43.2974 16.3172 44.069 16.4872C44.9556 16.7115 45.679 16.9285 46.2354 17.1455C46.7918 17.3625 47.2815 17.7098 47.7044 18.1908C48.1273 18.6719 48.3425 19.3157 48.3573 20.1259C48.3573 20.8096 48.1607 21.4172 47.7675 21.9562C47.3743 22.4915 46.8104 22.9147 46.0722 23.2221C45.334 23.5296 44.4807 23.6815 43.5088 23.6815C42.4664 23.6815 41.5353 23.5079 40.7192 23.157L40.7229 23.1498Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M49.6558 11.843V9H53.3246V11.843H55.7284V14.8126H53.3246V20.4804H55.747V23.5115H53.881C52.553 23.5115 51.5143 23.1932 50.7724 22.5602C50.0304 21.9272 49.6558 20.8928 49.6558 19.4568V14.8162",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M62.3198 12.2661C62.9616 11.8972 63.6776 11.7127 64.464 11.7127V15.4961H63.455C62.5387 15.4961 61.8524 15.6878 61.3961 16.0712C60.9398 16.4546 60.7098 17.1274 60.7098 18.0895V23.5042H57.041V11.8393H60.7098V13.7853C61.1402 13.145 61.6744 12.6387 62.3198 12.2697V12.2661Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M76.9662 18.5308H68.6678C68.7234 19.2579 68.9645 19.8113 69.3874 20.1947C69.8103 20.5781 70.326 20.7698 70.9418 20.7698C71.8581 20.7698 72.4924 20.3936 72.8522 19.6413H76.7548C76.5545 20.4081 76.1946 21.0989 75.6716 21.7102C75.1485 22.3251 74.4956 22.8062 73.7092 23.1534C72.9227 23.5006 72.0435 23.6779 71.0716 23.6779C69.8994 23.6779 68.857 23.4355 67.9407 22.9472C67.0244 22.4589 66.3121 21.7608 65.7965 20.8566C65.2809 19.9523 65.0249 18.8925 65.0249 17.6772C65.0249 16.4619 65.2772 15.4057 65.7854 14.4979C66.2936 13.5936 67.0059 12.8955 67.9184 12.4072C68.8347 11.9189 69.8845 11.6766 71.0716 11.6766C72.2587 11.6766 73.2603 11.9153 74.1617 12.3891C75.0632 12.863 75.768 13.5393 76.2725 14.4183C76.7808 15.2972 77.033 16.3208 77.033 17.4928C77.033 17.8255 77.0108 18.1764 76.9699 18.5381L76.9662 18.5308ZM73.2789 16.5415C73.2789 15.9302 73.0637 15.4419 72.6371 15.0766C72.2068 14.7149 71.6726 14.534 71.0271 14.534C70.3816 14.534 69.8919 14.7076 69.4728 15.0585C69.0499 15.4057 68.7902 15.9013 68.69 16.5415H73.2789Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M78.4528 14.4943C78.9165 13.5901 79.5508 12.892 80.3521 12.4037C81.1534 11.9154 82.0474 11.673 83.0342 11.673C83.8763 11.673 84.6182 11.8394 85.2526 12.1758C85.8869 12.5086 86.3766 12.9498 86.7216 13.4924V11.8394H90.3904V23.5079H86.7216V21.855C86.3654 22.3975 85.8684 22.8388 85.2303 23.1716C84.5922 23.5043 83.854 23.6743 83.0119 23.6743C82.04 23.6743 81.1534 23.4284 80.3521 22.9328C79.5508 22.4373 78.9202 21.7356 78.4528 20.8205C77.9891 19.909 77.7554 18.8528 77.7554 17.652C77.7554 16.4511 77.9891 15.4022 78.4528 14.4943ZM85.9611 15.5613C85.4566 15.0477 84.8408 14.7909 84.1137 14.7873C83.5906 14.7873 83.0713 14.9392 82.641 15.2286C81.8731 15.7458 81.491 16.5524 81.491 17.652C81.491 18.5454 81.7432 19.2507 82.2515 19.7752C82.7597 20.2996 83.3792 20.5601 84.1063 20.5601C84.8334 20.5601 85.4529 20.3033 85.9611 19.786C86.4693 19.2688 86.7216 18.5671 86.7216 17.6737C86.7216 16.7803 86.4693 16.0786 85.9611 15.5613Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M110.504 13.0293C111.383 13.9082 111.821 15.1272 111.821 16.6897V23.5078H108.174V17.1708C108.174 16.4185 107.97 15.8361 107.562 15.4238C107.154 15.0114 106.594 14.8089 105.878 14.8089C105.162 14.8089 104.602 15.0151 104.194 15.4238C103.786 15.8361 103.582 16.4185 103.582 17.1708V23.5078H99.9352V17.1708C99.9352 16.4185 99.7312 15.8361 99.3231 15.4238C98.915 15.0114 98.3549 14.8089 97.6389 14.8089C96.923 14.8089 96.3628 15.0151 95.9548 15.4238C95.5467 15.8361 95.3427 16.4185 95.3427 17.1708V23.5078H91.6738V11.8393H95.3427V13.3042C95.7136 12.8159 96.1996 12.4289 96.8005 12.1431C97.4015 11.8574 98.0804 11.7163 98.8371 11.7163C99.7386 11.7163 100.544 11.9044 101.248 12.2806C101.957 12.6568 102.51 13.1921 102.91 13.8902C103.326 13.2499 103.89 12.7255 104.606 12.3204C105.322 11.9153 106.101 11.7127 106.943 11.7127C108.43 11.7127 109.614 12.1504 110.493 13.0293H110.504Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M118.399 12.2661C119.041 11.8972 119.757 11.7127 120.544 11.7127V15.4961H119.535C118.618 15.4961 117.932 15.6878 117.476 16.0712C117.019 16.4546 116.789 17.1274 116.789 18.0895V23.5042H113.121V11.8393H116.789V13.7853C117.22 13.145 117.754 12.6387 118.399 12.2697V12.2661Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.3684 2.35789C26.3446 2.35789 32 8.01325 32 14.9895C32 21.9657 26.3446 27.6211 19.3684 27.6211C12.3922 27.6211 6.73684 21.9657 6.73684 14.9895C6.73684 8.01325 12.3922 2.35789 19.3684 2.35789ZM13.7273 10.6965C12.4169 9.97355 10.7789 10.8773 10.7789 12.3234V19.5082C10.7789 20.9542 12.4169 21.858 13.7273 21.135L20.2383 17.5426C21.5487 16.8196 21.5487 15.012 20.2383 14.289L13.7273 10.6965Z",
            fill: `url(#${n})`
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.9895 0C21.9657 4.54074e-08 27.6211 5.65535 27.6211 12.6316C27.6211 19.6078 21.9657 25.2632 14.9895 25.2632C8.01325 25.2632 2.35789 19.6078 2.35789 12.6316C2.35789 5.65535 8.01325 4.74289e-08 14.9895 0ZM13.7273 10.6965C12.4169 9.97355 10.7789 10.8773 10.7789 12.3234V19.5082C10.7789 20.9542 12.4169 21.858 13.7273 21.135L20.2383 17.5426C21.5487 16.8196 21.5487 15.012 20.2383 14.289L13.7273 10.6965Z",
            fill: `url(#${o})`
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.6316 5.05263C19.6078 5.05263 25.2632 10.708 25.2632 17.6842C25.2632 24.6604 19.6078 30.3158 12.6316 30.3158C5.65535 30.3158 4.74289e-08 24.6604 0 17.6842C-4.74289e-08 10.708 5.65535 5.05263 12.6316 5.05263ZM13.7273 10.6965C12.4169 9.97355 10.7789 10.8773 10.7789 12.3234V19.5082C10.7789 20.9542 12.4169 21.858 13.7273 21.135L20.2383 17.5426C21.5487 16.8196 21.5487 15.012 20.2383 14.289L13.7273 10.6965Z",
            fill: `url(#${r})`
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.0211 6.73684C24.9973 6.73684 30.6526 12.3922 30.6526 19.3684C30.6526 26.3446 24.9973 32 18.0211 32C11.0448 32 5.38947 26.3446 5.38947 19.3684C5.38947 12.3922 11.0448 6.73684 18.0211 6.73684ZM13.7273 10.6965C12.4169 9.97355 10.7789 10.8773 10.7789 12.3234V19.5082C10.7789 20.9542 12.4169 21.858 13.7273 21.135L20.2383 17.5426C21.5487 16.8196 21.5487 15.012 20.2383 14.289L13.7273 10.6965Z",
            fill: `url(#${l})`
          }
        ),
        /* @__PURE__ */ C("defs", { children: [
          /* @__PURE__ */ C(
            "linearGradient",
            {
              id: n,
              x1: "30.4",
              y1: "22.1867",
              x2: "8.10667",
              y2: "13.0133",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ e("stop", { stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ e("stop", { offset: "1", stopColor: "white" })
              ]
            }
          ),
          /* @__PURE__ */ C(
            "linearGradient",
            {
              id: o,
              x1: "25.0257",
              y1: "2.73504",
              x2: "11.7607",
              y2: "17.5043",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ e("stop", { stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ e("stop", { offset: "1", stopColor: "white" })
              ]
            }
          ),
          /* @__PURE__ */ C(
            "linearGradient",
            {
              id: r,
              x1: "2.87179",
              y1: "6.29059",
              x2: "23.2479",
              y2: "17.094",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ e("stop", { stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ e("stop", { offset: "1", stopColor: "white" })
              ]
            }
          ),
          /* @__PURE__ */ C(
            "linearGradient",
            {
              id: l,
              x1: "12.4632",
              y1: "30.1474",
              x2: "18.0211",
              y2: "17.2632",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ e("stop", { stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ e("stop", { offset: "1", stopColor: "white" })
              ]
            }
          )
        ] })
      ]
    }
  );
}, l6 = () => {
  const t = C1(), n = `gradient-0-${t}`, o = `gradient-1-${t}`, r = `gradient-2-${t}`, l = `gradient-3-${t}`;
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "56",
      height: "56",
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": "Streamr logo",
      role: "img",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M33.8947 4.12632C46.1031 4.12632 56 14.0232 56 26.2316C56 38.44 46.1031 48.3368 33.8947 48.3368C21.6863 48.3368 11.7895 38.44 11.7895 26.2316C11.7895 14.0232 21.6863 4.12632 33.8947 4.12632ZM24.0228 18.719C21.7296 17.4537 18.8632 19.0353 18.8632 21.5659V34.1394C18.8632 36.6699 21.7296 38.2515 24.0228 36.9863L35.4171 30.6995C37.7102 29.4343 37.7102 26.271 35.4171 25.0057L24.0228 18.719Z",
            fill: `url(#${n})`
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M26.2316 0C38.44 7.9463e-08 48.3368 9.89686 48.3368 22.1053C48.3368 34.3137 38.44 44.2105 26.2316 44.2105C14.0232 44.2105 4.12632 34.3137 4.12632 22.1053C4.12632 9.89686 14.0232 8.30006e-08 26.2316 0ZM24.0228 18.719C21.7296 17.4537 18.8632 19.0353 18.8632 21.5659V34.1394C18.8632 36.6699 21.7296 38.2515 24.0228 36.9863L35.4171 30.6995C37.7102 29.4343 37.7102 26.271 35.4171 25.0057L24.0228 18.719Z",
            fill: `url(#${o})`
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.1053 8.8421C34.3137 8.8421 44.2105 18.739 44.2105 30.9474C44.2105 43.1558 34.3137 53.0526 22.1053 53.0526C9.89686 53.0526 8.30006e-08 43.1558 0 30.9474C-8.30006e-08 18.739 9.89686 8.8421 22.1053 8.8421ZM24.0228 18.719C21.7296 17.4537 18.8632 19.0353 18.8632 21.5659V34.1394C18.8632 36.6699 21.7296 38.2515 24.0228 36.9863L35.4171 30.6995C37.7102 29.4343 37.7102 26.271 35.4171 25.0057L24.0228 18.719Z",
            fill: `url(#${r})`
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31.5368 11.7895C43.7452 11.7895 53.6421 21.6863 53.6421 33.8947C53.6421 46.1031 43.7452 56 31.5368 56C19.3284 56 9.43158 46.1031 9.43158 33.8947C9.43158 21.6863 19.3284 11.7895 31.5368 11.7895ZM24.0228 18.719C21.7296 17.4537 18.8632 19.0353 18.8632 21.5659V34.1394C18.8632 36.6699 21.7296 38.2515 24.0228 36.9863L35.4171 30.6995C37.7102 29.4343 37.7102 26.271 35.4171 25.0057L24.0228 18.719Z",
            fill: `url(#${l})`
          }
        ),
        /* @__PURE__ */ C("defs", { children: [
          /* @__PURE__ */ C(
            "linearGradient",
            {
              id: n,
              x1: "53.2",
              y1: "38.8267",
              x2: "14.1867",
              y2: "22.7733",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ e("stop", { stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ e("stop", { offset: "1", stopColor: "white" })
              ]
            }
          ),
          /* @__PURE__ */ C(
            "linearGradient",
            {
              id: o,
              x1: "43.7949",
              y1: "4.78632",
              x2: "20.5812",
              y2: "30.6325",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ e("stop", { stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ e("stop", { offset: "1", stopColor: "white" })
              ]
            }
          ),
          /* @__PURE__ */ C(
            "linearGradient",
            {
              id: r,
              x1: "5.02564",
              y1: "11.0085",
              x2: "40.6838",
              y2: "29.9145",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ e("stop", { stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ e("stop", { offset: "1", stopColor: "white" })
              ]
            }
          ),
          /* @__PURE__ */ C(
            "linearGradient",
            {
              id: l,
              x1: "21.8105",
              y1: "52.7579",
              x2: "31.5368",
              y2: "30.2105",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ e("stop", { stopColor: "white", stopOpacity: "0" }),
                /* @__PURE__ */ e("stop", { offset: "1", stopColor: "white" })
              ]
            }
          )
        ] })
      ]
    }
  );
}, C0 = "ColumnsContainer-module__root__X9jr7", d0 = {
  root: C0
}, c6 = (t) => /* @__PURE__ */ e("div", { ...t, className: b(d0.root, t.className) }), u0 = "GlassBackground-module__root__kdPtl", h0 = {
  root: u0
}, s6 = (t) => /* @__PURE__ */ e("div", { ...t, className: b(h0.root, t.className) }), m0 = "LoadingIndicator-module__root__Ji0tk", p0 = {
  root: m0
}, b1 = ({
  width: t = "2rem",
  height: n = "2rem",
  borderRadius: o,
  className: r,
  style: l,
  ...i
}) => {
  const u = {
    width: t,
    height: n,
    borderRadius: o,
    ...l
  };
  return /* @__PURE__ */ e(
    "div",
    {
      ...i,
      className: b(p0.root, r),
      style: u
    }
  );
}, g0 = "PopupList-module__root__h0i63", v0 = "PopupList-module__item__IgVDU", W1 = {
  root: g0,
  item: v0
}, C6 = ({
  children: t,
  className: n
}) => {
  const o = t1(() => M2.toArray(t), [t]), r = t1(
    () => Array.from(
      { length: o.length },
      () => typeof crypto < "u" && "randomUUID" in crypto ? crypto.randomUUID() : Math.random().toString(36).slice(2)
    ),
    [o.length]
  );
  return /* @__PURE__ */ e("ul", { className: b(W1.root, n), children: o.map((l, i) => /* @__PURE__ */ e("li", { className: W1.item, children: l }, r[i])) });
}, w0 = "MultiSelect-module__root__SmBja", f0 = "MultiSelect-module__list__eAPZg", M0 = "MultiSelect-module__item__h4K8p", x0 = "MultiSelect-module__item-disabled__FkDsW", b0 = "MultiSelect-module__icon-wrap__KeMzr", H0 = "MultiSelect-module__check-icon__mVtR0", L0 = "MultiSelect-module__plus-icon__AP2dx", Z0 = "MultiSelect-module__item-selected__baZ90", K = {
  root: w0,
  list: f0,
  item: M0,
  itemDisabled: x0,
  iconWrap: b0,
  checkIcon: H0,
  plusIcon: L0,
  itemSelected: Z0
}, d6 = ({
  options: t,
  selectedIds: n = [],
  onChange: o,
  className: r
}) => {
  const l = t1(() => new Set(n), [n]), i = R(
    (u) => {
      const a = new Set(n);
      a.has(u) ? a.delete(u) : a.add(u), o?.(a);
    },
    [n, o]
  );
  return /* @__PURE__ */ e("div", { className: b(K.root, r), children: /* @__PURE__ */ e("ul", { className: K.list, children: t.map((u) => {
    const a = l.has(u.id);
    return /* @__PURE__ */ C(
      "li",
      {
        className: b(K.item, {
          [K.itemSelected]: a,
          [K.itemDisabled]: u.disabled
        }),
        onClick: () => !u.disabled && i(u.id),
        onKeyDown: (d) => {
          (d.key === "Enter" || d.key === " ") && !u.disabled && i(u.id);
        },
        children: [
          /* @__PURE__ */ e("div", { className: K.iconWrap, children: a ? /* @__PURE__ */ e("div", { className: K.checkIcon, children: /* @__PURE__ */ e(w1, { size: "x1" }) }) : /* @__PURE__ */ e("div", { className: K.plusIcon, children: /* @__PURE__ */ e(d2, {}) }) }),
          /* @__PURE__ */ e("div", { className: K.texts, children: u.element })
        ]
      },
      u.id
    );
  }) }) });
}, V0 = "PopupHeader-module__header__7MXH9", y0 = "PopupHeader-module__headerContent__QSDDp", U1 = {
  header: V0,
  headerContent: y0
};
function u6({
  className: t,
  onCloseButtonClick: n,
  children: o
}) {
  return /* @__PURE__ */ C("div", { className: b(U1.header, t), children: [
    /* @__PURE__ */ e("div", { children: n && /* @__PURE__ */ e(W, { kind: "pill", onClick: n, children: /* @__PURE__ */ e(f1, {}) }) }),
    /* @__PURE__ */ C("div", { className: U1.headerContent, children: [
      "‌",
      o
    ] }),
    /* @__PURE__ */ e("div", {})
  ] });
}
const S0 = "ProductCatalogPlate-module__closeButton__pLA8A", N0 = "ProductCatalogPlate-module__content__dXo1S", k0 = "ProductCatalogPlate-module__scrollableContainer__O4Cmr", R0 = "ProductCatalogPlate-module__products__MdLtp", I0 = "ProductCatalogPlate-module__caret__jSk1l", _0 = "ProductCatalogPlate-module__noProductsPlaceholderContainer__jyMQr", P0 = "ProductCatalogPlate-module__noProductsPlaceholder__4fC8F", A = {
  closeButton: S0,
  content: N0,
  scrollableContainer: k0,
  products: R0,
  caret: I0,
  noProductsPlaceholderContainer: _0,
  noProductsPlaceholder: P0
}, T0 = "ScrollableContainer-module__root__yI390", z0 = {
  root: T0
};
function E0(t) {
  const { className: n, scrollableContainerControllerRef: o, children: r, ...l } = t, i = k(null), [u, a] = j(!1);
  X1(
    o,
    () => ({
      scrollToBottom: () => {
        const c = i.current?.elements().viewport;
        if (!c)
          return;
        const { clientHeight: s, scrollHeight: h } = c;
        c.scroll({
          top: h - s,
          behavior: "auto"
        });
      }
    }),
    []
  );
  const d = t1(
    () => ({
      initialized: (c) => {
        i.current = c, a(!0);
      }
    }),
    []
  );
  return /* @__PURE__ */ e(
    H2,
    {
      ...l,
      events: d,
      className: b(n, z0.root),
      defer: !0,
      children: u && r
    }
  );
}
const D0 = "TitleAndDescription-module__root__Qe0Eh", O0 = "TitleAndDescription-module__avatar__iMnte", j0 = "TitleAndDescription-module__avatar-image__5reaC", B0 = "TitleAndDescription-module__info__uT0Fw", F0 = "TitleAndDescription-module__title__535dG", W0 = "TitleAndDescription-module__description__vD4cl", Y = {
  root: D0,
  avatar: O0,
  avatarImage: j0,
  info: B0,
  title: F0,
  description: W0
}, U0 = ({
  title: t,
  description: n,
  avatar: o,
  noAvatarFallback: r = !1,
  isLoading: l = !1
}) => l ? /* @__PURE__ */ e(J0, { noAvatarFallback: r }) : /* @__PURE__ */ C("div", { className: Y.root, children: [
  !r && /* @__PURE__ */ C(g1, { className: Y.avatar, children: [
    !!o && typeof o == "string" && /* @__PURE__ */ e(
      "img",
      {
        src: o,
        alt: t,
        className: Y.avatarImage
      }
    ),
    !!o && typeof o != "string" && o,
    !o && /* @__PURE__ */ e(v1, { hashable: t })
  ] }),
  /* @__PURE__ */ C("div", { className: Y.info, children: [
    /* @__PURE__ */ e("div", { className: Y.title, children: t }),
    n && /* @__PURE__ */ e("div", { className: Y.description, children: n })
  ] })
] }), J0 = ({
  noAvatarFallback: t = !1
}) => /* @__PURE__ */ C("div", { className: Y.root, children: [
  !t && /* @__PURE__ */ e(
    b1,
    {
      borderRadius: "2rem",
      width: "2rem",
      height: "2rem"
    }
  ),
  /* @__PURE__ */ C("div", { className: Y.info, children: [
    /* @__PURE__ */ e("div", { className: Y.name, children: /* @__PURE__ */ e(b1, { width: "40%", height: "0.9rem" }) }),
    /* @__PURE__ */ e("div", { className: Y.tagline, children: /* @__PURE__ */ e(b1, { width: "100%", height: "0.7rem" }) })
  ] })
] }), Y0 = [];
function h6({
  title: t = "Send Super Balloons to…",
  subtitle: n,
  products: o = Y0,
  onCloseButtonClick: r,
  onProductClick: l
}) {
  return /* @__PURE__ */ C(p1, { children: [
    /* @__PURE__ */ e(
      R1,
      {
        title: t,
        subtitle: n,
        utils: r && /* @__PURE__ */ e(
          W,
          {
            className: A.closeButton,
            onClick: r,
            children: /* @__PURE__ */ e(f1, {})
          }
        )
      }
    ),
    /* @__PURE__ */ e("div", { className: A.content, children: /* @__PURE__ */ e(E0, { className: A.scrollableContainer, children: o.length > 0 ? /* @__PURE__ */ e("ul", { className: A.products, children: o.map((i) => /* @__PURE__ */ e("li", { children: /* @__PURE__ */ C(
      W,
      {
        className: A.product,
        onClick: () => {
          l?.(i);
        },
        children: [
          /* @__PURE__ */ e(
            U0,
            {
              title: i.name,
              description: i.tagline
            }
          ),
          /* @__PURE__ */ e(
            a2,
            {
              className: A.caret,
              size: "x1_5"
            }
          )
        ]
      }
    ) }, i.id)) }) : /* @__PURE__ */ e("div", { className: A.noProductsPlaceholderContainer, children: /* @__PURE__ */ e("div", { className: A.noProductsPlaceholder, children: "Super Balloons aren't set up for this livestream yet." }) }) }) })
  ] });
}
const G0 = "ProgressBar-module__root__9oRSb", K0 = "ProgressBar-module__indicator__b7Rpp", A0 = "ProgressBar-module__animated__9uysg", H1 = {
  root: G0,
  indicator: K0,
  animated: A0
}, m6 = ({
  animateFor: t,
  value: n,
  className: o,
  indicatorClassName: r
}) => {
  const l = typeof t == "number" && t > 0, i = typeof n == "number" ? Math.max(0, Math.min(100, n)) : 0, u = l ? {
    "--from": `${i}%`,
    "--duration": `${t}ms`
  } : { width: `${i}%` };
  return /* @__PURE__ */ e("div", { className: b(H1.root, o), children: /* @__PURE__ */ e(
    "div",
    {
      className: b(
        H1.indicator,
        l && H1.animated,
        r
      ),
      style: u
    },
    l ? `${t}-${i}` : "static"
  ) });
}, Q0 = "MoneyTextField-module__amountInput__2QFQO", X0 = "MoneyTextField-module__amountDisplay__vVCjv", L1 = {
  amountInput: Q0,
  amountDisplay: X0
}, J1 = { currencyDisplay: "narrowSymbol" };
function q0({
  min: t,
  max: n,
  value: o,
  currency: r,
  onChange: l
}) {
  const i = Math.min(t, n), u = Math.max(n, t), a = O(o ?? i, i, u), d = r1(
    a,
    r,
    J1
  ), [c, s] = j(!1), [h, f] = j(d), M = R(() => {
    f(
      `${u1(a, r)}`
    ), s(!0);
  }, [a, r]);
  return /* @__PURE__ */ e("div", { className: L1.root, children: c ? /* @__PURE__ */ e(
    "input",
    {
      autoFocus: !0,
      type: "number",
      step: 1 / 10 ** N1(r),
      placeholder: u1(i, r),
      min: u1(i, r),
      max: u1(u, r),
      className: L1.amountInput,
      value: h,
      onChange: (m) => {
        f(m.target.value);
        const v = k1(
          Number(m.target.value),
          r
        );
        Number.isFinite(v) && l(O(v, i, u));
      },
      onBlur: () => {
        s(!1);
      }
    }
  ) : /* @__PURE__ */ e(
    "button",
    {
      className: L1.amountDisplay,
      type: "button",
      onFocus: M,
      onClick: M,
      children: r1(a, r, J1)
    }
  ) });
}
const $0 = "PurchaseCustomizationPlate-module__headerUtils__eZD6G", e4 = "PurchaseCustomizationPlate-module__content__PZJCZ", t4 = "PurchaseCustomizationPlate-module__contentWrap__tRzZL", n4 = "PurchaseCustomizationPlate-module__buyer__FD1eE", o4 = "PurchaseCustomizationPlate-module__buyerAvatar__7nju3", r4 = "PurchaseCustomizationPlate-module__buyerInfo__blxO1", i4 = "PurchaseCustomizationPlate-module__buyerName__i7qaF", a4 = "PurchaseCustomizationPlate-module__amount__WWBJx", l4 = "PurchaseCustomizationPlate-module__textFieldWrap__Wfjob", c4 = "PurchaseCustomizationPlate-module__textField__S3JIN", s4 = "PurchaseCustomizationPlate-module__artworkWrap__sX8z5", C4 = "PurchaseCustomizationPlate-module__artworkContainer__2HQmG", d4 = "PurchaseCustomizationPlate-module__moneySlider__XYnLl", D = {
  headerUtils: $0,
  content: e4,
  contentWrap: t4,
  buyer: n4,
  buyerAvatar: o4,
  buyerInfo: r4,
  buyerName: i4,
  amount: a4,
  textFieldWrap: l4,
  textField: c4,
  artworkWrap: s4,
  artworkContainer: C4,
  moneySlider: d4
}, u4 = "Slider2-module__root__NXByX", h4 = "Slider2-module__track__KggR8", m4 = "Slider2-module__knobWrap__NIHdA", p4 = "Slider2-module__knob__L8nJ3", g4 = "Slider2-module__marks__LRCKA", v4 = "Slider2-module__mark__Skx5s", w4 = "Slider2-module__progressBar__e14rs", Q = {
  root: u4,
  track: h4,
  knobWrap: m4,
  knob: p4,
  marks: g4,
  mark: v4,
  progressBar: w4
};
function f4(t, n, o) {
  const r = Math.round((t - n) / o);
  return n + r * o;
}
function M4(t) {
  const {
    min: n,
    max: o,
    step: r,
    value: l,
    onChange: i,
    label: u,
    marks: a,
    disabled: d = !1,
    name: c,
    id: s,
    className: h,
    formatValue: f,
    ...M
  } = t, m = Math.min(n, o), v = Math.max(o, n), p = O(l ?? m, m, v), Z = (p - m) / (v - m || 1), _ = k(null), x = k(null), y = k(null), N = s ? `${s}-label` : void 0, P = R(
    (L) => {
      if (d)
        return;
      const w = x.current?.getBoundingClientRect().width;
      if (!w)
        return;
      const H = p, V = L.clientX;
      let S;
      L.preventDefault(), y.current?.focus();
      const U = L.currentTarget;
      U.setPointerCapture?.(L.pointerId);
      const I1 = ({ clientX: g2, shiftKey: v2 }) => {
        const w2 = V - g2, M1 = O(
          H - (v - m) * (w2 / w),
          m,
          v
        );
        if (v2)
          S = O(
            Math.round(M1 / 100) * 100,
            m,
            v
          );
        else {
          const P1 = a.find(
            (f2) => Math.abs(f2.value - M1) < 100
          )?.value;
          P1 == null ? S = M1 : S = P1;
        }
        i(S);
      }, _1 = () => {
        window.removeEventListener("pointermove", I1), window.removeEventListener("pointerup", _1);
        try {
          U.releasePointerCapture?.(L.pointerId);
        } catch {
        }
      };
      window.addEventListener("pointermove", I1), window.addEventListener("pointerup", _1);
    },
    [m, v, d, i, a, p]
  ), T = R(
    (L) => {
      const w = O(
        f4(p + L, m, r),
        m,
        v
      );
      i(w);
    },
    [v, m, i, r, p]
  ), z = R(
    (L) => {
      if (d)
        return;
      const w = Math.max(r * 10, (v - m) / 10), H = {
        ArrowLeft: -r,
        ArrowDown: -r,
        ArrowRight: r,
        ArrowUp: r,
        PageDown: w,
        PageUp: -w,
        Home: { value: m },
        End: { value: v }
      };
      function V(S) {
        return Object.hasOwn(H, S);
      }
      if (V(L.key)) {
        L.preventDefault();
        const S = H[L.key];
        typeof S == "number" ? T(S) : i(S.value);
      }
    },
    [T, d, v, m, i, r]
  ), B = f(p);
  return /* @__PURE__ */ C(
    "div",
    {
      ...M,
      className: b(Q.root, h),
      ref: _,
      "aria-disabled": d || void 0,
      style: {
        "--Slider2_KnobPosition": `${Z}`
      },
      children: [
        /* @__PURE__ */ e("div", { className: Q.track, children: a.length > 0 && /* @__PURE__ */ e("div", { className: Q.marks, children: a.map((L) => {
          const w = (O(L.value, m, v) - m) / (v - m || 1);
          return /* @__PURE__ */ e(
            "div",
            {
              className: Q.mark,
              style: {
                "--Slider2_MarkPosition": `${w}`
              }
            },
            `mark-at-${L.value}`
          );
        }) }) }),
        /* @__PURE__ */ e("div", { className: Q.progressBar }),
        /* @__PURE__ */ e("div", { className: Q.track, ref: x, children: /* @__PURE__ */ e("div", { className: Q.knobWrap, children: /* @__PURE__ */ e(
          "button",
          {
            ref: y,
            type: "button",
            className: Q.knob,
            disabled: d,
            role: "slider",
            "aria-label": u ? void 0 : "Amount",
            "aria-labelledby": u ? N : void 0,
            "aria-valuemin": m,
            "aria-valuemax": v,
            "aria-valuenow": Math.round(p / r) * r,
            "aria-valuetext": B,
            "aria-disabled": d,
            onKeyDown: z,
            onPointerDown: P
          }
        ) }) }),
        c && /* @__PURE__ */ e("input", { type: "hidden", name: c, value: String(p) })
      ]
    }
  );
}
function p6({
  title: t = "Send support",
  subtitle: n = "Buy a Super Balloon",
  okButtonLabel: o = "Buy and Send",
  onSubmit: r,
  canSubmit: l = !1,
  onInfoButtonClick: i,
  onCloseButtonClick: u,
  buyerName: a,
  buyerAvatar: d,
  currency: c,
  minAmount: s,
  maxAmount: h,
  message: f = "",
  onMessageChange: M,
  amount: m,
  onAmountChange: v
}) {
  const [p, Z] = j(m);
  X(() => {
    Z(m);
  }, [m]);
  const [_, x] = j(f);
  X(() => {
    x(f);
  }, [f]);
  const y = O(p, s, h), N = {
    buyerName: a,
    message: _,
    amount: Math.trunc(y)
  }, P = typeof l == "function" ? l(N) : l, T = K2(c), z = T.minUnitAmount / 10, B = [0.25, 0.5, 0.75].map((L) => L * T.maxUnitAmount).filter((L) => L >= T.minUnitAmount).map((L) => ({ value: L }));
  return /* @__PURE__ */ C(p1, { children: [
    /* @__PURE__ */ e(
      R1,
      {
        title: t,
        subtitle: n,
        utils: /* @__PURE__ */ C("div", { className: D.headerUtils, children: [
          /* @__PURE__ */ e(W, { onClick: i, children: /* @__PURE__ */ e(l2, {}) }),
          /* @__PURE__ */ e(W, { onClick: u, children: /* @__PURE__ */ e(f1, {}) })
        ] })
      }
    ),
    /* @__PURE__ */ C(
      "form",
      {
        onSubmit: (L) => {
          L.preventDefault(), P && r?.(N);
        },
        children: [
          /* @__PURE__ */ e("div", { className: D.contentWrap, children: /* @__PURE__ */ C("div", { className: D.content, children: [
            /* @__PURE__ */ C("div", { className: D.buyer, children: [
              /* @__PURE__ */ e(g1, { className: D.buyerAvatar, children: d ?? /* @__PURE__ */ e(
                v1,
                {
                  hashable: a,
                  size: 35
                }
              ) }),
              /* @__PURE__ */ C("div", { className: D.buyerInfo, children: [
                /* @__PURE__ */ e("div", { className: D.buyerName, children: a }),
                /* @__PURE__ */ e("div", { className: D.amount, children: r1(y, c) })
              ] })
            ] }),
            /* @__PURE__ */ e("div", { className: D.textFieldWrap, children: /* @__PURE__ */ e(
              "input",
              {
                "data-1p-ignore": !0,
                className: D.textField,
                type: "text",
                value: _,
                onChange: (L) => {
                  x(L.target.value), M?.(
                    L.target.value || void 0
                  );
                },
                placeholder: "Send a message (optional)"
              }
            ) }),
            /* @__PURE__ */ e("div", { className: D.artworkWrap, children: /* @__PURE__ */ e("div", { className: D.artworkContainer, children: /* @__PURE__ */ e($1, { boost: y / h }) }) }),
            /* @__PURE__ */ e(
              q0,
              {
                min: s,
                max: h,
                value: p,
                currency: c,
                onChange: (L) => {
                  Z(L), v?.(
                    Math.trunc(
                      O(L, s, h)
                    )
                  );
                }
              }
            ),
            /* @__PURE__ */ e(
              M4,
              {
                className: D.moneySlider,
                min: s,
                max: h,
                value: p,
                step: z,
                marks: B,
                formatValue: (L) => r1(L, c),
                onChange: (L) => {
                  Z(L), v?.(
                    Math.trunc(
                      O(L, s, h)
                    )
                  );
                }
              }
            )
          ] }) }),
          /* @__PURE__ */ e(u2, { children: /* @__PURE__ */ e(W, { type: "submit", children: o }) })
        ]
      }
    )
  ] });
}
const x4 = "RadioCards-module__root__C6jJN", b4 = "RadioCards-module__card__sPK3t", H4 = "RadioCards-module__card-inner__be85I", L4 = "RadioCards-module__input__Q5FTl", Z4 = "RadioCards-module__content__98zto", V4 = "RadioCards-module__title__f2A0e", y4 = "RadioCards-module__subtitle__mrfLX", S4 = "RadioCards-module__tick__9PSlG", N4 = "RadioCards-module__card-selected__PyWrD", k4 = "RadioCards-module__tick-icon__2kftZ", J = {
  root: x4,
  card: b4,
  cardInner: H4,
  input: L4,
  content: Z4,
  title: V4,
  subtitle: y4,
  tick: S4,
  cardSelected: N4,
  tickIcon: k4
};
function g6({
  options: t,
  value: n,
  onChange: o,
  className: r,
  name: l
}) {
  const i = C1(), u = l ?? i;
  return /* @__PURE__ */ e("div", { role: "radiogroup", className: b(J.root, r), children: t.map((a) => {
    const d = `${i}-${a.value}`, c = n === a.value;
    return /* @__PURE__ */ C(
      "label",
      {
        className: b(
          J.card,
          c && J.cardSelected
        ),
        htmlFor: d,
        children: [
          /* @__PURE__ */ C("div", { className: J.cardInner, children: [
            /* @__PURE__ */ e(
              "input",
              {
                id: d,
                type: "radio",
                className: J.input,
                name: u,
                value: a.value,
                checked: c,
                onChange: (s) => o(s.target.value)
              }
            ),
            /* @__PURE__ */ e("div", { className: J.content, children: /* @__PURE__ */ e("div", { className: J.title, children: a.title }) }),
            /* @__PURE__ */ e("div", { className: J.tick, "aria-hidden": !0, children: c && /* @__PURE__ */ e(
              w1,
              {
                className: J.tickIcon,
                size: "x1"
              }
            ) })
          ] }),
          a.subtitle && /* @__PURE__ */ e("div", { className: J.subtitle, children: a.subtitle })
        ]
      },
      a.value
    );
  }) });
}
const R4 = "RecordingIndicator-module__root__nslSu", I4 = "RecordingIndicator-module__transparent__NBX7n", _4 = "RecordingIndicator-module__circle__mD4z5", P4 = "RecordingIndicator-module__icon-container__2-gvW", T4 = "RecordingIndicator-module__icon__I55Vj", z4 = "RecordingIndicator-module__is-open__pFDwT", E4 = "RecordingIndicator-module__active__3tRX3", D4 = "RecordingIndicator-module__error__StqHf", O4 = "RecordingIndicator-module__semi-transparent__uVj0t", j4 = "RecordingIndicator-module__not-recording__s9Sgi", B4 = "RecordingIndicator-module__icon-animation-wrapper__1Y7bq", F4 = "RecordingIndicator-module__content-container__v3VkA", W4 = "RecordingIndicator-module__progress-bar-container__3Mi4g", U4 = "RecordingIndicator-module__status-text__EQNxQ", J4 = "RecordingIndicator-module__button__K4tFP", Y4 = "RecordingIndicator-module__spinner__hMetD", I = {
  root: R4,
  transparent: I4,
  circle: _4,
  iconContainer: P4,
  icon: T4,
  isOpen: z4,
  active: E4,
  error: D4,
  semiTransparent: O4,
  notRecording: j4,
  iconAnimationWrapper: B4,
  contentContainer: F4,
  progressBarContainer: W4,
  statusText: U4,
  button: J4,
  spinner: Y4
}, v6 = ({
  status: t,
  shape: n = "square",
  onButtonClick: o,
  className: r,
  title: l
}) => {
  const [i, u] = j(!1), a = t1(() => {
    switch (t) {
      case "initializing":
        return "Recording is starting";
      case "error":
        return "Error occurred";
      case "stopping":
        return "Stopping the recording";
      case "not_recording":
        return "";
      default:
        return "Recording";
    }
  }, [t]), d = t1(() => {
    switch (t) {
      case "initializing":
        return "Cancel";
      case "error":
        return "Try again";
      default:
        return "Stop";
    }
  }, [t]);
  return X(() => {
    t === "not_recording" && u(!1);
  }, [t]), /* @__PURE__ */ C(
    "div",
    {
      className: b(
        I.root,
        r,
        n === "circle" && !i && I.circle,
        (t === "not_recording" || t === "initializing" || t === "stopping") && n !== "circle" && I.transparent
      ),
      children: [
        /* @__PURE__ */ e(
          "button",
          {
            type: "button",
            className: I.iconContainer,
            onClick: () => {
              if (t === "not_recording") {
                o();
                return;
              }
              u(!i);
            },
            title: l,
            children: /* @__PURE__ */ e("div", { className: I.iconAnimationWrapper, children: /* @__PURE__ */ C(
              "div",
              {
                className: b(
                  I.icon,
                  t === "recording" && I.active,
                  t === "error" && I.error,
                  (t === "not_recording" || t === "initializing" || t === "stopping") && (n === "circle" ? I.semiTransparent : I.transparent),
                  t === "not_recording" && I.notRecording,
                  i && I.isOpen,
                  n === "circle" && I.circle
                ),
                children: [
                  t === "error" && /* @__PURE__ */ e(
                    c2,
                    {
                      fill: "var(--tv-ui-color-6)",
                      size: "x1_25"
                    }
                  ),
                  t === "recording" && /* @__PURE__ */ e(C2, { size: "x1_25" }),
                  t === "not_recording" && /* @__PURE__ */ e(s2, { size: "x1_25" }),
                  (t === "initializing" || t === "stopping") && /* @__PURE__ */ e("div", { className: I.spinner })
                ]
              }
            ) })
          }
        ),
        /* @__PURE__ */ C(
          "div",
          {
            className: b(
              I.contentContainer,
              t === "error" && I.error,
              i && I.isOpen
            ),
            children: [
              /* @__PURE__ */ e("div", { className: I.progressBarContainer, children: /* @__PURE__ */ e("span", { className: I.statusText, children: a }) }),
              t !== "stopping" && /* @__PURE__ */ e(W, { className: I.button, onClick: o, children: d })
            ]
          }
        )
      ]
    }
  );
}, G4 = "SingleRowButtonWithIcon-module__root__svDmA", K4 = "SingleRowButtonWithIcon-module__content__aYPHC", Y1 = {
  root: G4,
  content: K4
}, w6 = ({
  label: t,
  icon: n,
  onClick: o
}) => /* @__PURE__ */ e(W, { className: Y1.root, onClick: o, type: "button", children: /* @__PURE__ */ C(e2, { className: Y1.content, children: [
  /* @__PURE__ */ e("span", { children: t }),
  n
] }) }), A4 = "Slider-module__slider__6YWWR", Q4 = "Slider-module__track__pZ5UE", X4 = "Slider-module__fill__2nQ9H", q4 = "Slider-module__thumb__8WWlW", h1 = {
  slider: A4,
  track: Q4,
  fill: X4,
  thumb: q4
}, $4 = ({
  initialValue: t = 0,
  onChange: n,
  ariaLabel: o = "Slider"
}) => {
  const r = k(null), [l, i] = j(() => Number.isFinite(t) ? O(Math.floor(t), 0, 100) : 0), u = R(
    (s) => {
      const h = r.current;
      if (!h)
        return;
      const f = h.getBoundingClientRect(), M = s - f.left, m = O(M, 0, f.width), v = Math.round(m / f.width * 100);
      i(v), n && n(v);
    },
    [n]
  ), a = (s) => {
    s.currentTarget.setPointerCapture(s.pointerId), u(s.clientX);
  }, d = (s) => {
    s.pressure === 0 && s.buttons === 0 || u(s.clientX);
  }, c = (s) => {
    const h = ["ArrowLeft", "ArrowDown"], f = ["ArrowRight", "ArrowUp"];
    if (h.includes(s.key)) {
      s.preventDefault();
      const M = Math.max(0, l - 1);
      i(M), n && n(M);
      return;
    }
    if (f.includes(s.key)) {
      s.preventDefault();
      const M = Math.min(100, l + 1);
      i(M), n && n(M);
    }
  };
  return /* @__PURE__ */ e(
    "div",
    {
      className: h1.slider,
      style: {
        "--Slider_Percentage": `${l}%`
      },
      children: /* @__PURE__ */ C(
        "div",
        {
          ref: r,
          className: h1.track,
          role: "slider",
          "aria-label": o,
          "aria-valuemin": 0,
          "aria-valuemax": 100,
          "aria-valuenow": l,
          tabIndex: 0,
          onPointerDown: a,
          onPointerMove: d,
          onKeyDown: c,
          children: [
            /* @__PURE__ */ e("div", { className: h1.fill }),
            /* @__PURE__ */ e("div", { className: h1.thumb })
          ]
        }
      )
    }
  );
}, e8 = "SpeakerItem-module__root__-edYk", t8 = "SpeakerItem-module__main__k4HEl", n8 = "SpeakerItem-module__meta__PLD6M", o8 = "SpeakerItem-module__name__AfEHS", r8 = "SpeakerItem-module__description__DK-ST", i8 = "SpeakerItem-module__actions__McNK7", a8 = "SpeakerItem-module__avatarWrap__bZ-0e", $ = {
  root: e8,
  main: t8,
  meta: n8,
  name: o8,
  description: r8,
  actions: i8,
  avatarWrap: a8
};
function f6({
  name: t,
  description: n,
  actions: o,
  className: r
}) {
  return /* @__PURE__ */ C("div", { className: b($.root, r), children: [
    /* @__PURE__ */ C("div", { className: $.main, children: [
      /* @__PURE__ */ e("div", { className: $.avatarWrap, children: /* @__PURE__ */ e(
        "svg",
        {
          width: "25",
          height: "25",
          viewBox: "0 0 25 25",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-label": "User",
          role: "img",
          children: /* @__PURE__ */ e(
            "path",
            {
              d: "M12.2227 24.4453C5.48438 24.4453 0 18.9727 0 12.2227C0 5.48438 5.48438 0 12.2227 0C18.9727 0 24.4453 5.48438 24.4453 12.2227C24.4453 18.9727 18.9727 24.4453 12.2227 24.4453ZM12.2227 11.7891C13.9219 11.8008 15.3047 10.3477 15.3047 8.42578C15.3047 6.63281 13.9219 5.14453 12.2227 5.14453C10.5234 5.14453 9.14062 6.63281 9.14062 8.42578C9.14062 10.3477 10.5234 11.7773 12.2227 11.7891ZM6.94922 18.3047H17.5078C18.082 18.3047 18.3516 17.9062 18.3516 17.4023C18.3516 16.0898 16.4414 12.7266 12.2227 12.7266C8.00391 12.7266 6.09375 16.0898 6.09375 17.4023C6.09375 17.9062 6.375 18.3047 6.94922 18.3047Z",
              fill: "white"
            }
          )
        }
      ) }),
      /* @__PURE__ */ C("div", { className: $.meta, children: [
        /* @__PURE__ */ e("span", { className: $.name, children: t }),
        n && /* @__PURE__ */ e("span", { className: $.description, children: n })
      ] })
    ] }),
    o !== void 0 && /* @__PURE__ */ e("div", { className: $.actions, children: o })
  ] });
}
const l8 = "Spinner-module__root__gtO0N", c8 = {
  root: l8
}, M6 = ({ className: t }) => /* @__PURE__ */ e(
  "div",
  {
    role: "img",
    "aria-label": "Loading",
    className: b(c8.root, t)
  }
), s8 = "SuperBalloonLabel-module__root__kHr0G", C8 = "SuperBalloonLabel-module__amount__R7xaV", d8 = "SuperBalloonLabel-module__detailsContainer__0-GO3", u8 = "SuperBalloonLabel-module__details__JGuqn", h8 = "SuperBalloonLabel-module__content__uXUoT", l1 = {
  root: s8,
  amount: C8,
  detailsContainer: d8,
  details: u8,
  content: h8
};
function x6({
  authorNickname: t,
  amount: n,
  content: o,
  currency: r
}) {
  return /* @__PURE__ */ C("div", { className: l1.root, children: [
    /* @__PURE__ */ e("div", { className: l1.detailsContainer, children: /* @__PURE__ */ C("div", { className: l1.details, children: [
      /* @__PURE__ */ C("strong", { children: [
        "‌",
        t
      ] }),
      o && /* @__PURE__ */ e("div", { className: l1.content, children: o })
    ] }) }),
    /* @__PURE__ */ e("div", { className: l1.amount, children: r1(n, r) })
  ] });
}
function h2(t) {
  const n = R(
    (l) => {
      if (!t)
        return () => {
        };
      const i = new ResizeObserver(l);
      return i.observe(t), () => {
        i.disconnect();
      };
    },
    [t]
  ), o = k(
    void 0
  ), r = R(() => {
    if (!t)
      return;
    const l = [
      t.clientWidth,
      t.clientHeight
    ], i = o.current;
    return (!i || i[0] !== l[0] || i[1] !== l[1]) && (o.current = l), o.current;
  }, [t]);
  return S1(n, r);
}
const m8 = "TiltContainer-module__root__7fwXr", p8 = {
  root: m8
};
function G1({
  className: t,
  angle: n = 0,
  parentSize: o,
  ...r
}) {
  const [l, i] = j(null), u = h2(
    l?.parentElement || void 0
  ), a = o?.[0] ?? u?.[0] ?? 0, d = o?.[1] ?? u?.[1] ?? 0, c = (Math.round(n / 90) % 4 + 4) % 4, s = c % 2 === 1, [h, f] = s ? [d, a] : [a, d], [M, m] = c === 0 ? [0, 0] : c === 1 ? [0, -a] : c === 2 ? [-a, -d] : [-d, 0];
  return /* @__PURE__ */ e(
    "div",
    {
      ...r,
      ref: i,
      className: b(p8.root, t),
      style: {
        "--tv-ui-TiltContainer_Width": `${h}px`,
        "--tv-ui-TiltContainer_Height": `${f}px`,
        "--tv-ui-TiltContainer_OffsetX": `${M}px`,
        "--tv-ui-TiltContainer_OffsetY": `${m}px`,
        "--tv-ui-TiltContainer_Rotation": `${n}deg`
      }
    }
  );
}
const g8 = "Toggle-module__root__awHNC", v8 = "Toggle-module__slider__Xxw1A", w8 = "Toggle-module__option__wk6Yd", f8 = "Toggle-module__input__novJG", M8 = "Toggle-module__button__4mYbK", x8 = "Toggle-module__buttonUnselected__ThWFL", n1 = {
  root: g8,
  slider: v8,
  option: w8,
  input: f8,
  button: M8,
  buttonUnselected: x8
}, b6 = ({ options: t, selected: n, onChange: o }) => {
  const r = C1(), l = Math.max(0, t.indexOf(n));
  return /* @__PURE__ */ C(
    "div",
    {
      className: n1.root,
      style: {
        "--Toggle_Options": String(t.length),
        "--Toggle_SelectedIndex": String(l)
      },
      children: [
        /* @__PURE__ */ e("div", { className: n1.slider }),
        t.map((i) => {
          const u = `${r}-${i}`, a = n === i;
          return /* @__PURE__ */ C("div", { className: n1.option, children: [
            /* @__PURE__ */ e(
              "input",
              {
                className: n1.input,
                type: "radio",
                name: r,
                id: u,
                value: i,
                checked: a,
                onChange: (d) => o(d.target.value)
              }
            ),
            /* @__PURE__ */ e(
              "label",
              {
                className: b(
                  n1.button,
                  !a && n1.buttonUnselected
                ),
                htmlFor: u,
                children: i
              }
            )
          ] }, i);
        })
      ]
    }
  );
}, b8 = "Video-module__root__aeWZo", H8 = "Video-module__cover__lQbPq", L8 = "Video-module__contain__G84Ur", Z8 = "Video-module__mirror__YVP2k", Z1 = {
  root: b8,
  cover: H8,
  contain: L8,
  mirror: Z8
};
function H6({
  className: t,
  fit: n = "cover",
  mirror: o = !1,
  srcObject: r,
  innerRef: l,
  ...i
}) {
  const u = R(
    (a) => {
      a && r !== void 0 && (a.srcObject = r), typeof l == "function" ? l(a) : l !== void 0 && (l.current = a);
    },
    [r, l]
  );
  return /* @__PURE__ */ e(
    "video",
    {
      ...i,
      ref: u,
      className: b(
        Z1.root,
        t,
        Z1[n],
        o && Z1.mirror
      )
    }
  );
}
function K1(t, n, o) {
  if (o === 0)
    return [t, n];
  const r = o * Math.PI / 180, l = Math.abs(Math.sin(r)), i = Math.abs(Math.cos(r)), u = t * i + n * l, a = n * i + t * l;
  return [u, a];
}
function m2(t) {
  const n = R((o) => (screen.orientation.addEventListener("change", o), () => {
    screen.orientation.removeEventListener("change", o);
  }), []);
  return S1(n, t);
}
function V8() {
  const t = R(() => screen.orientation.type, []);
  return m2(t);
}
function y8() {
  const t = R(() => screen.orientation.angle, []);
  return m2(t);
}
function S8({
  uprightVideoHeight: t,
  uprightVideoWidth: n,
  orientToScreen: o
}) {
  const r = n > t ? "landscape" : "portrait", l = y8(), u = V8().includes("portrait") ? "portrait" : "landscape";
  if (o && r !== u)
    switch (l) {
      case 0:
      case 270:
        return 90;
      case 90:
      case 180:
        return -90;
    }
  return 0;
}
const N8 = "VideoContainer-module__root__gqojy", k8 = "VideoContainer-module__tiltContainer__BFtnU", R8 = "VideoContainer-module__center__nYfoP", I8 = "VideoContainer-module__canvasContainer__U-GeJ", _8 = "VideoContainer-module__hudContainer__DCskM", o1 = {
  root: N8,
  tiltContainer: k8,
  center: R8,
  canvasContainer: I8,
  hudContainer: _8
}, p2 = b2({
  videoRotationOffset: 0
}), L6 = () => x2(p2);
function Z6({
  className: t,
  canvas: n,
  hud: o,
  fit: r,
  videoHeight: l,
  videoWidth: i,
  videoRotation: u,
  orientToScreen: a = !1,
  center: d = !1,
  allowUpscale: c = !1
}) {
  const [s, h] = j(null), f = h2(s?.parentElement || void 0), [M, m] = K1(
    i,
    l,
    u
  ), v = S8({
    uprightVideoHeight: m,
    uprightVideoWidth: M,
    orientToScreen: a
  }), p = u + v, [Z, _] = K1(
    M,
    m,
    v
  ), x = k(!1), y = k(p);
  y.current !== p && (x.current = !0, y.current = p);
  let N = 0, P = 0, T = 0;
  if (f) {
    [P, T] = f;
    const L = p % 360 === 90 || p % 360 === 270, w = P < T;
    L === w && (x.current = !1), x.current && L !== w && ([P, T] = [
      T,
      P
    ]), r !== "fill" && (N = (r === "cover" ? Math.max : Math.min)(
      P / Z,
      T / _
    ), r === "contain" && !c && (N = Math.min(1, N)));
  }
  const z = r === "fill" ? { width: P, height: T } : { width: Z * N, height: _ * N }, B = {
    width: Math.min(z.width, P),
    height: Math.min(z.height, T)
  };
  return /* @__PURE__ */ C(
    "div",
    {
      ref: h,
      className: b(o1.root, d && o1.center, t),
      style: {
        "--tv-ui-VideoContainer-width": `${B.width}px`,
        "--tv-ui-VideoContainer-height": `${B.height}px`,
        "--tv-ui-VideoContainer-scaled-width": `${z.width}px`,
        "--tv-ui-VideoContainer-scaled-height": `${z.height}px`
      },
      children: [
        /* @__PURE__ */ e("div", { className: b(o1.tiltContainer, o1.canvasContainer), children: /* @__PURE__ */ e(
          G1,
          {
            angle: p,
            parentSize: [z.width, z.height],
            children: n
          }
        ) }),
        /* @__PURE__ */ e("div", { className: b(o1.tiltContainer, o1.hudContainer), children: /* @__PURE__ */ e(
          G1,
          {
            angle: v,
            parentSize: [B.width, B.height],
            children: /* @__PURE__ */ e(
              p2.Provider,
              {
                value: { videoRotationOffset: v },
                children: o
              }
            )
          }
        ) })
      ]
    }
  );
}
const P8 = "VolumeSlider-module__root__R49hZ", T8 = "VolumeSlider-module__slider-wrapper__IxPa5", A1 = {
  root: P8,
  sliderWrapper: T8
}, V6 = ({
  initialValue: t,
  onChange: n,
  label: o = "Speaker",
  ariaLabel: r = "Speaker"
}) => /* @__PURE__ */ C("div", { className: A1.root, children: [
  /* @__PURE__ */ e("span", { children: o }),
  /* @__PURE__ */ C("div", { className: A1.sliderWrapper, children: [
    /* @__PURE__ */ e(o2, {}),
    /* @__PURE__ */ e(
      $4,
      {
        initialValue: t,
        onChange: n,
        ariaLabel: r
      }
    )
  ] })
] }), Q1 = {
  videoHeight: 0,
  videoWidth: 0
};
function y6(t) {
  const n = R(
    (i) => t ? (t.addEventListener("resize", i), t.addEventListener("loadedmetadata", i), t.addEventListener("emptied", i), queueMicrotask(i), () => {
      t.removeEventListener("resize", i), t.removeEventListener(
        "loadedmetadata",
        i
      ), t.removeEventListener("emptied", i);
    }) : () => {
    },
    [t]
  ), o = k(Q1), r = R(() => {
    const i = t?.videoWidth ?? 0, u = t?.videoHeight ?? 0, a = o.current;
    return (i !== a.videoWidth || u !== a.videoHeight) && (o.current = {
      videoHeight: u,
      videoWidth: i
    }), o.current;
  }, [t]), l = R(() => Q1, []);
  return S1(n, r, l);
}
export {
  K8 as All,
  g1 as Avatar,
  l3 as BlankIcon,
  W8 as BubbleField,
  W as Button,
  c3 as CalendarIcon,
  B5 as CaretIcon,
  v3 as ChatIcon,
  w3 as ChatIconOutline,
  U8 as ChatMessageDisplay,
  w1 as CheckMarkIcon,
  j5 as ClockIcon,
  f1 as CloseIcon,
  c6 as ColumnsContainer,
  W5 as CopyIcon,
  A8 as DeviceSelector,
  X8 as DeviceSettingsButton,
  R5 as DollarSignIcon,
  I5 as DotDotDotIcon,
  _5 as DotDotDotVerticalIcon,
  F5 as DownCaretIcon,
  q8 as DragAndDropList,
  X5 as EditIcon,
  P5 as EmojiIcon,
  T5 as ExclamationMarkIcon,
  g3 as ExternalLinkIcon,
  K5 as EyeIcon,
  s6 as GlassBackground,
  h3 as HeartIcon,
  g as IconWrap,
  v1 as IdenticonCanvas,
  Q5 as InfoIcon,
  t6 as InfoPlate,
  C3 as KnobsIcon,
  U5 as LargeCopyIcon,
  m1 as LargeExclamationMarkIcon,
  i3 as LargeMicrophoneIcon,
  H3 as LayoutIcon,
  A5 as LeftCaretIcon,
  s3 as LinkIcon,
  n6 as ListHeader,
  b1 as LoadingIndicator,
  t3 as MaximizeIcon,
  n3 as MinimizeIcon,
  d6 as MultiSelect,
  r2 as MutedCameraIcon,
  t2 as MutedMicrophoneIcon,
  D5 as MutedSpeakerIcon,
  l2 as OutlinedInfoIcon,
  J8 as OverlayChatTextField,
  Y8 as PaidChatMessageDisplay,
  b3 as PencilIcon,
  m3 as PluginsIcon,
  O5 as PlusIcon,
  d2 as PlusIconPlain,
  e2 as PopupContentContainer,
  u6 as PopupHeader,
  C6 as PopupList,
  M3 as PrivateIcon,
  h6 as ProductCatalogPlate,
  m6 as ProgressBar,
  f3 as PublicIcon,
  p6 as PurchaseCustomizationPlate,
  g6 as RadioCards,
  s2 as RecordOffIcon,
  C2 as RecordOnIcon,
  v6 as RecordingIndicator,
  x3 as RecordingsIcon,
  a3 as ReportIcon,
  a2 as RightCaretIcon,
  B1 as RowsContainer,
  z5 as ScreenIcon,
  e3 as ScreenShareIcon,
  E0 as ScrollableContainer,
  $8 as Select,
  $5 as SettingsIcon,
  J5 as ShareIcon,
  G5 as ShareIconArrow,
  d3 as SidebarIcon,
  w6 as SingleRowButtonWithIcon,
  $4 as Slider,
  M4 as Slider2,
  o3 as SmallCameraIcon,
  r3 as SmallMicrophoneIcon,
  Y5 as SmallShareIcon,
  G8 as SolidEyeIcon,
  f6 as SpeakerItem,
  M6 as Spinner,
  o6 as StreamrLogo,
  a6 as StreamrNewLogo,
  l6 as StreamrNewLogoSolo,
  r6 as StreamrTvLogo,
  i6 as StreamrTvLogoClean,
  $1 as SuperBalloon,
  x6 as SuperBalloonLabel,
  N3 as Switch,
  p3 as SwitchesIcon,
  e6 as TextInput,
  G1 as TiltContainer,
  U0 as TitleAndDescription,
  b6 as Toggle,
  q5 as TrashCanIcon,
  i2 as UnmutedCameraIcon,
  n2 as UnmutedMicrophoneIcon,
  o2 as UnmutedSpeakerIcon,
  u3 as UpArrowIcon,
  H6 as Video,
  Z6 as VideoContainer,
  V6 as VolumeSlider,
  c2 as WarningIcon,
  E5 as WindowIcon,
  F8 as balloonOffsetYEase,
  j8 as balloonOpacityEase,
  B8 as balloonYPositionEase,
  V2 as defaultOpacityEase,
  V1 as easeOutSine,
  Q8 as getDeviceStatusText,
  K1 as rotateSize,
  h2 as useElementSize,
  y6 as useIntrinsicVideoElementSize,
  S8 as useOrientToScreenRotationOffset,
  y8 as useScreenOrientationAngle,
  V8 as useScreenOrientationType,
  L6 as useVideoRotationOffset
};
